import {onCleanup as $fF3HH$onCleanup} from "solid-js";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $0766c85d387a9765$export$83d89fbfd8236492 = "1.0.25";


const $571bce04eb920cd8$export$55fe61489d2c7417 = /*@__PURE__*/ (()=>process.env.STRIP_DEBUG === "true" ? false : process.env.DEBUG === "true" || process.env.NODE_ENV === "development" || process.env.BUILD_TARGET !== "node" && (globalThis?.document?.currentScript?.dataset?.debug === "true" || globalThis?.localStorage?.getItem?.("debug") === "true"))();


const $649f456f663da9fc$var$browser_prefix_styling = "color: #fff;";
let $649f456f663da9fc$var$browser_prefix = "[Depict]";
const $649f456f663da9fc$export$2dd75a6b038dc8cb = (str)=>{
    $649f456f663da9fc$var$browser_prefix = str;
};
function $649f456f663da9fc$var$decorated_log(console_command, ...args) {
    if (0, $571bce04eb920cd8$export$55fe61489d2c7417) console_command(...process.env.BUILD_TARGET === "node" ? [
        new Date().toISOString()
    ] : [
        `%c${$649f456f663da9fc$var$browser_prefix}`,
        $649f456f663da9fc$var$browser_prefix_styling
    ], ...args);
}
function $649f456f663da9fc$export$de56f1198d121036(...args) {
    /* eslint-disable no-console */ $649f456f663da9fc$var$decorated_log(console.log.bind(console), ...args);
}
function $649f456f663da9fc$export$c2363754d4758444(...args) {
    /* eslint-disable no-console */ $649f456f663da9fc$var$decorated_log(console.warn.bind(console), ...args);
}
function $649f456f663da9fc$export$997143d41f6a0c9b(...args) {
    /* eslint-disable no-console */ $649f456f663da9fc$var$decorated_log(console.error.bind(console), ...args);
}


const $f564adbc4675ceaf$export$60d1d0e3cfc8b9ed = {};
function $f564adbc4675ceaf$export$2cefb7e61fcbae00(package_name, version) {
    (0, $649f456f663da9fc$export$de56f1198d121036)("@depict-ai/" + package_name + " version", version);
    $f564adbc4675ceaf$export$60d1d0e3cfc8b9ed[package_name] = version;
}
function $f564adbc4675ceaf$export$fe609f0216e4ebef(url) {
    const got_url_object = url instanceof URL;
    const url_object = got_url_object ? url : new URL(url, location.origin);
    for (const [key, value] of Object.entries($f564adbc4675ceaf$export$60d1d0e3cfc8b9ed))url_object.searchParams.set(key, value);
    return got_url_object ? url_object.href : url_object;
}


// Source: https://stackoverflow.com/a/30106551
/**
 * Encoding UTF8 ⇢ base64
 */ function $5ea3131c5e08d52e$export$a1893782a2a6be0d(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
}
function $5ea3131c5e08d52e$export$a7e53ec3b3fdd030(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
}




/**
 * Class containing state that an IPNS operates on. It's only exported for type info and in case that you want to use it for instanceof checks.
 * subscribers is an array of functions that get called every time push_value is called with a new value AND all previous subscribers are done
 * queue is the queue of values that subscribers gets called with
 * last_processed_value is the last value that the subscribers were called with
 * push_value adds a new value to the queue and triggers the calling of the subscribers if they're done
 * subscriber_done decrements the number of subscribers we are waiting for, if this isn't called call_subscribers will get stuck. It also triggers a new call to call_subscribers
 */ class $ec58be30798d6e95$export$e2c811ae0eb35313 {
    subscribers_ = [];
    waiting_for_update_ = 0;
    queue_ = [];
    has_had_value_ = false;
    push_value_ = (value)=>{
        this.queue_.push(value);
        this.call_subscribers_();
    };
    call_subscribers_ = ()=>{
        // intentionally arrow fn so it doesn't matter what .this is when being called
        if (this.waiting_for_update_ <= 0 && this.queue_.length) {
            // shift value
            const next_value = this.queue_.shift();
            this.last_processed_value_ = next_value;
            this.has_had_value_ ||= true;
            for(let i = 0; i < this.subscribers_.length; i++){
                this.waiting_for_update_++;
                this.subscribers_[i](next_value);
            }
        }
    };
    subscriber_done_ = ()=>{
        this.waiting_for_update_--;
        this.call_subscribers_();
    };
}
function $ec58be30798d6e95$export$3e42f5078e3abfc0(state) {
    const asyncIterable = {
        [Symbol.asyncIterator] () {
            let resolve_value_promise;
            let value_promise;
            let subscribed_fn_is_processing = false;
            const update_promises = ()=>{
                value_promise = new Promise((r)=>resolve_value_promise = r);
            };
            const current_subscribed_fn = (value)=>{
                subscribed_fn_is_processing = true;
                resolve_value_promise({
                    value: value,
                    done: false
                });
            };
            const set_processs_done = ()=>{
                if (subscribed_fn_is_processing) {
                    subscribed_fn_is_processing = false;
                    state.subscriber_done_();
                }
            };
            update_promises();
            state.subscribers_.push(current_subscribed_fn);
            return {
                next () {
                    update_promises(); // do this first
                    set_processs_done(); // will lead to new resolving of promises
                    return value_promise;
                },
                return () {
                    // This will be reached if the consumer called 'break' or 'return' early in the loop.
                    const index = state.subscribers_.indexOf(current_subscribed_fn);
                    if (index >= 0) state.subscribers_.splice(index, 1);
                    set_processs_done(); // this will trigger subscribers to run again so we want to have removed ourselves first
                    return Promise.resolve({
                        done: true
                    }); // typescript goes nuts otherwise lol
                }
            };
        }
    };
    return Object.assign((...values)=>{
        for(let i = 0; i < values.length; i++)state.push_value_(values[i]);
    }, asyncIterable);
}


/**
 * You know how you can write `break` inside of a `for await` loop to exit it? Well, this lets you break the loop from outside. Pass any async iterable that never throws and you will get back a function and a specially proxied async iterable. Whenever you call the function all for await loops iterating the returned iterable will break. Note: This will add some extra ticks because awaiting thenable objects takes more ticks than awaiting promises.
 * @param  async_iterable               The async iterable you want to make exitable
 * @return                                                                 An array containing a function, the exit function, and a wrapped async iterable
 */ function $b8270fcf290bb3af$export$927664b47117acb0(async_iterable) {
    const promise_result_setting_functions = new Map();
    const exit_function = ()=>{
        const exit_iterator_object = {
            done: true,
            value: undefined
        };
        for (const [iterator, on_resolve_or_on_finally] of promise_result_setting_functions){
            if (!on_resolve_or_on_finally) throw new Error("Got no resolve fn");
            on_resolve_or_on_finally(iterator?.["return"]?.() || exit_iterator_object);
        }
        promise_result_setting_functions.clear();
    };
    const modified_async_iterable = {
        [Symbol.asyncIterator]: ()=>{
            const orig_iterator = async_iterable[Symbol.asyncIterator]();
            return new Proxy(orig_iterator, {
                get (target, property) {
                    if (property === "next") return ()=>{
                        const orig_next_result = orig_iterator.next();
                        return {
                            then: (fulfill, reject)=>{
                                promise_result_setting_functions.set(orig_iterator, fulfill);
                                return orig_next_result.then((value)=>{
                                    promise_result_setting_functions.delete(orig_iterator);
                                    return fulfill(value);
                                }, reject);
                            }
                        };
                    };
                    return target[property];
                }
            });
        }
    };
    return [
        exit_function,
        modified_async_iterable
    ];
}


// source: https://fettblog.eu/typescript-assertion-signatures/
function $41dbf27125069265$export$8df876135bad6d96(obj, prop, val) {
    Object.defineProperty(obj, prop, val);
}


const $607fc90221d440a6$var$compat_layer_to_info = /*@__PURE__*/ new WeakMap();
function $607fc90221d440a6$export$e806c6c1615a59ae(async_iterator_should_return_state_on_first_call = true, state_obj = new (0, $ec58be30798d6e95$export$e2c811ae0eb35313)()) {
    // @ts-ignore
    $607fc90221d440a6$var$on_async_iterator_next_called({}); // work around https://github.com/swc-project/swc/issues/5530
    const ai = (0, $ec58be30798d6e95$export$3e42f5078e3abfc0)(state_obj);
    const [exit, exitable] = (0, $b8270fcf290bb3af$export$927664b47117acb0)({
        ...ai
    });
    const obj = Object.assign(exitable, {
        exit: exit
    });
    if (async_iterator_should_return_state_on_first_call) {
        const orig_iterator = {
            [Symbol.asyncIterator]: obj[Symbol.asyncIterator]
        };
        obj[Symbol.asyncIterator] = ()=>{
            let was_exited = false;
            let should_unblock_state_obj_after_next_called = false;
            let stock_return_function;
            const unblock_state_obj = ()=>{
                if (should_unblock_state_obj_after_next_called) {
                    should_unblock_state_obj_after_next_called = false;
                    state_obj.waiting_for_update_--;
                    state_obj.call_subscribers_();
                }
            };
            const async_generator = async function*() {
                if (was_exited) return; // just in case
                if (state_obj.has_had_value_) {
                    state_obj.waiting_for_update_++; // block RawObservableInformation from changing a value while we feed this to our for-await loop, this makes so that values can't be missed if they are pushed as a result by below yield
                    should_unblock_state_obj_after_next_called = true;
                    yield state_obj.last_processed_value_;
                    // if we have resolved with a value before info.last_processed_valuestate should no longer be undefined (unless T is undefined) so we can assert this being non-null
                    if (was_exited) {
                        // only once we're at `yield* exitable_for_async_generator;` exit_async_generator will be able to make the async generator stop and return, we add this check so that it also works before
                        unblock_state_obj();
                        return;
                    }
                }
                yield* $607fc90221d440a6$var$on_async_iterator_next_called(exitable_for_async_generator, unblock_state_obj, (fn)=>stock_return_function = fn);
            };
            const iterator = async_generator();
            const [exit_async_generator, exitable_for_async_generator] = (0, $b8270fcf290bb3af$export$927664b47117acb0)(orig_iterator);
            // we can't use a normal async generator since it can't be "quit" from the outside (by calling .return on the AsyncIterator) while being awaited apparently
            // therefore we make the async iterable that it's (soon) passing control onto exitable by calling .return() (even if a .next() promise is being currently awaited)
            iterator.return = ()=>{
                stock_return_function?.();
                unblock_state_obj();
                exit_async_generator();
                was_exited = true;
                return Promise.resolve({
                    done: true,
                    value: undefined
                });
            };
            return iterator;
        };
    }
    const callable_obj_with_everything = Object.assign(ai, obj);
    (0, $41dbf27125069265$export$8df876135bad6d96)(callable_obj_with_everything, "state", {
        get: ()=>state_obj.last_processed_value_,
        enumerable: true
    });
    (0, $41dbf27125069265$export$8df876135bad6d96)(callable_obj_with_everything, "latest_call_value", {
        get: ()=>state_obj.queue_[state_obj.queue_.length - 1] ?? callable_obj_with_everything.state,
        enumerable: true
    });
    $607fc90221d440a6$var$compat_layer_to_info.set(callable_obj_with_everything, new WeakRef(state_obj));
    return callable_obj_with_everything;
}
function $607fc90221d440a6$var$on_async_iterator_next_called(async_iterable, before_next_return, set_stock_return_function) {
    return new Proxy(async_iterable, {
        get (target, property) {
            return new Proxy(target[property], {
                apply (target, this_arg, arg_list) {
                    const iterator = target.apply(this_arg, arg_list);
                    const { return: return_fn  } = iterator;
                    if (return_fn) set_stock_return_function?.(return_fn);
                    return new Proxy(iterator, {
                        get (inner_target, inner_property) {
                            const value = inner_target[inner_property];
                            if (inner_property === "next") return new Proxy(value, {
                                apply (next_target, next_this_arg, next_arg_list) {
                                    const retval = next_target.apply(next_this_arg, next_arg_list);
                                    before_next_return();
                                    return retval;
                                }
                            });
                            return value;
                        }
                    });
                }
            });
        }
    });
}
function $607fc90221d440a6$export$90740b5bc9c2b3b7(ipns) {
    const internal_state_obj = $607fc90221d440a6$var$compat_layer_to_info.get(ipns)?.deref?.();
    if (!internal_state_obj) throw new Error("Couldn't get state obj");
    return $607fc90221d440a6$export$e806c6c1615a59ae(false, internal_state_obj);
}
function $607fc90221d440a6$export$10c3e52ef388b81b(ipns) {
    const internal_state_obj = $607fc90221d440a6$var$compat_layer_to_info.get(ipns)?.deref?.();
    if (!internal_state_obj) throw new Error("Couldn't get state obj");
    return $607fc90221d440a6$export$e806c6c1615a59ae(true, internal_state_obj);
}





function $7547e32486a3abc0$export$8048b892d651b310(exception, error_for_stack) {
    (0, $649f456f663da9fc$export$de56f1198d121036)(exception);
    if (0, $571bce04eb920cd8$export$55fe61489d2c7417) /* eslint-disable no-console */ console.trace();
    if (process.env.BUILD_TARGET !== "node") {
        const { stack: stack  } = error_for_stack instanceof Error ? error_for_stack : new Error();
        const msg_is_error = exception instanceof Error;
        (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
            if (msg_is_error) scope.setExtra("primary_stack", exception.stack);
            scope.setExtra(msg_is_error ? "secondary_stack" : "stack", stack);
            scope.setLevel("error");
            this.captureMessage(exception);
        });
    }
    return undefined;
}



async function $d0e7629fb3179e02$export$2fc1a072736ae2f6(obj, property, ...sub_objects_to_wait_for) {
    let value;
    if (typeof obj[property] === "undefined") value = await $d0e7629fb3179e02$var$wait_for_variable_in_object(property, obj).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    else value = obj[property];
    if (value && sub_objects_to_wait_for?.length) return $d0e7629fb3179e02$export$2fc1a072736ae2f6(value, ...sub_objects_to_wait_for).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    else return value;
}
async function $d0e7629fb3179e02$var$wait_for_variable_in_object(variable, obj) {
    const start = new Date().getTime();
    (0, $649f456f663da9fc$export$de56f1198d121036)("waiting for definition of variable", variable, "in", obj);
    let var_behind_the_scenes;
    let resolve_variable_definition;
    let was_defined = false;
    const definition_of_var = new Promise((r)=>resolve_variable_definition = r);
    const previous_descriptor = $d0e7629fb3179e02$export$d5062f468a0454f3(obj, variable);
    const get = typeof previous_descriptor?.get == "function" ? previous_descriptor.get : ()=>var_behind_the_scenes;
    const set = typeof previous_descriptor?.set == "function" ? new Proxy(previous_descriptor.set, {
        apply (target, this_arg, arguments_list) {
            if (!was_defined) {
                was_defined = true;
                resolve_variable_definition(arguments_list[0]);
            }
            return target.apply(this_arg, arguments_list);
        }
    }) : (value)=>{
        if (!was_defined) {
            was_defined = true;
            resolve_variable_definition(value);
        }
        return var_behind_the_scenes = value;
    };
    Object.defineProperty(obj, variable, {
        configurable: true,
        enumerable: true,
        get: get,
        set: set
    });
    (0, $649f456f663da9fc$export$de56f1198d121036)("everything's set up, waiting for promise by setter to resolve");
    const result = await definition_of_var;
    (0, $649f456f663da9fc$export$de56f1198d121036)("Promise resolved, ", result, " is here. We waited", new Date().getTime() - start, "ms");
    return result;
}
function $d0e7629fb3179e02$export$d5062f468a0454f3(obj, prop) {
    // https://stackoverflow.com/a/38802602/10659982
    if (obj != null) return Object.hasOwnProperty.call(obj, prop) ? Object.getOwnPropertyDescriptor(obj, prop) : $d0e7629fb3179e02$export$d5062f468a0454f3(Object.getPrototypeOf(obj), prop);
}
function $d0e7629fb3179e02$export$79f910a98828378d(obj, variable, async_iterator_should_return_state_on_first_call) {
    const definition_ipns = (0, $607fc90221d440a6$export$e806c6c1615a59ae)(async_iterator_should_return_state_on_first_call);
    let var_behind_the_scenes = obj[variable];
    definition_ipns(var_behind_the_scenes); // resolve with initial value
    const previous_descriptor = $d0e7629fb3179e02$export$d5062f468a0454f3(obj, variable);
    const get = typeof previous_descriptor?.get == "function" ? previous_descriptor.get : ()=>var_behind_the_scenes;
    const set = typeof previous_descriptor?.set == "function" ? new Proxy(previous_descriptor.set, {
        apply (target, this_arg, arguments_list) {
            definition_ipns(arguments_list[0]);
            return target.apply(this_arg, arguments_list);
        }
    }) : (value)=>{
        definition_ipns(value);
        var_behind_the_scenes = value;
    };
    Object.defineProperty(obj, variable, {
        configurable: true,
        enumerable: true,
        get: get,
        set: set
    });
    return definition_ipns;
}


function $a035d75d336cf506$export$2e2bcd8739ae039(TENANT, more_options, dlog, extra_sentry_url, script_integrity) {
    const sentry_object = {};
    if (process.env.BUILD_TARGET !== "modern" && Proxy.toString().indexOf("[native code]") === -1) {
        // Proxy polyfill needs defined things to work. If any other sentry function is desired to be used, please add it to the array below for ie11 compatibility
        const known_keys = [
            "isOlderThan",
            "bindClient",
            "pushScope",
            "popScope",
            "withScope",
            "getClient",
            "getScope",
            "getStack",
            "getStackTop",
            "captureException",
            "captureMessage",
            "captureEvent",
            "lastEventId",
            "addBreadcrumb",
            "setUser",
            "setTags",
            "setExtras",
            "setTag",
            "setExtra",
            "setContext",
            "configureScope",
            "run",
            "getIntegration",
            "startSpan",
            "startTransaction",
            "traceHeaders",
            "captureSession",
            "endSession",
            "startSession",
            "_sendSessionUpdate",
            "_invokeClient",
            "_callExtensionMethod",
            "_version",
            "_stack",
            "_lastEventId"
        ];
        known_keys.forEach((fn)=>sentry_object[fn] = ()=>{});
    }
    // the sentry "hub" we usually use only has functions - except for "_version", "_stack" and "_lastEventId"
    // for all these functions we will push the arguments to a stack which we go through once sentry has loaded
    // we will return a promise that resolves to the eventual result of the function result
    // meaning a fictional Sentry.returnsauce will return a promise that resolves to "sauce", given that sentry.returnsauce usually returns "sauce"
    // for the things that are not a function we will return a promise resolving to its value once sentry has loaded - sorry lazy loaded sentry users, you'll have to adapt your code to deal with it
    // i don't expect anyone ever having to do that tho because when's the last time you accessed Sentry._stack ???
    const not_functions = [
        "_version",
        "_stack",
        "_lastEventId"
    ];
    const function_backlog = {
    };
    const getter_backlog = [];
    let actual_sentry;
    const sentry = new Proxy(sentry_object, {
        get (target, property) {
            if (property === "then") // browsers do thenable checks by calling .then on any returned object of an awaited function, ignore it (probably not needed because proxy implementation should be robust enough maybe I'll remove it later)
            return;
            let resolve_with_value;
            const value_promise = new Promise((r)=>resolve_with_value = r);
            const property_as_string = property.toString();
            if (property_as_string.includes("Symbol")) // if someone runs String(Sentry) they fail miserably without this check
            return target[property];
            else if (not_functions.includes(property_as_string)) {
                getter_backlog.push([
                    property,
                    resolve_with_value
                ]);
                process_calls();
                return value_promise;
            } else return function(...args) {
                if (!Array.isArray(function_backlog[property])) // this check needs to be like this so that functions of an object - i.e. toString get replaced
                function_backlog[property] = [];
                const stack_for_fn = function_backlog[property];
                stack_for_fn.push({
                    args: args,
                    resolve: resolve_with_value
                });
                process_calls();
                return value_promise;
            };
        }
    });
    return sentry;
    async function process_calls() {
        let sentry;
        /* eslint-disable no-console */ const err = console.log.bind(console); // we can't feed errors from here into sentry - it might create an infinite loop
        dlog ||= process.env.DEBUG == "true" ? err : ()=>{};
        let attempt = 0;
        while(!(sentry = await actual_sentry)){
            // retry if fails for some reason
            if (++attempt > 3) {
                // hopefully this code will never be reached but if loading fails thrice we do nothing and leave everthing how it was
                actual_sentry = false;
                return;
            }
            // we define it as promise so that not multiple functions load it when started at the same time
            actual_sentry = $a035d75d336cf506$var$load_sentry(TENANT, more_options, extra_sentry_url, script_integrity).catch(err);
        }
        // we now for sure have sentry and can start processing the events
        // call functions and resolve results
        for(const fn in function_backlog){
            const backlog_for_fn = function_backlog[fn];
            backlog_for_fn.forEach((backlog_obj, index)=>{
                const { args: args , resolve: resolve  } = backlog_obj;
                try {
                    sentry.run((current_hub)=>{
                        if (typeof current_hub[fn] == "function") {
                            // quick hack to be able to get actual hub to make withScope work
                            const bound_args = args.map((arg)=>{
                                if (typeof arg == "function") return arg.bind(current_hub);
                                else return arg;
                            });
                            resolve(current_hub[fn](...bound_args));
                        } else resolve(undefined);
                    });
                } catch (e) {
                    err(e);
                }
                backlog_for_fn.splice(index, 1);
            });
        }
        getter_backlog.forEach((getter, index)=>{
            const [property, resolve_with_value] = getter;
            resolve_with_value && resolve_with_value(sentry[property]);
            getter_backlog.splice(index, 1);
        });
    }
}
async function $a035d75d336cf506$var$load_sentry(TENANT, more_options = {}, extra_sentry_url, script_integrity) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (script_integrity) {
        script.integrity = script_integrity;
        script.setAttribute("crossorigin", "anonymous");
    }
    script.src = extra_sentry_url || "https://cdn.depict.ai/lazy_sentry/depict-ai.js";
    document.head.appendChild(script);
    const global_var_name = "_depict_ai_sentry";
    const { BrowserClient: BrowserClient , Hub: Hub , defaultIntegrations: defaultIntegrations  } = await (0, $d0e7629fb3179e02$export$2fc1a072736ae2f6)(window, global_var_name);
    delete window[global_var_name];
    if (process.env.SENTRY_SAMPLE_RATE) {
        const sample_rate = parseFloat(process.env.SENTRY_SAMPLE_RATE);
        more_options.sampleRate ??= sample_rate;
    }
    const client = new BrowserClient({
        dsn: "https://1dd6c18a286b40a69dab1cdfe80bad9b@o464891.ingest.sentry.io/5476183",
        release: process.env.sentry_version,
        environment: TENANT,
        // @ts-ignore - can't seem to get the typing to work
        integrations: defaultIntegrations,
        ...more_options
    });
    const hub = new Hub(client);
    hub.bindClient(client); // WHAT ARE YOU DOING SENTRY, WHY IS THIS CALL + the hub.run EQUIRED FOR INTEGRATIONS TO WORK? It's way too hard to figure out
    // related issues:
    // https://github.com/getsentry/sentry-javascript/issues/2622
    // https://github.com/getsentry/sentry-javascript/issues/2541
    // https://github.com/getsentry/sentry-javascript/issues/2541
    return hub;
}



const $eba382943196079c$export$af2e17a20c2ea3c5 = !(process.env.SENTRY === "true" || process.env.DEPICT_ERROR_REPORTING === "true" || process.env.NEXT_PUBLIC_DEPICT_ERROR_REPORTING === "true") && (process.env.SENTRY === "false" || process.env.DEPICT_ERROR_REPORTING === "false" || process.env.NEXT_PUBLIC_DEPICT_ERROR_REPORTING === "false" || (0, $571bce04eb920cd8$export$55fe61489d2c7417)) ? /*@__PURE__*/ $eba382943196079c$var$fakesentry() : /*@__PURE__*/ (0, /*@__PURE__*/$a035d75d336cf506$export$2e2bcd8739ae039)(process.env.TENANT || "unknown", undefined, (0, $649f456f663da9fc$export$de56f1198d121036));
function $eba382943196079c$var$fakesentry() {
    // // source: https://docs.sentry.io/platforms/javascript/troubleshooting/#dealing-with-ad-blockers
    // const handler = {
    //   get: function (_, key) {
    //     return new Proxy(function (cb) {
    //       if (key === "flush" || key === "close") return Promise.resolve();
    //       if (typeof cb === "function") return cb(fake_sentry);
    //       return fake_sentry;
    //     }, handler);
    //   },
    // };
    // var fake_sentry = new Proxy({ captureException: () => {}, captureMessage: () => {}, withScope: () => {} }, handler);
    // the magical proxy stuff has infinite looped for me on rp, old fashioned NOOP functions will have to make do
    const fake_sentry = {
        captureException: ()=>{},
        captureMessage: ()=>{},
        withScope: ()=>{}
    };
    return fake_sentry;
}


function $b04e44fad5ea42c7$export$b3bbfd758f11cfa9(fn, message, severity = "error") {
    return function() {
        const report_w_severity = (e)=>$b04e44fad5ea42c7$export$f18d5b0af29128b7(message ? [
                e,
                message
            ] : e, severity);
        try {
            const return_value = Reflect.apply(fn, this, arguments);
            if (fn?.constructor?.name === "AsyncFunction" || typeof return_value?.then === "function") return return_value.catch(report_w_severity);
            return return_value;
        } catch (e) {
            report_w_severity(e);
        }
    };
}
function $b04e44fad5ea42c7$export$f18d5b0af29128b7(msg, severity, input_data = {}) {
    const has_human_readable_name = Array.isArray(msg);
    if (0, $571bce04eb920cd8$export$55fe61489d2c7417) /* eslint-disable no-console */ console.info(`[sentry-${severity}]:`, ...has_human_readable_name ? msg.reverse() : [
        msg
    ], "\n", input_data);
    (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
        const data_for_sending = {
            stack: has_human_readable_name ? msg[0] : msg,
            ...input_data,
            ...has_human_readable_name ? {
                exception_message: msg[0].message
            } : {}
        };
        for(const key in data_for_sending)scope.setExtra(key, data_for_sending[key]);
        scope.setLevel(severity);
        this.captureException(has_human_readable_name ? new Proxy(msg[0], {
            get (target, property) {
                if (property === "message") return msg[1];
                return target[property];
            }
        }) : msg);
    });
}


/**
 * Gives a random number between min and max (potentially including min and max).
 * @param min The minimum number.
 * @param max The maximum number.
 * @returns a random number
 */ function $d89638655e64f324$export$bb0a9c36cf454ea0(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}




function $511123bb28a7b6f7$export$535946eb77c946dd(the_function) {
    let busy = false;
    let current_promise;
    return (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (...args)=>{
        // Double awaits to make sure that if busy is true, it must also be true two ticks later.
        // This is a fix for when a promise that finalizes immediately is passed.
        // For context: https://javascript.info/microtask-queue
        if (!busy || !(await await busy, busy)) {
            busy = true;
            const to_finally = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(the_function)(...args);
            current_promise = to_finally.finally(()=>busy = false);
        }
        return current_promise;
    });
}
function $511123bb28a7b6f7$export$f241be8e610f5c77(the_function) {
    let busy = false;
    let queued;
    let current_promise;
    const wrapped_fn = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (...args)=>{
        // Double awaits to make sure that if busy is true, it must also be true two ticks later.
        // This is a fix for when a promise that finalizes immediately is passed.
        // For context: https://javascript.info/microtask-queue
        if (!busy || !(await await busy, busy)) {
            busy = true;
            const to_finally = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(the_function)(...args);
            current_promise = to_finally.finally(()=>{
                busy = false;
                if (queued) {
                    const q_val = queued;
                    queued = undefined;
                    wrapped_fn(...q_val);
                }
            });
        } else queued = args;
        return current_promise;
    });
    return wrapped_fn;
}


class $09ff985c7c424fb3$export$32ccf3a614c84258 {
    #values_to_resolve_with = [];
    #internal_resolve;
    #previous_promise = Promise.resolve();
    promise = new Promise((r)=>this.#internal_resolve = r);
    #work_queue_max_once = (0, $511123bb28a7b6f7$export$535946eb77c946dd)(this.#work_queue.bind(this));
    resolve = (value)=>{
        this.#values_to_resolve_with.push(value);
        this.#work_queue_max_once();
    };
    async #work_queue() {
        const vtrw = this.#values_to_resolve_with;
        for(let i = 0; i < vtrw.length; i++){
            await this.#previous_promise;
            const oldresolve = this.#internal_resolve;
            this.#previous_promise = this.promise;
            this.promise = new Promise((r)=>this.#internal_resolve = r);
            oldresolve(vtrw[i]);
        }
        while(vtrw.length)vtrw.pop();
    }
}



const $4ce764ddfee055ef$var$ONE_MINUTE = 60000;
class $4ce764ddfee055ef$export$1b28bc5c68cc4d77 extends EventTarget {
    // WHEN MAKING CHANGES, PLEASE KEEP IN MIND THAT THIS CLASS IS ALSO USED ON THE FRONTEND
    #ws_constructor_options;
    #possible_events = [
        "close",
        "error",
        "message",
        "open"
    ];
    #ons = {};
    #try_again_in_ms = this.#initial_reconnect_delay;
    #fails = 0;
    #max_fails = 10;
    #max_backoff_ms = $4ce764ddfee055ef$var$ONE_MINUTE;
    get #initial_reconnect_delay() {
        return (0, $d89638655e64f324$export$bb0a9c36cf454ea0)(1, 1000);
    }
    #connect() {
        this.current_socket = typeof window === "object" || typeof WebSocket === "function" ? new WebSocket(...this.#ws_constructor_options) : {
            readyState: 0,
            addEventListener: ()=>{},
            send: ()=>{}
        };
        this.#possible_events.forEach((name)=>{
            this.current_socket.addEventListener(name, (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((original_event)=>{
                let fixed_event;
                if (!(original_event instanceof Event)) {
                    // Node - the WS class uses a predecessor of EventTarget and doesn't fire actual events, which we need for dispatchEvent since we're an EventTarget
                    fixed_event = new Event(name);
                    delete original_event["target"];
                    delete original_event["type"];
                    Object.assign(fixed_event, original_event);
                    // @ts-ignore
                    fixed_event.data ||= original_event.data;
                // original_event can either be an event from the 'ws' npm package which is some custom made event for something that extends EventEmitter or an actual Event
                // the event will only have `.data` if it's a message or close event, but wdgaf because setting undefined = undefined is still undefined
                // ts-ignore because it would be very hard to teach typescript the situation
                } else try {
                    // @ts-ignore
                    fixed_event = new original_event.constructor(original_event.type, original_event); // modern browsers - clones an event as well as possible
                } catch (e) {
                    // IE11 and the likes
                    // dlog("Can't reconstruct event", e, original_event, "trying to make a CustomEvent instead");
                    fixed_event = new CustomEvent(original_event.type, original_event);
                    const intermediate = {};
                    for(const key in original_event)intermediate[key] = original_event[key]; // for some reason Object.assign doesn't work because things like MessageEvent.data are not enumarable
                    delete intermediate["target"];
                    Object.assign(fixed_event, intermediate);
                }
                this.dispatchEvent(fixed_event);
            }));
        });
    }
    #setup_dot_on_event_support() {
        // the idea is to make AutoReconnectingWS usable just like a normal WebSocket
        // so that you can do .onmessage or .addEventListener("message", handler) on an AutoReconnectingWS. It basically abstracts away connections that can close and die to one big EventTarget where you don't need to care about the underlying connection
        // this is how we add .onmessage, .onclose, .onopen and .onerror support to our EventTarget (this class)
        for (const ev of this.#possible_events){
            Object.defineProperty(this, "on" + ev, {
                configurable: false,
                enumerable: true,
                get: ()=>this.#ons[ev],
                set: (v)=>this.#ons[ev] = v
            });
            this.addEventListener(ev, (e)=>{
                // e can be MessageEvent | CloseEvent | ErrorEvent I think
                const on_fn = this.#ons[ev];
                if (typeof on_fn === "function") (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(on_fn).call(ev, e);
            });
        }
    }
    async #ensure_connection() {
        while(true){
            const error = await new Promise((resolve)=>{
                this.addEventListener("close", resolve);
                this.addEventListener("error", resolve);
                this.restart_ws = resolve;
            });
            this.removeEventListener("close", this.restart_ws);
            this.removeEventListener("error", this.restart_ws);
            // 4100 means server thinks this is a scraper bot that's ignoring robots.txt
            // @ts-ignore
            if (error?.code === 4100) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("Websocket connection rejected by server, won't reconnect", error);
                return;
            }
            (0, $649f456f663da9fc$export$de56f1198d121036)("Somehow the websocket died", error, "message:", // @ts-ignore
            error?.message, "code:", // @ts-ignore
            error?.code, "reason:", // @ts-ignore
            error?.reason, "reconnecting in", this.#try_again_in_ms);
            await new Promise((r)=>{
                // "race" the timeout and getting an https://developer.mozilla.org/en-US/docs/Web/API/Window/online_event by the browser
                const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((ev)=>{
                    r();
                    (0, $649f456f663da9fc$export$de56f1198d121036)("Retrying due to 'online' event", ev);
                    clearTimeout(timeout);
                });
                window.addEventListener("online", handler, {
                    once: true
                });
                const timeout = setTimeout((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                    this.#try_again_in_ms *= 1.5 + Math.random();
                    if (this.#try_again_in_ms > this.#max_backoff_ms) this.#try_again_in_ms = this.#max_backoff_ms * (1 + Math.random() / 10);
                    r();
                    window.removeEventListener("online", handler);
                }), this.#try_again_in_ms);
            });
            this.#connect();
        }
    }
    increase_fails() {
        this.#fails++;
        if (this.#fails > this.#max_fails) {
            this.restart_ws();
            this.#fails = 0;
        }
    }
    async send(...args) {
        this.current_socket.send(...args);
    }
    constructor(url, protocols, options = {}){
        super();
        this.#ws_constructor_options = [
            url,
            protocols
        ];
        const { max_backoff_ms: max_backoff_ms  } = options;
        if (max_backoff_ms) this.#max_backoff_ms = max_backoff_ms;
        this.#setup_dot_on_event_support();
        this.#connect();
        this.#ensure_connection().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "error"));
        this.addEventListener("open", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            (0, $649f456f663da9fc$export$de56f1198d121036)("Connection opened");
            this.#try_again_in_ms = this.#initial_reconnect_delay; // reset exponential backoff
        }));
    }
}
class $4ce764ddfee055ef$export$1d9c6fddbff3441f extends $4ce764ddfee055ef$export$1b28bc5c68cc4d77 {
    // WHEN MAKING CHANGES, PLEASE KEEP IN MIND THAT THIS CLASS IS ALSO USED ON THE FRONTEND
    #msg_ipns = new (0, $09ff985c7c424fb3$export$32ccf3a614c84258)();
    #initial_retry_ms = 5000;
    #connection_last_active = 0;
    #reconnect_if_dead_for_ms = 20000;
    #messages_queued = 0;
    async #wait_for_open_and_send(msg) {
        while(this.current_socket.readyState !== 1)await new Promise((resolve)=>{
            this.addEventListener("open", resolve, {
                once: true
            });
        });
        this.send(msg);
    }
    #start_reconnection_if_offline_process = (0, $511123bb28a7b6f7$export$535946eb77c946dd)(async ()=>{
        await new Promise((r)=>setTimeout(r, this.#reconnect_if_dead_for_ms + (0, $d89638655e64f324$export$bb0a9c36cf454ea0)(-2, 10)));
        // so if we are trying to send something and there's no activity ("error" which could mean the server is down or message or reconnection) we can safely assume that the internet connection is down. In that case we skip the exponential backoff since we want to know when we're connected again ASAP and just retry every like 20s
        if (this.#messages_queued === 0) return;
        const now = +new Date();
        if (now - this.#connection_last_active > this.#reconnect_if_dead_for_ms) {
            const reason = `No activity in ${this.#reconnect_if_dead_for_ms} ms`;
            (0, $649f456f663da9fc$export$de56f1198d121036)(reason, "reconnecting ws");
            this.restart_ws(reason);
        }
    });
    #periodic_send(msg1) {
        let delay_to_next_send = this.#initial_retry_ms;
        let quit = false;
        this.#messages_queued++;
        (async ()=>{
            while(!quit){
                this.#start_reconnection_if_offline_process();
                await this.#wait_for_open_and_send(msg1);
                const waited = await new Promise((r)=>{
                    const handler = ()=>{
                        r(false);
                        clearTimeout(resend_due_to_lost_message_timeout);
                    };
                    // wait the correct delay
                    const resend_due_to_lost_message_timeout = setTimeout(// this might actually never be needed and be from when Daniel didn't understand WebSockets as well
                    (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                        r(true);
                        this.removeEventListener("open", handler);
                    }), delay_to_next_send);
                    // BUT if we new websocket opens (which means the internet connection works) try again immediately (shortcut the delay)
                    this.addEventListener("open", handler, {
                        once: true
                    });
                });
                if (quit) break;
                delay_to_next_send *= 1.5 + Math.random();
                if (delay_to_next_send > $4ce764ddfee055ef$var$ONE_MINUTE) delay_to_next_send = $4ce764ddfee055ef$var$ONE_MINUTE * (Math.random() + 1);
                if (waited) // don't count the fail as fail if we're trying again due to a reconnect since that could make us kill the connection if many messages suddenly retry which we don't want
                // this is not a proven theory and might be wrong
                this.increase_fails();
            }
            this.#messages_queued--;
        })().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "error"));
        return ()=>quit = true;
    }
    async ensure_sent(payload) {
        const json_payload = JSON.stringify(payload);
        const stop_sending = this.#periodic_send(json_payload);
        while(true){
            const { data: data  } = await this.#msg_ipns.promise;
            let reply;
            try {
                reply = JSON.parse(data);
            } catch (e) {
                const msg = "Got malformed message (ignoring, might cause memory leak)";
                (0, $649f456f663da9fc$export$de56f1198d121036)(msg, data, e);
                (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                    e,
                    msg
                ], "error", {
                    data: data
                });
                continue;
            }
            if (reply.id == payload.id) {
                const { status: status  } = reply;
                if (status == "ack") {
                    stop_sending();
                    continue;
                } else if (status == "not-ok") (0, $649f456f663da9fc$export$c2363754d4758444)("Got reply not-ok reply from server for event!", payload, reply);
                else if (status == "ok") {
                    if (process.env.BUILD_TARGET !== "node") (0, $649f456f663da9fc$export$de56f1198d121036)(`Successfully sent ${payload?.event?.type} (WS)`, payload, reply);
                } else (0, $649f456f663da9fc$export$c2363754d4758444)("Strange reply from WSS server to", payload, ":", reply);
                stop_sending();
                return [
                    reply,
                    data
                ];
            }
        }
    }
    constructor(...params){
        super(...params);
        const option_retry_ms = params[2]?.initial_retry_ms;
        if (option_retry_ms) this.#initial_retry_ms = option_retry_ms;
        this.addEventListener("message", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#msg_ipns.resolve));
        [
            "open",
            "error",
            "message"
        ].forEach((event)=>this.addEventListener(event, (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>this.#connection_last_active = +new Date())));
    }
}


/**
 * Returns a random string
 * @return A random string, containing a-z, 0-9 and occasionally a dot (`.`)
 */ function $460df8550f9d084d$export$656831b7e9c341c3() {
    return (Math.random() * 2e17).toString(36);
}
function $460df8550f9d084d$export$a6db784f019668ba() {
    return "x" + $460df8550f9d084d$export$656831b7e9c341c3().replaceAll(".", "");
}





const $6c2b49f3f564b0d1$export$362abebb4b313340 = process.env.BASE_URL || "https://api.depict.ai";


const $cafa1ff1049985c2$var$c = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9);
const $cafa1ff1049985c2$var$ws_instance = /*@__PURE__*/ $cafa1ff1049985c2$var$c(()=>new (0, $4ce764ddfee055ef$export$1d9c6fddbff3441f)("wss://ws.depict.ai/ws/create-events"))();
const $cafa1ff1049985c2$var$allowed_keys = [
    "tenant",
    "market",
    "type",
    "user_id",
    "session_id",
    "product_id",
    "entity_identifiers",
    "url",
    "entity_price",
    "currency",
    "document_referrer",
    "document_width",
    "attribution_id",
    "recommendation_id",
    "click_location",
    "ab_test_group",
    "variant_ids",
    "dsid",
    "transaction_id",
    "error_type",
    "detail",
    "recommendation_type",
    "search_result_id",
    "product_listing_result_id"
];
const $cafa1ff1049985c2$export$72036d950e1fae95 = /*@__PURE__*/ $cafa1ff1049985c2$var$c((payload)=>{
    if (process.env.DEPICT === "false") return;
    return payload.map((body)=>Object.fromEntries(Object.entries(body).filter(([key, value])=>$cafa1ff1049985c2$var$allowed_keys.includes(key) && value != null)));
});
const $cafa1ff1049985c2$export$aa26019042811d4f = /*@__PURE__*/ $cafa1ff1049985c2$var$c(async (bodies)=>{
    if (process.env.DEPICT === "false") return;
    for(let i = 0; i < bodies.length; i++){
        const id = (0, $460df8550f9d084d$export$656831b7e9c341c3)();
        $cafa1ff1049985c2$var$ws_instance?.ensure_sent({
            id: id,
            event: bodies[i]
        }).catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "error"));
    }
});
const $cafa1ff1049985c2$export$608478473a3304a0 = /*@__PURE__*/ $cafa1ff1049985c2$var$c((payload, use_ws = true)=>{
    if (process.env.DEPICT === "false") return;
    if (use_ws && typeof WebSocket == "function" && typeof $cafa1ff1049985c2$var$ws_instance?.ensure_sent == "function") {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Sending to depict (ws)", payload);
        return $cafa1ff1049985c2$export$aa26019042811d4f(payload);
    }
    const url = (0, $6c2b49f3f564b0d1$export$362abebb4b313340) + "/create-events";
    return $cafa1ff1049985c2$export$cc3b6ddf805f6156(url, payload);
});
const $cafa1ff1049985c2$export$cc3b6ddf805f6156 = /*@__PURE__*/ $cafa1ff1049985c2$var$c((url, payload)=>{
    const payload_json = JSON.stringify(payload);
    let success = false;
    (0, $649f456f663da9fc$export$de56f1198d121036)(`Attempting to send (beacon)`, payload);
    try {
        success = navigator.sendBeacon(url, new Blob([
            payload_json
        ], {
            type: "application/json"
        }));
    } catch (first_error) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Beacon has failed", first_error, "falling back to sending with wrong mime type which might work");
        try {
            success = navigator.sendBeacon(url, new Blob([
                payload_json
            ], {
                type: "application/x-www-form-urlencoded"
            }));
        } catch (e) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Beacon fallback has failed", e, "trying fetch");
            fetch(url, {
                "headers": {
                    "content-type": "application/json"
                },
                "body": payload_json,
                "method": "POST",
                "mode": "cors",
                "credentials": "include"
            }).then((response)=>response.text()).then((text)=>(0, $649f456f663da9fc$export$de56f1198d121036)("Beacon fallback fallback transmission result", text)).catch((fetch_error)=>{
                (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
                    scope.setExtra("stack", new Error().stack);
                    scope.setExtra("url", url);
                    scope.setExtra("payload", payload_json);
                    scope.setExtra("first_error", first_error);
                    scope.setExtra("second_error", e);
                    scope.setTag("feature", "beacon");
                    scope.setTag("approach", "fetch_fallback");
                    scope.setLevel("error");
                    this.captureMessage(fetch_error); // we can now do this - it's depict lazy sentry specific. `this` will refer to the actual hub with breadcrumbs and the scope activated
                });
            });
        }
    }
    return success;
});
const $cafa1ff1049985c2$export$28cacbd9b4306ffc = /*@__PURE__*/ $cafa1ff1049985c2$var$c((payload, use_ws)=>{
    if (process.env.DEPICT === "false") return;
    // filter_depict_payload will only return undefined if process.env.DEPICT === "false"
    return $cafa1ff1049985c2$export$608478473a3304a0($cafa1ff1049985c2$export$72036d950e1fae95(payload), use_ws);
});





let $43683b1103edab15$export$6399bdb2291895e0 = ()=>{
    if (typeof document === "undefined") return "server";
    let id = "";
    let localstorage_error;
    let cookie_error;
    try {
        id = localStorage._dep_id ||= (0, $460df8550f9d084d$export$656831b7e9c341c3)();
    } catch (e) {
        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "warning");
        localstorage_error = e;
    }
    if (!id) {
        try {
            const get_cookie_id = ()=>document.cookie.split(";").reduce((res, c)=>{
                    const [key, val] = c.trim().split("=").map(decodeURIComponent);
                    return Object.assign(res, {
                        [key]: val
                    });
                }, {})._dep_id;
            id = get_cookie_id();
            if (!id) {
                document.cookie = `_dep_id=${(0, $460df8550f9d084d$export$656831b7e9c341c3)()}; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
                id = get_cookie_id();
            }
        } catch (e) {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "warning");
            cookie_error = e;
        }
        (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
            scope.setExtra("id", id);
            scope.setExtra("ls_error", localstorage_error);
            scope.setExtra("cookie_error", cookie_error);
            scope.setLevel("error");
            this.captureMessage(`${id ? "localStorage" : "cookie and localStorage"} failed to hold a value!`);
        });
    }
    if (!id) id = (0, $460df8550f9d084d$export$656831b7e9c341c3)();
    return id;
};
let $43683b1103edab15$export$adc61a405a4cabed = $43683b1103edab15$export$6399bdb2291895e0;
let $43683b1103edab15$export$61e7e1f11e96692f = ()=>undefined;
const $43683b1103edab15$export$336e7ad40bae0652 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((newfn)=>$43683b1103edab15$export$6399bdb2291895e0 = newfn);
const $43683b1103edab15$export$8a96793bf9f87d90 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((newfn)=>$43683b1103edab15$export$adc61a405a4cabed = newfn);
const $43683b1103edab15$export$93ae15b1ae509334 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((newfn)=>$43683b1103edab15$export$61e7e1f11e96692f = newfn);
const $43683b1103edab15$export$8c6f26a5b6921b95 = /*@__PURE__*/ ()=>{
    return {
        session_id: $43683b1103edab15$export$61e7e1f11e96692f(),
        user_id: $43683b1103edab15$export$adc61a405a4cabed(),
        dsid: $43683b1103edab15$export$6399bdb2291895e0(),
        url: document.location.href,
        document_width: window.innerWidth,
        document_referrer: document?.referrer
    };
};
const $43683b1103edab15$export$82badda1f9923310 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((vars, use_ws)=>{
    if (process.env.DEPICT === "false") return;
    const payload = [
        {
            ...$43683b1103edab15$export$8c6f26a5b6921b95(),
            // Compatability mapping - TODO: refactor & remove
            tenant: vars?.TENANT,
            market: vars?.MARKET,
            entity_price: vars?.sale_price,
            ...vars
        }
    ];
    return (0, $cafa1ff1049985c2$export$28cacbd9b4306ffc)(payload, use_ws);
});
const $43683b1103edab15$export$15f8a0cd5a8c0ebb = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((vars)=>{
    if (process.env.DEPICT === "false") return;
    const beacon_retval = $43683b1103edab15$export$82badda1f9923310({
        ...vars,
        type: "click"
    }, false // don't send clicks over websockets because the page might unload
    );
    $43683b1103edab15$export$82badda1f9923310({
        ...vars,
        type: "ws_click"
    }, true // explicitly send `ws-click` over websockets, this is an experiment to test the hypothesis of above - does unloading the page affect if this gets sent?
    );
    return beacon_retval;
});
const $43683b1103edab15$export$9028351cb994757e = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((vars)=>{
    if (process.env.DEPICT === "false") return;
    return $43683b1103edab15$export$82badda1f9923310({
        ...vars,
        type: "add_to_cart"
    });
});
function $43683b1103edab15$export$622991c71a1f52b3(cookie_name) {
    // https://stackoverflow.com/a/25490531
    return document.cookie.match("(^|;)\\s*" + cookie_name + "\\s*=\\s*([^;]+)")?.pop() || "";
}



function $9e268c1aeeb86b34$export$c50e1901e8ed0615(callback) {
    // https://stackoverflow.com/a/61574326
    const channel = new MessageChannel();
    channel.port1.onmessage = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(callback);
    channel.port2.postMessage("");
}



function $f809bc98a1cb5f92$export$6f051469dd676a8b(tenant, market, type) {
    let queued_sending = false;
    const current_displays = new Set();
    return function(display, info) {
        if (!display) return;
        info.set_on_index_change(()=>{
            current_displays.add(display);
            (0, $fF3HH$onCleanup)(()=>current_displays.delete(display));
            if (!queued_sending) {
                queued_sending = true;
                (0, $9e268c1aeeb86b34$export$c50e1901e8ed0615)(()=>{
                    (0, $43683b1103edab15$export$82badda1f9923310)({
                        tenant: tenant,
                        market: market,
                        recommendation_type: type,
                        type: "recommendations_inserted"
                    });
                    queued_sending = false;
                });
            }
        });
    };
}



/**
 * @deprecated this was a stupid idea, it's much easier to read if one just does a quick arrow function that provides the wanted arguments
 */ function $a1c80794e6bf4cc2$export$6e7454c733fa1fb2(fn, ...args) {
    return function(...unimportant_args) {
        return fn.apply(this, [
            ...args,
            ...unimportant_args
        ]);
    };
}




const $66b898e9bfcef532$export$8582cf3716962dc2 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ({ recs: recs , min_recs: min_recs , market: market , type: type , product_id: product_id , tenant: tenant  })=>{
    if (type == "placeholder") return;
    if (typeof product_id === "function") product_id = product_id();
    product_id = await product_id;
    recs = await recs;
    if (typeof recs === "object") {
        if (!Array.isArray(recs)) recs = recs?.displays;
        if (Array.isArray(recs)) {
            if (min_recs == undefined) min_recs = 10;
            if (recs.length < min_recs) {
                (0, $649f456f663da9fc$export$c2363754d4758444)("Displays provided to check_displays is too short, it contains", recs.length, "displays which is less than", min_recs);
                return false;
            } else return true;
        } else (0, $649f456f663da9fc$export$c2363754d4758444)(new Error("neither recs nor recs.displays are an array"));
    } else (0, $649f456f663da9fc$export$c2363754d4758444)(new Error("Non object was passed to check_displays"));
});



const $b55a70757989faf4$var$elem_track_id_map = /*@__PURE__*/ new WeakMap();
function $b55a70757989faf4$export$16d7c76794a38a4(element, event, track_id, func) {
    const set_for_el = $b55a70757989faf4$var$elem_track_id_map.get(element);
    if (!set_for_el?.has?.(track_id)) {
        if (!(set_for_el instanceof Set)) $b55a70757989faf4$var$elem_track_id_map.set(element, new Set([
            track_id
        ]));
        else set_for_el.add(track_id);
        element.addEventListener(event, func, true);
    }
}


// @ts-nocheck

const $39ef887981612535$var$needs_patching = typeof window === "object" ? /*@__PURE__*/ $39ef887981612535$var$check_if_querySelectorAll_needs_patching() : false;
function $39ef887981612535$export$33f937d741e49339(element, selector) {
    if (!(element instanceof Element) || !$39ef887981612535$var$needs_patching || !selector.includes("#") || !selector.includes("+")) // covers most cases, we don't need patching or don't hit the bug
    return element?.querySelectorAll?.(selector);
    const result = [];
    const elements_to_check = [];
    // intentionally not recursive since it's possible to have deeper nested elements than max stack size
    for(let i = element.children.length; i--;)elements_to_check.push(element.children[i]);
    while(elements_to_check.length){
        const child_element = elements_to_check.pop();
        if (child_element.matches(selector)) result.push(child_element);
        for(let i = child_element.children.length; i--;)// kudos to Karl for algorithm help
        elements_to_check.push(child_element.children[i]);
    }
    return result;
}
function $39ef887981612535$var$check_if_querySelectorAll_needs_patching() {
    const id_div = document.createElement("div");
    const element = document.createElement("section");
    const selector = "#a+*";
    id_div.id = "a";
    document.documentElement.append(id_div, element);
    try {
        return element === element.querySelectorAll(selector)[0];
    } finally{
        id_div.remove();
        element.remove();
    }
}




let $8be08add28592faf$var$has_queued_microtask = false;
const $8be08add28592faf$var$queued_callbacks = /*@__PURE__*/ new Map();
const $8be08add28592faf$var$catchified_deduplicate_and_dispatch = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($8be08add28592faf$var$deduplicate_and_dispatch, "error in observer event processing", "error");
function $8be08add28592faf$export$2b08e30396270f0b(callback, ev) {
    $8be08add28592faf$var$queued_callbacks.set(ev, callback);
    if (!$8be08add28592faf$var$has_queued_microtask) queueMicrotask($8be08add28592faf$var$catchified_deduplicate_and_dispatch);
}
function $8be08add28592faf$var$deduplicate_and_dispatch() {
    $8be08add28592faf$var$has_queued_microtask = false;
    const deduplication_map = new Map();
    // event_name -> [selector -> [element -> [function, eoe]]]
    for (const [eoe, callback] of $8be08add28592faf$var$queued_callbacks){
        // put events into structure of maps and sets where they can only exist once
        $8be08add28592faf$var$queued_callbacks.delete(eoe);
        const { event: event_name , selector: selector , element: element  } = eoe;
        if (!event_name) {
            // it's an ifexists callback, doesnt' need deduplication
            $8be08add28592faf$var$call_callback(callback, eoe);
            continue;
        }
        let l2_map = deduplication_map.get(event_name);
        if (!l2_map) {
            l2_map = new Map();
            deduplication_map.set(event_name, l2_map);
        }
        let l3_map = l2_map.get(selector);
        if (!l3_map) {
            l3_map = new Map();
            l2_map.set(selector, l3_map);
        }
        let l4_map = l3_map.get(element);
        if (!l4_map) {
            l4_map = new Map();
            l3_map.set(element, l4_map);
        }
        l4_map.set(callback, eoe);
    }
    // go through structure and call callbacks that are left
    for (const [_event_name, l2_map] of deduplication_map)for (const [_selector, l3_map] of l2_map){
        for (const [_element, callback_set] of l3_map)for (const [callback, eoe] of callback_set)$8be08add28592faf$var$call_callback(callback, eoe);
    }
}
function $8be08add28592faf$var$call_callback(callback, ev) {
    (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(callback, "Error in observer callback")(ev);
}


class $cb50cd7a49e824ee$export$ea60432919e69303 {
    constructor(opts){
        this.element = opts.element_;
        this.selector = opts.selector_;
        this.disconnector = opts.disconnector_;
        opts.mutation_record_ && (this.mutation_record = opts.mutation_record_);
        opts.event_ && (this.event = opts.event_);
    }
}





class $cdca9fea6eb103e5$export$12e07a2a9f87578a {
    #the_mutation_observer;
    #observing = {};
    #self_proxied;
    #observer_callback_running = false;
    #execute_after_callback_ran = [];
    #attribute_attribution_map_object = {};
    #territory;
    #listeners = [
        "exists",
        "creation",
        "removed",
        "change"
    ];
    #weakref_finalization_registry = typeof FinalizationRegistry === "function" && new FinalizationRegistry((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#finalization_registry_callback.bind(this)));
    #verbs = {
        // add "normal" functions for the class that can be used as i.e. observer.ifexists() here
        ifexists: (selector, callback)=>{
            this.#check_observer_args(selector, callback, true);
            if (selector instanceof Node) {
                if (typeof document === "object" && (this.#territory || document.documentElement).contains(selector)) // When the selector is a node the selector and the element are the same, dunno how we could reflect that in the typing though
                this.#call_callbacks([
                    callback
                ], (callback_)=>({
                        element_: selector,
                        selector_: selector,
                        // ts is being stupid here because it doesn't understand that everything in string | Text | Element | Comment that's a node is Text | Element | Comment
                        disconnector_: this.#disconnect_fn({
                            event_: "exists",
                            selector_: new WeakRef(selector),
                            callback_: callback_
                        })
                    }));
                return;
            }
            const our_set = this.#attribute_attribution_map_object[selector] ||= new WeakSet();
            const elements = typeof document === "undefined" ? [] : (0, $39ef887981612535$export$33f937d741e49339)(this.#territory || document, selector);
            for(let i = 0; i < elements.length; i++){
                const element = elements[i];
                our_set.add(element);
                this.#call_callbacks([
                    callback
                ], (callback_)=>({
                        element_: element,
                        selector_: selector,
                        disconnector_: this.#disconnect_fn({
                            event_: "exists",
                            selector_: selector,
                            callback_: callback_
                        })
                    }));
            }
        },
        wait_for_element: (selector, timeout)=>{
            return this.#self_proxied.wait_for_listener("exists", selector, timeout);
        },
        wait_for_listener: (listener, selector, timeout)=>{
            this.#check_observer_args(listener, ()=>{}, false);
            // console.log("waiting for listener", listener, "selector", selector, "timeout", timeout);
            return new Promise((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((r)=>{
                const stop_observing = this.#self_proxied["on" + listener](selector, ({ element: element , disconnector: disconnector  })=>{
                    r(element);
                    disconnector();
                    if (timeout) clearTimeout(obs_timeout);
                });
                if (timeout) var obs_timeout = setTimeout(()=>{
                    stop_observing();
                    r(undefined);
                }, timeout);
            }));
        }
    };
    #kickstart_observer() {
        if (typeof document === "undefined") return;
        this.#the_mutation_observer = new MutationObserver(this.#observer_callback);
        this.#the_mutation_observer.observe(this.#territory || document, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeOldValue: true,
            characterData: true,
            characterDataOldValue: true
        });
    }
    #disconnect_fn({ event_: event_ , selector_: selector_ , callback_: callback_  }) {
        return ()=>{
            const fn = ()=>{
                const observing = this.#observing;
                const selector_to_callback_array_map = observing[event_];
                if (!selector_to_callback_array_map) return;
                const callbacks = selector_to_callback_array_map.get(selector_);
                callbacks?.delete(callback_);
                if (callbacks?.size === 0) selector_to_callback_array_map.delete(selector_);
                if (selector_to_callback_array_map.size === 0) delete observing[event_];
                if (!Object.keys(observing).length) {
                    this.#the_mutation_observer?.disconnect();
                    this.#the_mutation_observer = undefined;
                }
            };
            // If the observer callback is running, we need to queue every function that mutates this.#observing since we can't clone it for performance reasons
            if (this.#observer_callback_running) this.#execute_after_callback_ran.push(fn);
            else fn();
        };
    }
    #observer_callback = (records)=>{
        // this is the function which needs to be as fast as possible because it is called on EVERY mutation in the DOM
        try {
            this.#observer_callback_running = true;
            const steps_to_restore_observing_cache = [];
            try {
                const observing = this.#observing; // Currently observing elements. Please make sure they don't get mutated by anything except this function during the running of this function (use observer_callback_running and #execute_after_callback_ran to check for and schedule your mutations for after the run of this function). We previously cloned these on every run but that's super slow.
                const attribute_attribution_map_object = this.#attribute_attribution_map_object;
                for(let j = 0; j < records.length; j++){
                    const record = records[j];
                    const { addedNodes: addedNodes , removedNodes: removedNodes , target: target  } = record;
                    const events_for_discovery = [];
                    let nodes_to_check;
                    // code for handling a record containing wanted elements in addedNodes or the children of added nodes and attribute changes that make an existing node match a selector, mainly for oncreation and onexists, but it will fire onchange if someone is listening if an attribute change makes an element match a selector
                    if (!addedNodes.length && !removedNodes.length) nodes_to_check = [
                        target
                    ];
                    else {
                        nodes_to_check = addedNodes;
                        if (observing["creation"]) events_for_discovery.push("creation");
                    }
                    if (observing["exists"]) events_for_discovery.push("exists");
                    if (observing["change"]) events_for_discovery.push("change");
                    for(let n = 0; n < events_for_discovery.length; n++){
                        const event = events_for_discovery[n];
                        const event_is_creation_or_exists_with_tree_change = event === "creation" || event === "exists" && addedNodes.length;
                        const selector_map = observing[event];
                        const selectors = [
                            ...selector_map.keys()
                        ]; // we can only iterate over a MapIterator once, so we need to spread it
                        if (event === "change" && (addedNodes.length || removedNodes.length)) {
                            // we check the selectors first because I'm DUMB and already have come so far
                            for(let selectors_i = 0; selectors_i < selectors.length; selectors_i++){
                                const selector = selectors[selectors_i];
                                // @ts-ignore
                                if (target?.matches?.(selector)) {
                                    // we WANT change event and there are children to an element that interests us - act on it
                                    const callbacks = selector_map.get(selector);
                                    this.#call_callbacks(callbacks, (callback)=>({
                                            element_: target,
                                            // it has to be an *Element* since it has
                                            // the selector is a string since the event is change
                                            // @ts-ignore
                                            selector_: selector,
                                            event_: event,
                                            mutation_record_: record,
                                            disconnector_: this.#disconnect_fn({
                                                event_: event,
                                                selector_: selector,
                                                callback_: callback
                                            })
                                        }));
                                    selector_map.delete(selector);
                                    steps_to_restore_observing_cache.push(()=>selector_map.set(selector, callbacks));
                                }
                            }
                            break;
                        }
                        for(let i = 0; i < nodes_to_check.length; i++){
                            const node = nodes_to_check[i];
                            for(let selectors_i = 0; selectors_i < selectors.length; selectors_i++){
                                const selector = selectors[selectors_i];
                                const callbacks = selector_map.get(selector) || new Set();
                                if (typeof selector !== "string") {
                                    // oncreation or onexists with node-selector
                                    if (event_is_creation_or_exists_with_tree_change) {
                                        const derefed_el = selector.deref();
                                        if (!derefed_el) {
                                            selector_map.delete(selector);
                                            continue;
                                        }
                                        if (node === derefed_el || node.contains(derefed_el)) // node is node or node is child of added node
                                        this.#call_callbacks(callbacks, (callback)=>({
                                                element_: derefed_el,
                                                selector_: derefed_el,
                                                event_: event,
                                                mutation_record_: record,
                                                disconnector_: this.#disconnect_fn({
                                                    event_: event,
                                                    selector_: selector,
                                                    callback_: callback
                                                })
                                            }));
                                    }
                                    continue;
                                }
                                // @ts-ignore
                                const matches_now = node?.matches?.(selector);
                                let our_set;
                                if (event == "exists") {
                                    // we want the change event to trigger to any change (exists only if it makes an element match a selector that didn't previously match)
                                    our_set = attribute_attribution_map_object[selector] ||= new WeakSet();
                                    if (record.type === "attributes" && matches_now != null) {
                                        const matched_last = our_set.has(node);
                                        if (matched_last && matches_now) continue;
                                    }
                                    if (matches_now) our_set.add(node);
                                    else our_set.delete(node);
                                }
                                if (matches_now) this.#call_callbacks(callbacks, (callback)=>({
                                        element_: node,
                                        selector_: selector,
                                        event_: event,
                                        mutation_record_: record,
                                        disconnector_: this.#disconnect_fn({
                                            event_: event,
                                            selector_: selector,
                                            callback_: callback
                                        })
                                    }));
                                if ((addedNodes.length || removedNodes.length) && node.hasChildNodes() && // @ts-ignore
                                node.querySelectorAll /* don't act on i.e. textnodes. Doing the check this way is actually faster than both `in` and instanceof */ ) {
                                    const matching_children = (0, $39ef887981612535$export$33f937d741e49339)(node, selector);
                                    for(let m = 0; m < matching_children.length; m++){
                                        // always use for loops because this can't be slow and forEach takes ages
                                        if (event == "exists") our_set.add(matching_children[m]);
                                        this.#call_callbacks(callbacks, (callback)=>({
                                                element_: matching_children[m],
                                                selector_: selector,
                                                event_: event,
                                                mutation_record_: record,
                                                disconnector_: this.#disconnect_fn({
                                                    event_: event,
                                                    selector_: selector,
                                                    callback_: callback
                                                })
                                            }));
                                    }
                                }
                            }
                        }
                    }
                    // code for handling changes to children of an observed element
                    {
                        const event = "change";
                        const selector_map = observing[event];
                        if (selector_map) {
                            let target_el = target;
                            while(target_el = target_el?.parentNode)// @ts-ignore
                            if (target_el?.matches) {
                                for (const selector of selector_map.keys())// selector is string because event is change
                                // @ts-ignore
                                if (target_el.matches?.(selector)) {
                                    const callbacks = selector_map.get(selector);
                                    this.#call_callbacks(callbacks, (callback)=>({
                                            element_: target_el,
                                            // @ts-ignore
                                            selector_: selector,
                                            event_: event,
                                            mutation_record_: record,
                                            disconnector_: this.#disconnect_fn({
                                                event_: event,
                                                selector_: selector,
                                                callback_: callback
                                            })
                                        }));
                                    // Since we now deduplicate
                                    steps_to_restore_observing_cache.push(()=>selector_map.set(selector, callbacks));
                                }
                            }
                        }
                    }
                    // code for observing observed elements disappearing
                    {
                        const event = "removed";
                        const removed_map = observing[event];
                        if (removed_map && removedNodes?.length) {
                            const selectors = [
                                ...removed_map.keys()
                            ];
                            for(let t = 0; t < removedNodes.length; t++)for(let u = 0; u < selectors.length; u++){
                                const selector = selectors[u];
                                const callbacks = removed_map.get(selector) || new Set();
                                const node = removedNodes[t];
                                if (typeof selector === "string") {
                                    const matching_nodes = [];
                                    // @ts-ignore
                                    if (node?.matches?.(selector)) matching_nodes.push(node);
                                    matching_nodes.push(...(0, $39ef887981612535$export$33f937d741e49339)(node, selector) || []);
                                    for(let v = 0; v < matching_nodes.length; v++)this.#call_callbacks(callbacks, (callback)=>({
                                            element_: matching_nodes[v],
                                            selector_: selector,
                                            event_: event,
                                            mutation_record_: record,
                                            disconnector_: this.#disconnect_fn({
                                                event_: "removed",
                                                selector_: selector,
                                                callback_: callback
                                            })
                                        }));
                                } else {
                                    const derefed_el = selector.deref();
                                    if (derefed_el) {
                                        if (node === derefed_el || node.contains(derefed_el)) this.#call_callbacks(callbacks, (callback)=>({
                                                element_: derefed_el,
                                                mutation_record_: record,
                                                selector_: derefed_el,
                                                event_: event,
                                                disconnector_: this.#disconnect_fn({
                                                    event_: event,
                                                    selector_: selector,
                                                    callback_: callback
                                                })
                                            }));
                                    } else // here it's also ok to mutate #observing since the WeakRef is empty
                                    removed_map.delete(selector);
                                }
                            }
                        }
                    }
                }
            // const end = new Date().getTime();
            // console.log("procesed",records.length,"in", end-start, this.#observing);
            } finally{
                // ensure that we don't leave this.#observing in a broken state if we throw
                while(steps_to_restore_observing_cache.length)steps_to_restore_observing_cache.pop()();
                const execute_after_run = this.#execute_after_callback_ran;
                // We need to execute these in order they were added because I'm afraid that things might rely on it
                for(let i = 0; i < execute_after_run.length; i++)try {
                    execute_after_run[i]();
                } catch (e) {
                    (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                        e,
                        "error in observer running queued function"
                    ], "error");
                }
                // Let the garbage collector empty the old array by creating a new one
                this.#execute_after_callback_ran = [];
                this.#observer_callback_running = false;
            }
        } catch (e) {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                e,
                "error in observer"
            ], "error");
        }
    };
    #check_observer_args(selector, callback, allow_nodes) {
        if (!allow_nodes && typeof selector !== "string" || allow_nodes && !(selector instanceof Node) && typeof selector !== "string") throw new Error("no or invalid selector specified");
        if (typeof callback !== "function") throw new Error("no callback specified");
    }
    #add_listener(listener) {
        // called when observer.onsomethinglistener() is called, somethinglistener being something in this.#listeners
        const the_class = this;
        const function_for_listener = (selector, callback)=>{
            if (typeof Node !== "function") // We are probably running on the server where we can't do anything anyway so we might just return
            return;
            if (!listener || !selector || !callback) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("listener, selector or callback is falsey", {
                    listener: listener,
                    selector: selector,
                    callback: callback
                });
                return;
            }
            the_class.#check_observer_args(selector, callback, listener != "change");
            if (the_class.#observer_callback_running) {
                // Can't mutate #observing right now, queue it for when we can
                the_class.#execute_after_callback_ran.push(()=>function_for_listener(selector, callback));
                return;
            }
            const observing = the_class.#observing;
            observing[listener] ||= new Map();
            // create map for each listener, this is because the selectors can be objects for .onremoved, .oncreation and .onexists to take explicit nodes
            const selector_map = observing[listener];
            let disconnector;
            if (listener === "exists") the_class.#verbs.ifexists(selector, callback);
            if (typeof selector === "string") {
                // simple code for string selectors
                let callback_set = selector_map.get(selector);
                if (!callback_set) {
                    callback_set = new Set();
                    selector_map.set(selector, callback_set);
                }
                callback_set.add(callback); // we make this a set since you're not supposed to be able to have the same function as listener twice, like you can't with addEventListener
                disconnector = the_class.#disconnect_fn({
                    event_: listener,
                    selector_: selector,
                    callback_: callback
                });
            } else {
                // for an element "selector" we don't want to keep strong references to the nodes as that would prevent them from being garbage collected
                let callback_set_to_add_to;
                for (const [stored_selector, existing_callback_set] of selector_map){
                    // try finding an existing array of callbacks
                    if (typeof stored_selector === "string") continue;
                    const ref_contents = stored_selector.deref();
                    if (!ref_contents) {
                        // clean up listeners for selectors that have already been GC'd
                        selector_map.delete(stored_selector);
                        continue;
                    }
                    if (ref_contents === selector) {
                        callback_set_to_add_to = existing_callback_set;
                        disconnector = the_class.#disconnect_fn({
                            event_: listener,
                            selector_: stored_selector,
                            callback_: callback
                        });
                        break;
                    }
                }
                if (!callback_set_to_add_to) {
                    callback_set_to_add_to = new Set();
                    const weakref = new WeakRef(selector);
                    the_class.#cleanup_weakref_when_refd_el_gcd(listener, weakref, selector);
                    selector_map.set(weakref, callback_set_to_add_to);
                    disconnector = the_class.#disconnect_fn({
                        event_: listener,
                        selector_: weakref,
                        callback_: callback
                    });
                }
                callback_set_to_add_to.add(callback);
            }
            if (!the_class.#the_mutation_observer) the_class.#kickstart_observer();
            return disconnector;
        };
        return function_for_listener;
    }
    #cleanup_weakref_when_refd_el_gcd(listener1, weakref, element) {
        // we don't want to keep references to elements used as "selectors" in oncreation and onremoved
        if (!this.#weakref_finalization_registry) return;
        this.#weakref_finalization_registry.register(element, [
            listener1,
            weakref
        ]);
    }
    #finalization_registry_callback([listener2, weak_ref]) {
        // element was GCd and the callbacks can never be called, remove them
        const observing = this.#observing;
        observing[listener2]?.get(weak_ref)?.clear(); // just in case something still has a reference to this set and does something with it, clear it
        observing[listener2]?.delete(weak_ref);
        if (observing[listener2]?.size === 0) delete observing[listener2];
        if (Object.keys(observing).length === 0) {
            this.#the_mutation_observer?.disconnect();
            this.#the_mutation_observer = undefined;
        }
    }
    #call_callbacks(callbacks, make_ev_data) {
        for (const callback of callbacks)(0, $8be08add28592faf$export$2b08e30396270f0b)(callback, new (0, $cb50cd7a49e824ee$export$ea60432919e69303)(make_ev_data(callback)));
    }
    #get(target, verb) {
        // @ts-ignore
        const is_listener = target.#listeners.includes(verb.slice(2));
        const is_verb = Object.keys(target.#verbs).includes(verb);
        if (is_verb) return target.#verbs[verb];
        else if (is_listener) return target.#add_listener(verb.slice(2));
        else throw new Error("Property " + verb + " is not valid. Valid listeners: " + target.#listeners.join(", ") + "; valid verbs: " + Object.keys(target.#verbs).join(", "));
    }
    constructor(options = {}){
        if (process.env.BUILD_TARGET !== "modern" && Proxy.toString().indexOf("[native code]") === -1) {
            this.#listeners.forEach((listener)=>this["on" + listener] = ()=>{}); // define listeners, needed for IE11 proxy polyfill
            Object.keys(this.#verbs).forEach((listener)=>this[listener] = ()=>{});
        }
        if (options.territory) this.#territory = options.territory;
        return this.#self_proxied = new Proxy(this, {
            get: this.#get
        });
    }
}




const $0b48ba2f40ce6067$export$b6ae1bc530f4c149 = /*@__PURE__*/ $0b48ba2f40ce6067$var$make_default_observer();
function $0b48ba2f40ce6067$var$make_default_observer() {
    try {
        return new (0, $cdca9fea6eb103e5$export$12e07a2a9f87578a)();
    } catch (error) {
        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            error,
            "error starting ElementObserver"
        ], "error");
    }
}




function $0bdb8dbcf1bc7f34$export$925772df9b4d16e5(url, param, value) {
    const url_object = new URL(url), search_params = new URLSearchParams(url_object.search);
    search_params.set(param, value);
    return url_object.origin + url_object.pathname + "?" + search_params.toString();
}
function $0bdb8dbcf1bc7f34$export$785f04709990c4ec(element, selector) {
    let result = null;
    while(!result && element){
        element = element?.parentNode;
        result = element?.querySelector(selector) || (element?.matches ? element.matches(selector) ? element : null : null);
    }
    return result;
}
function $0bdb8dbcf1bc7f34$export$44951404cb8d0583(html) {
    // need to wrap the HTML into a <body> tag because the browser otherwise automatically puts <style> into head and we can't return it
    return new DOMParser().parseFromString(`<body>${html}</body>`, "text/html")?.body?.childNodes;
}
function $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787(html) {
    return new DOMParser().parseFromString(`<body>${html}</body>`, "text/html")?.body?.firstElementChild;
}
function $0bdb8dbcf1bc7f34$export$d4bd03f19260ef1c(url, also_onchange = false, override_dev_url = "demo.depict.ai", stfu = true, also_in_all_shadow_roots = false) {
    if (process.env.DEBUG === "true" && location.href.includes(override_dev_url)) {
        const relativ_callback = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((event)=>{
            const anchor = event.element;
            if (typeof url === "string") {
                if (anchor.href.includes(url)) {
                    if (!stfu) (0, $649f456f663da9fc$export$de56f1198d121036)("RUNNING RELATIVIFY on", event);
                    anchor.href = anchor.href.replaceAll(url, "/");
                }
            } else if (url.test(anchor.href)) {
                if (!stfu) (0, $649f456f663da9fc$export$de56f1198d121036)("RUNNING RELATIVIFY on", event);
                anchor.href = anchor.href.replace(url, "/");
            }
        });
        const link_sel = "a[href]";
        (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(link_sel, relativ_callback);
        if (also_onchange) (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onchange(link_sel, relativ_callback);
        if (also_in_all_shadow_roots && typeof ShadowRoot == "function") (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists("*", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(({ element: element  })=>{
            if (element?.shadowRoot instanceof ShadowRoot) {
                const local_observer = new (0, $cdca9fea6eb103e5$export$12e07a2a9f87578a)({
                    territory: element.shadowRoot
                });
                local_observer.onexists(link_sel, relativ_callback);
            }
        }));
    }
}
function $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0(elements, selector) {
    const matches = [];
    for (const element of elements){
        if ("querySelectorAll" in element) matches.push(...(0, $39ef887981612535$export$33f937d741e49339)(element, selector));
        if ("matches" in element && element.matches?.(selector)) matches.push(element);
    }
    return matches;
}
function $0bdb8dbcf1bc7f34$export$cfef5d5c9ac09253(price, places_after_comma = 2, decimal_delimiter = ",", thousands_delimiter = String.fromCharCode(160) // Non-breaking space (&nbsp;)
) {
    if (!price && price !== 0) return "";
    if (typeof price === "string") {
        if (!isNaN(price)) {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(new Error("standard_price_format did not expect price as a string"), "warning", {
                price: price
            });
            price = parseFloat(price);
        } else {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(new Error("standard_price_format cannot handle price string"), "error", {
                price: price
            });
            return "";
        }
    }
    if (places_after_comma == "auto") places_after_comma = price % 1 ? 2 : 0;
    const fixed = places_after_comma < 0 ? price.toString().split(".") : price.toFixed(places_after_comma).split("."), [...chars] = fixed[0], reversed = chars.reverse();
    let j, reversed_formatted = [];
    for(let i = 0; i < reversed.length; i++)if (!(i % 3)) j = reversed_formatted.push([
        reversed[i]
    ]) - 1;
    else reversed_formatted[j].push(reversed[i]);
    fixed[0] = reversed_formatted.map((v)=>v.reverse().join("")).reverse().join(thousands_delimiter);
    return fixed.join(decimal_delimiter);
}
function $0bdb8dbcf1bc7f34$export$f124e3ee16e6b45d(bcp47_country_code, number, numberformat_options) {
    const numfmt = window?.Intl?.NumberFormat;
    if (numfmt) return new numfmt(bcp47_country_code, numberformat_options)?.format?.(number);
    return $0bdb8dbcf1bc7f34$export$cfef5d5c9ac09253(number, "auto");
}
function $0bdb8dbcf1bc7f34$export$9590700a594aef08(obj, step1, ...path) {
    if (typeof obj[step1] === "undefined") obj[step1] = {};
    if (path.length) return $0bdb8dbcf1bc7f34$export$9590700a594aef08(obj[step1], ...path);
    else return obj[step1];
}








// https://stackoverflow.com/a/39941616
function $bb3252f70898acd6$var$invert_promise(promise) {
    return new Promise((res, rej)=>promise.then(rej, res));
}
function $bb3252f70898acd6$export$947a20746936143d(promises) {
    return Promise?.any?.(promises) ?? $bb3252f70898acd6$var$invert_promise(Promise.all([
        ...promises
    ].map($bb3252f70898acd6$var$invert_promise)));
}


async function $61b3c9e5f2cf8171$export$836f70a28c317905(product_id) {
    if (typeof BroadcastChannel != "function") return;
    const bc = new BroadcastChannel("right_click_attribution");
    (0, $649f456f663da9fc$export$de56f1198d121036)("Broadcasting", product_id, "to", bc);
    bc.postMessage(product_id);
    bc.close();
}
function $61b3c9e5f2cf8171$export$58c56fe2313fdbe3(elements, display, info, get_event_listener_remover) {
    if (typeof BroadcastChannel != "function") return elements;
    const disconnectors = [];
    const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((e)=>$61b3c9e5f2cf8171$export$8f66c4c7fb96eda2(e, ("variant_index" in display ? display.variant_displays[display.variant_index] : display).product_id));
    const auxclick_handler = (e)=>e.button === 1 && handler(e);
    for(let i = 0; i < elements?.length; i++){
        const element = elements[i];
        element.addEventListener("contextmenu", handler);
        element.addEventListener("auxclick", auxclick_handler); // actual wheel click - some mouses / OS:es also dispatch auxclick on rightclick
        if (get_event_listener_remover) disconnectors.push(()=>{
            element.removeEventListener("contextmenu", handler);
            element.removeEventListener("auxclick", auxclick_handler);
        });
    }
    get_event_listener_remover?.(()=>disconnectors.forEach((disconnector)=>disconnector()));
    return elements;
}
async function $61b3c9e5f2cf8171$export$8f66c4c7fb96eda2(e, product_id) {
    (0, $649f456f663da9fc$export$de56f1198d121036)("Contextmenu was invoked", e);
    const element = e.currentTarget || e.target;
    const bc = new BroadcastChannel("right_click_attribution");
    const got_wanted_event = await (0, $bb3252f70898acd6$export$947a20746936143d)([
        new Promise((resolve)=>{
            bc.addEventListener("message", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((msg)=>{
                const { data: data  } = msg;
                (0, $649f456f663da9fc$export$de56f1198d121036)("Recieved broadcast channel event", data, msg);
                if (data == product_id) resolve(true);
            }));
        }),
        new Promise((r)=>setTimeout(r, 60000, false))
    ]);
    if (got_wanted_event) {
        const click = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
            metaKey: true
        });
        (0, $649f456f663da9fc$export$de56f1198d121036)("Someone broadcasted our product_id! Simulating a click event on the element that was contextmenu'd", element, click);
        element.addEventListener("click", (e)=>(e.preventDefault(), false), {
            once: true
        });
        element.dispatchEvent(click);
    } else (0, $649f456f663da9fc$export$de56f1198d121036)("Our product_id did not get broadcasted, closing channel");
    bc.close();
}







/**
 * Useful for the `thresholds` option of IntersectionObserver - if you want to be notified at a 10% change, call this and set num_steps to 10. Pls see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/thresholds
 * @param  numSteps               How many steps (notifications) there should be between 0 and 100% intersection
 * @return          Stuff to give to IntersectionObserver
 */ function $9ab9ecb74920f343$export$f8ea2e7b15b5d129(numSteps) {
    const thresholds = [];
    for(let i = 1.0; i <= numSteps; i++){
        const ratio = i / numSteps;
        thresholds.push(ratio);
    }
    thresholds.push(0);
    return thresholds;
}


/**
 * Elements currently intersecting with the viewport.
 * If they are intersecting for the `has_to_be_intersecting_for` duration, we count it as an impression, and call the callback.
 */ const $f24c14db771b471d$var$current_intersections = /*@__PURE__*/ new WeakMap();
/**
 *  Currently watched elements by the intersection observer with their respective callback
 * */ const $f24c14db771b471d$var$watched_elements = /*@__PURE__*/ new WeakMap();
const $f24c14db771b471d$var$unwatch_element = (element)=>{
    $f24c14db771b471d$var$intersection_observer?.unobserve(element);
    $f24c14db771b471d$var$watched_elements.delete(element);
    $f24c14db771b471d$var$current_intersections.delete(element);
};
const $f24c14db771b471d$export$4c51576248bcdf31 = (element, callback)=>{
    if ($f24c14db771b471d$var$watched_elements.has(element)) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Not watching", element, "as it's already being watched");
        return ()=>{};
    }
    $f24c14db771b471d$var$intersection_observer?.observe(element);
    /** Calls the given callback and makes sure to stop watching the element  */ const wrapped_callback = (element)=>{
        callback(element);
        $f24c14db771b471d$var$unwatch_element(element);
    };
    $f24c14db771b471d$var$watched_elements.set(element, wrapped_callback);
    const disconnect_observer = (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(element, ()=>{
        // Sometimes it has already rapidly been reinserted. The observer events lag by one tick.
        // For that case, make sure we're really out of the DOM
        if (document.documentElement.contains(element)) return;
        $f24c14db771b471d$var$unwatch_element(element);
    });
    return ()=>{
        disconnect_observer();
        $f24c14db771b471d$var$unwatch_element(element);
    };
};
const $f24c14db771b471d$var$intersection_observer_callback = (entries)=>{
    for (const record of entries){
        const { target: target  } = record;
        const callback = $f24c14db771b471d$var$watched_elements.get(target);
        // Skip the element if it's no longer being watched.
        if (!callback) {
            $f24c14db771b471d$var$intersection_observer?.unobserve(target);
            continue;
        }
        const currently_intersecting = $f24c14db771b471d$var$current_intersections.has(target);
        if (!currently_intersecting && record.intersectionRatio >= (0, $ccf918da074d7243$export$135da44d0ba958bc)[0]) {
            // we're intersecting enough and not already in the process of "measuring"
            const started_intersecting_at_ = +new Date(); // save start time
            // Schedule the callback function to be called after the element has been intersecting for the required duration
            const callback_timeout_ = setTimeout(callback, (0, $ccf918da074d7243$export$ca8321ea61dc2544), target);
            $f24c14db771b471d$var$current_intersections.set(target, {
                started_intersecting_at_: started_intersecting_at_,
                callback_timeout_: callback_timeout_
            });
        } else if (currently_intersecting && record.intersectionRatio < (0, $ccf918da074d7243$export$135da44d0ba958bc)[1]) {
            // we are in the process of "measuring" and went below the threshold
            const { started_intersecting_at_: started_intersecting_at_ , callback_timeout_: callback_timeout_  } = $f24c14db771b471d$var$current_intersections.get(target);
            const time_elapsed = +new Date() - started_intersecting_at_;
            // If we stopped intersecting too early we want to abort our timeout.
            // if we did not we also want to abort the timeout since it's been lagging and just instantly send the event
            // (the browser can delay setTimeout timers)
            clearTimeout(callback_timeout_);
            if (time_elapsed <= (0, $ccf918da074d7243$export$ca8321ea61dc2544)) $f24c14db771b471d$var$current_intersections.delete(target);
            else {
                // we intersected long enough
                (0, $649f456f663da9fc$export$de56f1198d121036)("intersection_observer: setTimeout lagged", time_elapsed, (0, $ccf918da074d7243$export$ca8321ea61dc2544), "ms", target);
                callback(target);
            }
        }
    }
};
/**
 * Global IntersectionObserver used for all impression tracking.
 * It's faster to use one observer for all elements than to create a new one for each element.
 */ const $f24c14db771b471d$var$intersection_observer = typeof window === "object" ? /*@__PURE__*/ new IntersectionObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($f24c14db771b471d$var$intersection_observer_callback), {
    threshold: /*@__PURE__*/ (0, /*@__PURE__*/$9ab9ecb74920f343$export$f8ea2e7b15b5d129)(8)
}) : undefined;






const $405969d60b37fdac$export$d0efd8ed14f5c33 = (items, display, info)=>{
    if (!items?.length) return items;
    const node_array = Array.isArray(items) ? items : [
        ...items
    ]; // if it's a NodeList convert it to an array
    const first_watchable_el = node_array.find((el)=>el instanceof Element);
    if (!first_watchable_el) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Impression tracking: Can't observe", items, display);
        return items;
    }
    if (!info.t) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Impression tracking: No tenant instance, can't track", items, display);
        return items;
    }
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(first_watchable_el, ({ element: element  })=>{
        (0, $f24c14db771b471d$export$4c51576248bcdf31)(element, ()=>{
            const { recommendation_id: recommendation_id , search_result_id: search_result_id , product_listing_result_id: product_listing_result_id , suggestions_result_id: suggestions_result_id  } = display;
            (0, $ccf918da074d7243$export$4205dc6835bc0d9f)({
                ...(0, $43683b1103edab15$export$8c6f26a5b6921b95)(),
                recommendation_type: info.rendering_options.type,
                entity_price: display.sale_price,
                market: info.t.market,
                tenant: info.t.tenant,
                product_id: display.product_id,
                recommendation_id: recommendation_id,
                search_result_id: search_result_id,
                product_listing_result_id: product_listing_result_id,
                suggestions_result_id: suggestions_result_id
            });
        });
    });
    return items;
};






const $21285393646b9849$export$37125ccc5dd98050 = ({ element: element , data: data , wait_for_dom_insertion: wait_for_dom_insertion = true  })=>{
    const disconnectors = [];
    const impression_track = ()=>{
        const disconnector = (0, $f24c14db771b471d$export$4c51576248bcdf31)(element, ()=>{
            (0, $ccf918da074d7243$export$4205dc6835bc0d9f)({
                ...(0, $43683b1103edab15$export$8c6f26a5b6921b95)(),
                ...data
            });
        });
        disconnectors.push(disconnector);
    };
    if (wait_for_dom_insertion) disconnectors.push((0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(element, impression_track));
    else impression_track();
    return ()=>disconnectors.forEach((disconnector)=>disconnector());
};


let $ccf918da074d7243$export$135da44d0ba958bc = [
    0.6,
    0.5
];
const $ccf918da074d7243$export$c543ee4cdb0d0964 = (start, end)=>$ccf918da074d7243$export$135da44d0ba958bc = [
        start,
        end
    ];
const $ccf918da074d7243$export$ca8321ea61dc2544 = 500;
const $ccf918da074d7243$export$4205dc6835bc0d9f = (data)=>{
    data.type = "element_visible"; // Set the type to element_visible as this is optional to pass here.
    (0, $cafa1ff1049985c2$export$28cacbd9b4306ffc)([
        data
    ], true);
};




function $91b2e49f92ed636c$export$82a685f2da2fb027(a_element, product_id, recommendation_id, additional_listener) {
    if (!a_element || // @ts-ignore
    !a_element.depict_tracked || // @ts-ignore
    a_element?.depict_tracked?.recommendation_id != recommendation_id || // @ts-ignore
    a_element?.depict_tracked?.product_id != product_id) {
        const listener = (e)=>{
            localStorage.setItem(`depict_attribution_${product_id}`, recommendation_id);
            if (additional_listener) additional_listener(e, product_id, recommendation_id);
        };
        // @ts-ignore
        if (a_element.depict_tracked) // @ts-ignore
        a_element.removeEventListener("click", a_element.depict_tracked?.listener);
        // @ts-ignore
        a_element.depict_tracked = {
            product_id: product_id,
            recommendation_id: recommendation_id,
            listener: listener
        };
        a_element.addEventListener("click", listener);
        return listener;
    }
}
async function $91b2e49f92ed636c$export$2c34560c3749dc63(button, get_product_id, tracking_fn, unmatching_tracking, event) {
    // @ts-ignore
    if (!button || button.depict_tracked) return;
    button.addEventListener(event ? event : "click", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (e)=>{
        if (!e.isTrusted) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("ignoring event", e, "because it's not user generated");
            return;
        }
        const product_id = await get_product_id(undefined, e);
        if (product_id) {
            const item_name = `depict_attribution_${product_id}`;
            const recommendation_id = localStorage.getItem(item_name);
            if (recommendation_id) {
                localStorage.removeItem(item_name);
                tracking_fn(product_id, recommendation_id, false, e);
            } else if (unmatching_tracking) tracking_fn(product_id, recommendation_id, true, e);
        }
    }));
    // @ts-ignore
    button.depict_tracked = true;
}









const $0d2acf276472ebf7$export$20e9533e68ee72e7 = /*@__PURE__*/ (0, /*@__PURE__*/$607fc90221d440a6$export$e806c6c1615a59ae)(false);
const $0d2acf276472ebf7$export$a9d39e43ae273d26 = /*@__PURE__*/ (0, /*@__PURE__*/$607fc90221d440a6$export$e806c6c1615a59ae)();
const $0d2acf276472ebf7$export$7500cdfd37aafd43 = /*@__PURE__*/ new Set();
let $0d2acf276472ebf7$var$old_url;
const $0d2acf276472ebf7$var$maybe_navigation = (what_happened, args)=>{
    if (typeof location === "undefined") return;
    const new_url = location.href;
    if ($0d2acf276472ebf7$var$old_url !== new_url) {
        $0d2acf276472ebf7$export$a9d39e43ae273d26(new_url);
        if ($0d2acf276472ebf7$var$old_url !== undefined) // don't resolve stateless href change ipns with the initial value - it's not a navigation
        $0d2acf276472ebf7$export$20e9533e68ee72e7(new_url);
        $0d2acf276472ebf7$var$old_url = new_url;
    }
    for (const fn of $0d2acf276472ebf7$export$7500cdfd37aafd43)fn(what_happened, args);
};
$0d2acf276472ebf7$export$baccefee4a395d8f((args, what_happened)=>$0d2acf276472ebf7$var$maybe_navigation(what_happened, args));
$0d2acf276472ebf7$var$maybe_navigation();
globalThis?.window?.addEventListener("popstate", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((e)=>$0d2acf276472ebf7$var$maybe_navigation("popstate", e)));
async function $0d2acf276472ebf7$export$1cd22bab0d2c3b0b(callback) {
    const catchified_callback = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(callback);
    for await (const href of $0d2acf276472ebf7$export$20e9533e68ee72e7){
        catchified_callback(href);
        break;
    }
}
async function $0d2acf276472ebf7$export$baccefee4a395d8f(after_navigation, replace_replaceState = true) {
    if (typeof History === "undefined") return;
    const { prototype: prototype  } = History;
    const instance = history;
    const polyfill_dance = (the_thing)=>{
        const proxy_the_thing = (obj)=>{
            const orig_pushState = obj[the_thing];
            obj[the_thing] = new Proxy(orig_pushState, {
                apply: (target, this_arg, arguments_list)=>{
                    const nav_result = Reflect.apply(target, this_arg, arguments_list);
                    try {
                        after_navigation(arguments_list, the_thing);
                    } catch (e) {
                        (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
                    }
                    return nav_result;
                }
            });
        };
        proxy_the_thing(prototype);
        if (Object.getOwnPropertyNames(instance).includes(the_thing)) // we don't want to just change the instance because that's not the way to do it, but we don't want to not work because someone else did it wrong
        proxy_the_thing(instance);
    };
    polyfill_dance("pushState");
    if (replace_replaceState) polyfill_dance("replaceState");
}


let $aa0140679dc70b7a$var$last_page_pageview_sent_for;
async function $aa0140679dc70b7a$export$eee4c4d924348b05(data) {
    // Send page view to depict if needed
    try {
        const { href: href  } = location;
        if ($aa0140679dc70b7a$var$last_page_pageview_sent_for !== href) {
            $aa0140679dc70b7a$var$last_page_pageview_sent_for = href;
            (0, $43683b1103edab15$export$82badda1f9923310)({
                ...data,
                type: "page_view"
            });
            if (data.product_id) await (0, $61b3c9e5f2cf8171$export$836f70a28c317905)(data.product_id); // this takes care of right click click attribution - broadcasts the URL of the current page
        }
    } catch (error) {
        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            error,
            "Sending page view failed"
        ], "warning");
    }
}
let $aa0140679dc70b7a$var$sending_on_navigation = false;
async function $aa0140679dc70b7a$export$f7cb1bd47199ec38(data) {
    if (!$aa0140679dc70b7a$var$sending_on_navigation) {
        $aa0140679dc70b7a$var$sending_on_navigation = true;
        (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ()=>{
            for await (const _href of (0, $0d2acf276472ebf7$export$a9d39e43ae273d26))$aa0140679dc70b7a$export$eee4c4d924348b05({
                tenant: data.tenant,
                market: data.market,
                product_id: await data.get_product_id(_href)
            });
        })();
    }
}





function $42bbbba8196bd057$export$edfedd0557ca5a2d(ga_tracker, append_to_url) {
    if (!ga_tracker) return;
    // Docs for analytics.js Tasks:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
    const sendHitTask = "sendHitTask";
    const originalSendHitTask = ga_tracker.get(sendHitTask);
    ga_tracker.set(sendHitTask, (model)=>{
        originalSendHitTask(model);
        // console.log('Sent original hit, now sending to depict');
        try {
            const payLoad = model.get("hitPayload");
            const path = (0, $6c2b49f3f564b0d1$export$362abebb4b313340) + "/collect-ga";
            let url = path + "?" + payLoad;
            if (append_to_url) url += append_to_url;
            const n = navigator;
            const sb = "sendBeacon";
            if (n[sb]) // this is actually smaller, I tested
            n[sb](url);
            else {
                const xhttp = new XMLHttpRequest();
                xhttp.open("GET", url);
                xhttp.send();
            }
        } catch (e) {
        // console.log('Could not send beacon to /collect-ga', e);
        }
    });
}
function $42bbbba8196bd057$export$674d8cd8b6868154() {
    // Snippet to load GA async
    const w = window;
    // @ts-ignore
    w.ga ||= function() {
        (w.ga.q ||= []).push(arguments);
    };
    w.ga.l = +new Date();
}


var $155540b3b8aca771$exports = {};

$parcel$export($155540b3b8aca771$exports, "cookiebot_get_consent", () => $155540b3b8aca771$export$fce59460a1699957);
$parcel$export($155540b3b8aca771$exports, "cookiebot_wait_for_consent", () => $155540b3b8aca771$export$56c2e8be65fb14ae);
$parcel$export($155540b3b8aca771$exports, "cookiebot_get_cookie_ipns", () => $155540b3b8aca771$export$8827362e5e938d26);
$parcel$export($155540b3b8aca771$exports, "init_cookiebot_tracking", () => $155540b3b8aca771$export$abec7fd9f0b9cc22);





const $155540b3b8aca771$var$required_consent_level = process.env.DEPICT_TRACKING_CONSENT_LEVEL;
function $155540b3b8aca771$var$consent_from_cookie() {
    const cookie = (0, $43683b1103edab15$export$622991c71a1f52b3)("CookieConsent");
    if (!cookie) return;
    const consent_json = cookie.replace(/%2C/g, ",").replace(/%27/g, "'").replace(/'/g, '"').replace(/([{[,])\s*([\w]+?):/g, '$1"$2":');
    try {
        return JSON.parse(consent_json);
    } catch ({ message: message  }) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Error parsing cookie json", consent_json, message);
        return;
    }
}
let $155540b3b8aca771$var$cookie_ipns;
let $155540b3b8aca771$var$has_consent = $155540b3b8aca771$var$required_consent_level ? $155540b3b8aca771$var$consent_from_cookie()?.[$155540b3b8aca771$var$required_consent_level] || false : true;
const $155540b3b8aca771$export$fce59460a1699957 = ()=>$155540b3b8aca771$var$has_consent;
async function $155540b3b8aca771$export$56c2e8be65fb14ae() {
    for await (const consent_obj of $155540b3b8aca771$export$8827362e5e938d26())return consent_obj[process.env.DEPICT_TRACKING_CONSENT_LEVEL];
    // Impossible
    return false;
}
function $155540b3b8aca771$export$8827362e5e938d26() {
    if ($155540b3b8aca771$var$cookie_ipns) return $155540b3b8aca771$var$cookie_ipns;
    $155540b3b8aca771$var$cookie_ipns = (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    const existing_consent = $155540b3b8aca771$var$consent_from_cookie();
    if (existing_consent) $155540b3b8aca771$var$cookie_ipns(existing_consent);
    const consent_maybe_changed = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
        const { consent: { marketing: marketing , necessary: necessary , preferences: preferences , statistics: statistics  }  } = window.Cookiebot;
        const new_consent_obj = {
            marketing: marketing,
            necessary: necessary,
            preferences: preferences,
            statistics: statistics
        };
        if (!Object.keys(new_consent_obj).every((k)=>$155540b3b8aca771$var$cookie_ipns.latest_call_value?.[k] === new_consent_obj[k])) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Consent changed", new_consent_obj);
            $155540b3b8aca771$var$cookie_ipns(new_consent_obj);
        }
    }, "extracting consent failed");
    (0, $d0e7629fb3179e02$export$2fc1a072736ae2f6)(window, "Cookiebot", "consent").then(consent_maybe_changed);
    [
        "CookiebotOnAccept",
        "CookiebotOnDecline"
    ].forEach((e)=>window.addEventListener(e, consent_maybe_changed, false));
    return $155540b3b8aca771$var$cookie_ipns;
}
const $155540b3b8aca771$export$abec7fd9f0b9cc22 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (anon_id = "anonymous")=>{
    (0, $649f456f663da9fc$export$de56f1198d121036)("Initializing Cookiebot tracking");
    if (!$155540b3b8aca771$var$required_consent_level) return (0, $649f456f663da9fc$export$de56f1198d121036)("No consent level set for Depict tracking. Ignoring consent and tracking everything.");
    const original_get_depict_id = (0, $43683b1103edab15$export$6399bdb2291895e0);
    const original_get_user_id = (0, $43683b1103edab15$export$adc61a405a4cabed);
    (0, $43683b1103edab15$export$336e7ad40bae0652)(()=>$155540b3b8aca771$var$has_consent ? original_get_depict_id() : anon_id);
    (0, $43683b1103edab15$export$8a96793bf9f87d90)(()=>$155540b3b8aca771$var$has_consent ? original_get_user_id() : anon_id);
    for await (const consent_obj of $155540b3b8aca771$export$8827362e5e938d26()){
        // Changing this will change the return value of function given to set_depict_id_fn above
        $155540b3b8aca771$var$has_consent = consent_obj[$155540b3b8aca771$var$required_consent_level];
        if (!$155540b3b8aca771$var$has_consent) (0, $649f456f663da9fc$export$de56f1198d121036)(`dsid/user_id will be set to, "${anon_id}", until Cookiebot has consent for "${$155540b3b8aca771$var$required_consent_level}"`);
        else (0, $649f456f663da9fc$export$de56f1198d121036)(`Cookiebot obtained consent for "${$155540b3b8aca771$var$required_consent_level}", will use true dsid/user_id`);
    }
});






const $5dbacdc6a3feeb15$var$required_consent_level = process.env.DEPICT_TRACKING_CONSENT_LEVEL;
/*
  The Optanon cookie format can vary slightly between integrations. To figure out the key values used for a particular customer,
  visit their web, finish the consent dialog, then run
  new URLSearchParams(document.cookie.match("(^|;)\\s*OptanonConsent\\s*=\\s*([^;]+)")?.pop()).get("groups")
  in the console. You should see something like
  'NECES:1,ANALY:1,PERON:1,MARKE:1'
  Which tells you what the key values for each consent level is. Enter them in the correct order, comma separated, 
  as OPTANON_KEYS in the tenants .env file. For the cookie output above, the .env entry would be
  OPTANON_KEYS="NECES,ANALY,PERON,MARKE"
  If it's not obvious which consent level each key represents, open the consent dialog again and start de-selecting consent options,
  then check the cookie value again.
*/ const $5dbacdc6a3feeb15$var$KEY_ORDER = [
    "necessary",
    "statistics",
    "preferences",
    "marketing"
];
const $5dbacdc6a3feeb15$var$OPTANON_TO_COOKIEBOT = Object.fromEntries((process.env.OPTANON_KEYS || "").split(",").filter((k)=>k).map((k, i)=>[
        k,
        $5dbacdc6a3feeb15$var$KEY_ORDER[i]
    ]));
function $5dbacdc6a3feeb15$var$consent_from_cookie() {
    const cookie = (0, $43683b1103edab15$export$622991c71a1f52b3)("OptanonConsent");
    if (!cookie) return;
    const groups = new URLSearchParams(cookie).get("groups") || "";
    const matches = groups.matchAll(/(\w+):(\d)/g);
    const consent = {};
    for (const match of matches)consent[$5dbacdc6a3feeb15$var$OPTANON_TO_COOKIEBOT[match[1]]] = match[2] == "1";
    return consent;
}
let $5dbacdc6a3feeb15$var$cookie_ipns;
let $5dbacdc6a3feeb15$var$has_consent = $5dbacdc6a3feeb15$var$required_consent_level ? $5dbacdc6a3feeb15$var$consent_from_cookie()?.[$5dbacdc6a3feeb15$var$required_consent_level] || false : true;
const $5dbacdc6a3feeb15$export$1dd9ce50e201eff1 = ()=>$5dbacdc6a3feeb15$var$has_consent;
async function $5dbacdc6a3feeb15$export$7a6d436e0782c6ed() {
    for await (const consent_obj of $5dbacdc6a3feeb15$export$7e4427e80d5fc619())return consent_obj[process.env.DEPICT_TRACKING_CONSENT_LEVEL];
    // Impossible
    return false;
}
function $5dbacdc6a3feeb15$export$7e4427e80d5fc619() {
    if ($5dbacdc6a3feeb15$var$cookie_ipns) return $5dbacdc6a3feeb15$var$cookie_ipns;
    $5dbacdc6a3feeb15$var$cookie_ipns = (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    const existing_consent = $5dbacdc6a3feeb15$var$consent_from_cookie();
    if (existing_consent?.necessary) // If "necessary" isn't set, user hasn't actually given/withold consent yet.
    $5dbacdc6a3feeb15$var$cookie_ipns(existing_consent);
    window.addEventListener("consent.onetrust", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((evt)=>{
        const c = evt;
        // Cast because TS doesn't know about the forEach coming up
        const consent_obj = {};
        Object.keys($5dbacdc6a3feeb15$var$OPTANON_TO_COOKIEBOT).forEach((k)=>{
            consent_obj[$5dbacdc6a3feeb15$var$OPTANON_TO_COOKIEBOT[k]] = c.detail.includes(k);
        });
        if (!consent_obj.necessary) // If "necessary" isn't set, user hasn't actually given/withold consent yet.
        return;
        if (!Object.keys(consent_obj).every((k)=>$5dbacdc6a3feeb15$var$cookie_ipns.latest_call_value?.[k] === consent_obj[k])) $5dbacdc6a3feeb15$var$cookie_ipns(consent_obj);
    }));
    return $5dbacdc6a3feeb15$var$cookie_ipns;
}
const $5dbacdc6a3feeb15$export$f0f6c846d96fdbec = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (anon_id = "anonymous")=>{
    (0, $649f456f663da9fc$export$de56f1198d121036)("Initializing OptAnon tracking");
    if (!$5dbacdc6a3feeb15$var$required_consent_level) return (0, $649f456f663da9fc$export$de56f1198d121036)("No consent level set for Depict tracking. Ignoring consent and tracking everything.");
    const original_get_depict_id = (0, $43683b1103edab15$export$6399bdb2291895e0);
    const original_get_user_id = (0, $43683b1103edab15$export$adc61a405a4cabed);
    (0, $43683b1103edab15$export$336e7ad40bae0652)(()=>$5dbacdc6a3feeb15$var$has_consent ? original_get_depict_id() : anon_id);
    (0, $43683b1103edab15$export$8a96793bf9f87d90)(()=>$5dbacdc6a3feeb15$var$has_consent ? original_get_user_id() : anon_id);
    for await (const consent_obj of $5dbacdc6a3feeb15$export$7e4427e80d5fc619()){
        // Changing this will change the return value of function given to set_depict_id_fn above
        $5dbacdc6a3feeb15$var$has_consent = consent_obj[$5dbacdc6a3feeb15$var$required_consent_level];
        if (!$5dbacdc6a3feeb15$var$has_consent) (0, $649f456f663da9fc$export$de56f1198d121036)(`dsid/user_id will be set to, "${anon_id}", until Optanon has consent for "${$5dbacdc6a3feeb15$var$required_consent_level}"`);
        else (0, $649f456f663da9fc$export$de56f1198d121036)(`Optanon obtained consent for "${$5dbacdc6a3feeb15$var$required_consent_level}", will use true dsid/user_id`);
    }
});




const $c749fe63b72056ef$var$g = typeof globalThis == "object" && globalThis || window;
const $c749fe63b72056ef$export$f3354ec2ce95ebd9 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (GA_ID, strict)=>{
    if (process.env.GTAG === "false") return;
    if (!GA_ID) {
        (0, $649f456f663da9fc$export$c2363754d4758444)("Couldn't load gtag, GA_ID not specified", GA_ID);
        return;
    }
    const required_consent_level = process.env.GTAG_LOADING_CONSENT_LEVEL;
    if (required_consent_level !== undefined) {
        (0, $649f456f663da9fc$export$de56f1198d121036)(`GTag loading waiting for consent level ${required_consent_level}`);
        const ipns = process.env.CONSENT_FRAMEWORK == "optanon" ? (0, $5dbacdc6a3feeb15$export$7e4427e80d5fc619)() : (0, $155540b3b8aca771$export$8827362e5e938d26)();
        for await (const consent_status of ipns){
            const status_for_level = consent_status[required_consent_level];
            if (status_for_level) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("got consent for", required_consent_level, "loading gtag");
                break;
            }
        }
    }
    // delay loading of script because it's huge and slow according to nordiska galleriet
    // @ts-ignore
    const page_hasnt_loaded = $c749fe63b72056ef$var$g?.performance?.getEntriesByType?.("navigation")?.every?.((e)=>e?.loadEventEnd) === false;
    // Source: comment on https://stackoverflow.com/a/53525488
    // don't use readyState, source: personal experience and comment on https://stackoverflow.com/a/28093606
    (0, $649f456f663da9fc$export$de56f1198d121036)("Loading gtag after " + (page_hasnt_loaded ? "pageload and " : "") + "3s" + (strict ? "" : ", but setting up queues already"));
    if (!strict) $c749fe63b72056ef$export$d031e55ccd4c52dc(GA_ID);
    if (page_hasnt_loaded) {
        const load_event = await new Promise((r)=>window.addEventListener("load", r, {
                once: true
            }));
        (0, $649f456f663da9fc$export$de56f1198d121036)("page has loaded", load_event);
    }
    await new Promise((r)=>setTimeout(r, 3000));
    const script = document.createElement("script"), head = document.head;
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
    head.appendChild(script);
    (0, $649f456f663da9fc$export$de56f1198d121036)("Loading gtag now", script);
});
const $c749fe63b72056ef$export$d031e55ccd4c52dc = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((GA_ID)=>{
    if (process.env.GTAG === "false") return;
    $c749fe63b72056ef$var$g.dataLayer ||= [];
    function gtag() {
        $c749fe63b72056ef$var$g.dataLayer.push(arguments);
    }
    $c749fe63b72056ef$var$g.gtag = gtag;
    $c749fe63b72056ef$var$g.gtag("js", new Date());
    $c749fe63b72056ef$var$g.gtag("config", GA_ID, {
        "send_page_view": false
    });
    (0, $649f456f663da9fc$export$de56f1198d121036)("configuring gtag with", GA_ID);
});
const $c749fe63b72056ef$export$7babcd5d4056b2ca = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (raw_displays, get_product_id, more)=>{
    const displays = raw_displays; // gtag tracking is "obsolete" and we don't expect any customers using something else than LegacyDisplay to use it
    if (process.env.GTAG === "false") return;
    if (process.env.GTAG_VIEW === "false") return;
    if (process.env.GTAG_EVENT_CONSENT_LEVEL !== undefined && !await $c749fe63b72056ef$var$can_send_gtag_events(displays, get_product_id, more)) return;
    if (typeof $c749fe63b72056ef$var$g.gtag == "function") {
        const make_item = (display, index, id)=>({
                id: id,
                "list_name": "depict",
                "list_position": display?.index || index + 1,
                ...typeof more === "function" ? more(display) : more
            });
        const gtag_items = [
            // spread works around safari 11 bug where Array returned by Promise.all is not an instance of the global Array
            // https://sentry.io/organizations/depictai-0o/issues/2794688692/?project=5476183
            ...await Promise.all(displays.map(async (display, index)=>display.ga_product_ids ? display.ga_product_ids.map((id)=>make_item(display, index, id)) : make_item(display, index, display.ga_product_id || display.product_id || await get_product_id(display.page_url) || await get_product_id(display) // the last statement is this row allows for special product_id getter functions that not only use the page_url. They need to check the typeof their argument tho and ignore the first calls
                )))
        ].flat();
        const max_products_per_request = 100;
        for(let i = 0; i < gtag_items.length; i += max_products_per_request){
            const gtag_args = [
                "event",
                "view_item_list",
                {
                    "items": gtag_items.slice(i, i + max_products_per_request)
                }
            ];
            (0, $649f456f663da9fc$export$de56f1198d121036)("Sending product view to gtag", gtag_args);
            $c749fe63b72056ef$var$g.gtag(...gtag_args);
        }
    } else (0, $649f456f663da9fc$export$c2363754d4758444)("not sending gtag tracking as there is no gtag");
});
const $c749fe63b72056ef$export$f522672c9379e339 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (product_id, index, more)=>{
    if (process.env.GTAG === "false") return;
    if (process.env.GTAG_EVENT_CONSENT_LEVEL !== undefined && !await $c749fe63b72056ef$var$can_send_gtag_events(product_id, index, more)) return;
    if (typeof $c749fe63b72056ef$var$g.gtag == "function") {
        const gtag_args = [
            "event",
            "select_content",
            {
                "content_type": "product",
                "items": [
                    {
                        "id": product_id,
                        "list_name": "depict",
                        "list_position": index + 1,
                        ...more
                    }
                ]
            }
        ];
        (0, $649f456f663da9fc$export$de56f1198d121036)("calling gtag with arguments", gtag_args);
        return $c749fe63b72056ef$var$g.gtag(...gtag_args);
    } else (0, $649f456f663da9fc$export$c2363754d4758444)("not sending gtag tracking as there is no gtag");
});
const $c749fe63b72056ef$export$f75172d2e289cd02 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((action)=>{
    if (process.env.GA === "false") return;
    if (typeof $c749fe63b72056ef$var$g.ga != "function") {
        (0, $649f456f663da9fc$export$c2363754d4758444)("Not sending to ga as there is no ga");
        return;
    }
    (0, $649f456f663da9fc$export$de56f1198d121036)("sending", action, "to GA");
    return $c749fe63b72056ef$var$g.ga("depict.send", {
        hitType: "event",
        eventCategory: "Depict",
        eventAction: action,
        eventLabel: "rec-bar-tracking",
        nonInteraction: 1
    });
});
const $c749fe63b72056ef$export$ac7296527cb52311 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((GAID)=>{
    if (process.env.GA === "false") return;
    if (!GAID) {
        (0, $649f456f663da9fc$export$c2363754d4758444)(new Error("No GAID specified"));
        return;
    }
    if (typeof $c749fe63b72056ef$var$g.ga != "function") {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Creating GA queue");
        (0, $42bbbba8196bd057$export$674d8cd8b6868154)();
    }
    (0, $649f456f663da9fc$export$de56f1198d121036)("Creating ga with GA-ID", GAID);
    $c749fe63b72056ef$var$g.ga("create", GAID, "auto", "depict");
    $c749fe63b72056ef$export$f3354ec2ce95ebd9(GAID, false);
});
const $c749fe63b72056ef$export$127751e82111fcf = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>$c749fe63b72056ef$export$f75172d2e289cd02("rec_bar_click"));
const $c749fe63b72056ef$export$bf205937e5e012cb = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>$c749fe63b72056ef$export$f75172d2e289cd02("add_to_cart_after_rec_bar_click"));
async function $c749fe63b72056ef$var$can_send_gtag_events(...stuff_to_log) {
    const required_consent_level = process.env.GTAG_LOADING_CONSENT_LEVEL;
    if (required_consent_level !== undefined) return true; // just in case
    const ipns = process.env.CONSENT_FRAMEWORK == "optanon" ? (0, $5dbacdc6a3feeb15$export$7e4427e80d5fc619)() : (0, $155540b3b8aca771$export$8827362e5e938d26)();
    for await (const consent_obj of ipns){
        const can_send = consent_obj[required_consent_level];
        if (!can_send) (0, $649f456f663da9fc$export$de56f1198d121036)("Got no consent for", required_consent_level, "not sending gtag event for", ...stuff_to_log);
        return can_send;
    }
}













let $0a581f1dfa083522$var$existing_style_tag;
let $0a581f1dfa083522$var$reactions_in_last_s = 0;
const $0a581f1dfa083522$export$59ba1eb2c083f0cd = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (css)=>{
    const style_tag = await ($0a581f1dfa083522$var$existing_style_tag ||= (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element("head").then((head)=>{
        const tag = document.createElement("style");
        (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(// reinsertion for next.js's "portable" <head>
        tag, (eoe)=>{
            if (document.head.contains(tag)) // just make sure to not freak out if it's already been added again
            return;
            if ($0a581f1dfa083522$var$reactions_in_last_s >= 10) {
                (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(new Error("Someone removed our styling but insists on it (10 removals in previous second). Giving up \uD83D\uDE2B"), "error");
                return;
            }
            (0, $649f456f663da9fc$export$de56f1198d121036)("Someone removed our styling \uD83D\uDE24, reinserting", eoe);
            $0a581f1dfa083522$var$reactions_in_last_s++;
            setTimeout(()=>$0a581f1dfa083522$var$reactions_in_last_s--, 1000);
            document.head.append(tag); // we're sure that head exists now since we inserted it there previously
        });
        (0, $649f456f663da9fc$export$de56f1198d121036)("inserting", tag, "into", head);
        return head.appendChild(tag);
    }));
    style_tag.append(css);
});
const $0a581f1dfa083522$export$a96c18473f2af463 = (tenant, selector, validator)=>{
    return (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(selector, ({ element: element  })=>(0, $91b2e49f92ed636c$export$2c34560c3749dc63)(element, tenant.get_product_id, (p_id, r_id, was_unmatching, event)=>{
            if (typeof validator === "function" && !validator(event)) return;
            if (!was_unmatching) (0, $c749fe63b72056ef$export$bf205937e5e012cb)();
            (0, $43683b1103edab15$export$9028351cb994757e)({
                ...tenant,
                product_id: p_id,
                ...was_unmatching ? {
                    attribution_id: "recommendation"
                } : {
                    recommendation_id: r_id
                }
            });
        }, true));
};
const $0a581f1dfa083522$export$a4f97b27a0592e6c = (url)=>(url ? new URL(url, window.location.origin) : window.location).pathname.split("/").filter((a)=>a).pop()?.replace(/\.html?$/i, "") || "";
const $0a581f1dfa083522$export$692b606677218a16 = (callback)=>{
    if (document.depictwashere) {
        if (process.env.BUILD_TARGET === "dev") {
            (0, $649f456f663da9fc$export$de56f1198d121036)("HMR tried to rerun us, reloading page");
            /* eslint-disable no-self-assign */ location.href = location.href;
        }
        (0, $649f456f663da9fc$export$de56f1198d121036)("Script has already ran", document.currentScript, "is exiting");
        return;
    }
    if (process.env.BUILD_TARGET === "dev") /* eslint-disable no-console */ console.clear = new Proxy(console.clear, {
        apply (target, this_arg, arg_list) {
            if (new Error().stack?.split("\n").filter(Boolean).some((s)=>s.includes("http://localhost:1234/depict-ai.js"))) {
                /* eslint-disable no-console */ console.log("CSS change detected through hack, reloading");
                location.reload();
            }
            return target.apply(this_arg, arg_list);
        }
    });
    document.depictwashere = true;
    callback().catch((0, $7547e32486a3abc0$export$8048b892d651b310));
};
function $0a581f1dfa083522$export$328e81c44cddf3c0(callback, get_market, supported_markets, unsupported_markets, preferred_demo_market) {
    $0a581f1dfa083522$export$692b606677218a16(async ()=>{
        // Handle override for debug scripts (could be used on demo pages too)
        if (process.env.DEBUG === "true") {
            let localstorage_override;
            const query_param_override = new URLSearchParams(location.search).get("depict-override-market");
            if (query_param_override !== null) {
                (0, $649f456f663da9fc$export$de56f1198d121036)(`Found ?depict-override-market=${query_param_override}. Using that as the market`);
                get_market = ()=>query_param_override;
                localStorage.setItem("depict-override-market", query_param_override);
            } else if ((localstorage_override = localStorage.getItem("depict-override-market")) !== null) {
                (0, $649f456f663da9fc$export$de56f1198d121036)(`Found depict-override-market="${localstorage_override}" in localStorage. Using that as the market`);
                get_market = ()=>localstorage_override;
            }
        }
        const market = await get_market();
        if (supported_markets.includes(market)) {
            (0, $649f456f663da9fc$export$de56f1198d121036)(`Initializing with market: ${market}`);
            return callback(market).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
        } else if (unsupported_markets.includes(market)) {
            (0, $649f456f663da9fc$export$de56f1198d121036)(`Unsupported market: ${market}. Exiting...`);
            return;
        } else if (process.env.DEBUG === "true" && location.host.endsWith(".demo.depict.ai") && preferred_demo_market) {
            (0, $649f456f663da9fc$export$de56f1198d121036)(`On demosite with default market override. Setting market to ${preferred_demo_market}`);
            return callback(preferred_demo_market).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
        } else {
            (0, $7547e32486a3abc0$export$8048b892d651b310)(new Error(`Unknown market: "${market}". Exiting...`));
            return;
        }
    });
}






class $26eaaddf434c84f1$export$8d42ce4827f43582 {
    constructor(options){
        this.dataset = {
            ...(options.current_script_override || document.currentScript || {}).dataset || {}
        };
        this.modify = this.dataset.modify === "true";
        this.is_debug = (0, $571bce04eb920cd8$export$55fe61489d2c7417);
        this.dlog = (0, $649f456f663da9fc$export$de56f1198d121036);
        this.TENANT = options.TENANT || process.env.TENANT || "sandbox";
        this.MARKET = options.MARKET;
        this.Sentry = (0, $eba382943196079c$export$af2e17a20c2ea3c5);
        this.GA_ID = options.GA_ID ?? "";
        this.TYPE = options.TYPE || "normal";
        this.catchify = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9);
        this.err = (0, $7547e32486a3abc0$export$8048b892d651b310);
        if (this.GA_ID) (0, $c749fe63b72056ef$export$ac7296527cb52311)(this.GA_ID);
        // https://gitlab.com/depict-ai/depict.ai/-/merge_requests/2318#note_927887712
        this.get_product_id = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((...args)=>{
            const id = options.get_product_id(...args);
            if (id instanceof Promise) return id.then((id)=>id || "");
            return id || "";
        });
        this.product_id = this.get_product_id; // template tool compatible alias
        this.tenant = this.TENANT;
        this.market = this.MARKET;
        this.gaid = this.GA_ID; // template tool compatible alias
        this.type = this.TYPE;
        this.catchify = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9);
        this.err = (0, $7547e32486a3abc0$export$8048b892d651b310);
        if (localStorage.getItem("highlight-depict") === "true") (0, $0a581f1dfa083522$export$59ba1eb2c083f0cd)(".depict { background: #f00a !important; }");
        if (options.pageview_tracking ?? true) (async ()=>{
            (0, $aa0140679dc70b7a$export$f7cb1bd47199ec38)({
                market: this.market,
                tenant: this.tenant,
                get_product_id: this.get_product_id
            });
        })();
    }
} /**
 * This is a list of alpha-2 country codes plus some two letter combinations commonly used to describe markets
 */  // albania


const $d4ffde0b9fca0369$var$default_get_rec_id = (elem)=>elem?.dataset?.depict_recommendation_id || elem?.dataset?.recommendationId;
const $d4ffde0b9fca0369$var$default_get_prod_id = (elem)=>elem?.dataset?.depict_product_id || elem?.dataset?.productId;
const $d4ffde0b9fca0369$var$default_get_ga_prod_id = (elem)=>elem?.dataset?.ga_ids;
const $d4ffde0b9fca0369$var$get_index_in_children_of_el = (el)=>[
        ...el?.parentElement?.children || []
    ].indexOf(el);
const $d4ffde0b9fca0369$export$29a6094e0bd8bc5f = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (options, gtag_options)=>{
    const { product_selector: product_selector , a2c_selector: a2c_selector , rec_a2c_selector: rec_a2c_selector , rec_a2c_unbubbled: rec_a2c_unbubbled , get_product_id: get_product_id = options.t?.get_product_id , get_rec_id: get_rec_id = $d4ffde0b9fca0369$var$default_get_rec_id , get_prod_id: get_prod_id = $d4ffde0b9fca0369$var$default_get_prod_id , get_ga_prod_id: get_ga_prod_id = $d4ffde0b9fca0369$var$default_get_ga_prod_id , get_display: get_display , impression_tracking: impression_tracking , a2c_elements: a2c_elements , product_elements: product_elements , t: t , click_location_prefix: click_location_prefix = (elem)=>elem?.parentElement?.dataset?.type + "_"  } = options;
    const get_display_data = async (elem)=>{
        const data = {};
        if (get_prod_id) data.product_id = await get_prod_id(elem) || (get_product_id ? await get_product_id(elem.querySelector("a")?.href || elem?.href) : undefined);
        if (get_ga_prod_id) data.ga_product_id = await get_ga_prod_id(elem);
        if (get_rec_id) data.recommendation_id = get_rec_id(elem);
        if (get_display) Object.assign(data, get_display(elem));
        return data;
    };
    const impression_tracked_els = new WeakSet();
    const view_tracked_els = new WeakSet();
    const a2c_tracked_els = new WeakSet();
    const click_tracked_els = new WeakSet();
    const gtag_view_product_ids = {};
    // Page view
    if (t instanceof (0, $26eaaddf434c84f1$export$8d42ce4827f43582)) (async ()=>{
        (0, $aa0140679dc70b7a$export$eee4c4d924348b05)({
            tenant: t.tenant,
            market: t.market,
            product_id: await t.get_product_id()
        });
    })();
    // Product card
    const add_tracking_to_product_card = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ({ element: elem  })=>{
        const index = $d4ffde0b9fca0369$var$get_index_in_children_of_el(elem);
        const data = await get_display_data(elem);
        const prefix = typeof click_location_prefix === "function" && click_location_prefix(elem) || "depict_";
        const gtag_list_name = "depict_" + (prefix[prefix.length - 1] == "_" ? prefix.substr(0, prefix.length - 1) : prefix);
        // Impression tracking
        if (impression_tracking && !impression_tracked_els.has(elem)) {
            impression_tracked_els.add(elem);
            (0, $21285393646b9849$export$37125ccc5dd98050)({
                element: elem,
                data: {
                    recommendation_id: data.recommendation_id,
                    product_id: data.product_id,
                    tenant: t.tenant,
                    recommendation_type: prefix.slice(-1) === "_" ? prefix.slice(0, -1) : prefix,
                    entity_price: data.entity_price,
                    market: t.market
                },
                wait_for_dom_insertion: false
            });
        }
        // Gtag view tracking
        if (data.product_id && options.attempt_gtag_view_tracking && !view_tracked_els.has(elem)) {
            view_tracked_els.add(elem);
            const gtag_view_product_ids_for_product = gtag_view_product_ids[gtag_list_name] ||= [];
            gtag_view_product_ids_for_product.push({
                product_id: data.ga_product_id || data.product_id,
                index: index
            });
            if (data.ga_product_ids) gtag_view_product_ids_for_product.push(...data.ga_product_ids.map((product_id)=>({
                    product_id: product_id,
                    index: index
                })));
            try {
                const ga_ids = elem?.dataset?.ga_ids;
                if (ga_ids) gtag_view_product_ids_for_product.push(...ga_ids.split(",").map((id)=>({
                        product_id: id,
                        index: index
                    })));
            } catch (e) {
                (0, $649f456f663da9fc$export$c2363754d4758444)("Something went wrong on a product with multiple ga_ids", e);
            }
        }
        if (typeof BroadcastChannel == "function") {
            // right click and mouse wheel click tracking
            const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((e)=>(0, $61b3c9e5f2cf8171$export$8f66c4c7fb96eda2)(e, data.product_id));
            elem.addEventListener("contextmenu", handler);
            elem.addEventListener("auxclick", (e)=>e.button === 1 && handler(e)); // actual wheel click - some mouses / OS:es also dispatch auxclick on rightclick
        }
        click_tracking: {
            if (click_tracked_els.has(elem)) break click_tracking;
            click_tracked_els.add(elem);
            elem.addEventListener("click", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                const product_id = data.product_id || "DNT";
                const recommendation_id = data.recommendation_id || "not_depict";
                localStorage.setItem(`depict_attribution_${product_id}`, recommendation_id);
                const index = $d4ffde0b9fca0369$var$get_index_in_children_of_el(elem);
                const click_location = prefix + (index + 1);
                (0, $c749fe63b72056ef$export$127751e82111fcf)();
                (0, $43683b1103edab15$export$15f8a0cd5a8c0ebb)({
                    ...options.t || {},
                    ...options,
                    ...data,
                    ...data.recommendation_id ? {} : {
                        attribution_id: "recommendation"
                    },
                    click_location: click_location
                });
                if (!options.no_gtag) {
                    const gtag_options_with_click_location = {
                        list_name: gtag_list_name,
                        ...gtag_options
                    };
                    (0, $c749fe63b72056ef$export$f522672c9379e339)(data.product_id, index, gtag_options_with_click_location);
                    try {
                        const to_iterate = [];
                        if (data.ga_product_id) to_iterate.push(...data.ga_product_id.toString?.().split(",") ?? []);
                        to_iterate.push(...data.ga_product_ids || []);
                        to_iterate.forEach((id)=>(0, $c749fe63b72056ef$export$f522672c9379e339)(id, index, gtag_options_with_click_location));
                    } catch (e) {
                        (0, $649f456f663da9fc$export$c2363754d4758444)("Something went wrong when sending gtag click tracking on a product with multiple ga_ids");
                        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "error");
                    }
                }
            }), {
                once: true
            });
        }
        // Product card A2C button tracking
        if (rec_a2c_selector && !a2c_tracked_els.has(elem)) {
            const track_rec_a2c = async (element)=>{
                const rec_a2c_button = element.querySelector(rec_a2c_selector);
                if (!rec_a2c_button) return;
                const data = await get_display_data(element);
                rec_a2c_button.addEventListener("click", ()=>{
                    if (rec_a2c_unbubbled) {
                        // If their script cancels the event before it reaches the rec card,
                        // we will only attribute an a2c but not a click. This is inconsistent with what we usually do.
                        // Create a fake click event on the main rec card,
                        // so our click_tracking above can send tracking for a click as well.
                        const click = new MouseEvent("click", {
                            view: window,
                            bubbles: true,
                            cancelable: true,
                            metaKey: true
                        });
                        element.addEventListener("click", (e)=>(e.preventDefault(), false), {
                            once: true
                        });
                        element.dispatchEvent(click);
                    }
                    (0, $c749fe63b72056ef$export$bf205937e5e012cb)();
                    (0, $43683b1103edab15$export$9028351cb994757e)({
                        ...options.t || {},
                        ...options,
                        ...data
                    });
                });
                a2c_tracked_els.add(elem);
            };
            track_rec_a2c(elem);
        }
        if (options.shade) $d4ffde0b9fca0369$export$6ebd242c09192cec(elem);
        if (options.attempt_gtag_view_tracking && Object.keys(gtag_view_product_ids)?.length) // setTimeout to batch the requests / put it all into one gtag view event
        setTimeout((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            for(const key in gtag_view_product_ids){
                const product_ids = gtag_view_product_ids[key];
                if (product_ids?.length) {
                    (0, $c749fe63b72056ef$export$7babcd5d4056b2ca)(product_ids, ()=>"", {
                        list_name: key,
                        ...gtag_options
                    });
                    delete gtag_view_product_ids[key];
                }
            }
        }));
    });
    if (typeof product_selector == "string") (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(product_selector, add_tracking_to_product_card);
    else if (product_elements && typeof product_elements?.[Symbol.iterator] == "function") for (const element of product_elements)add_tracking_to_product_card({
        element: element
    });
    else (0, $649f456f663da9fc$export$c2363754d4758444)(new Error("AIO can't find elements, try adding a selector or els")); // don't throw so that a2c tracking keeps working
    // Page A2C button tracking
    const a2c_handler = ({ element: element  })=>{
        (0, $91b2e49f92ed636c$export$2c34560c3749dc63)(element, get_product_id, (product_id, recommendation_id, was_unmatching)=>{
            if (!was_unmatching) (0, $c749fe63b72056ef$export$bf205937e5e012cb)();
            (0, $43683b1103edab15$export$9028351cb994757e)({
                ...options.t || {},
                ...options,
                product_id: product_id,
                ...recommendation_id == "not_depict" || was_unmatching ? {
                    attribution_id: "recommendation"
                } : {
                    recommendation_id: recommendation_id
                }
            });
        }, options.always_track_a2c);
        if (options.shade) $d4ffde0b9fca0369$export$6ebd242c09192cec(element);
    };
    if (typeof a2c_selector == "string") (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(a2c_selector, a2c_handler);
    else if (a2c_elements && typeof a2c_elements?.[Symbol.iterator] == "function") for (const element of a2c_elements)a2c_handler({
        element: element
    });
    else (0, $649f456f663da9fc$export$c2363754d4758444)(new Error("Can't find a2c button, try adding a selector or els"));
    return {
        add_a2c_element: (element)=>a2c_handler({
                element: element
            }),
        add_product_element: (element)=>add_tracking_to_product_card({
                element: element
            })
    };
});
const $d4ffde0b9fca0369$export$6ebd242c09192cec = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((element)=>{
    element.style.boxShadow = "rgba(255,0,0,0.5) 10px 10px 30px 40px";
    element.style.background = "rgba(255,0,0,0.5)";
    element.style.color = "white";
});










// not ideal but can help when debugging via sentry
/**
 * A function that attempts to "serialize" an object to a text representation that helps with debugging when using sentry
 * @param  anything               Something to try to serialize - this function is crappy and your mileage may vary
 * @param  depth                  How deep to go when recursing
 * @return          An object that is somehow closer to text (better serializable by sentry) or text
 */ function $5c4afc453f904a1f$export$39d526a1194b6499(anything, depth) {
    depth ??= 0;
    depth++;
    if (depth > 30) return anything;
    const output = {};
    for(const key in anything){
        const value = anything[key];
        let serialized_value;
        if (value instanceof Element) serialized_value = value.cloneNode(false).outerHTML;
        else if (value instanceof Headers) serialized_value = Object.fromEntries(value.entries());
        else if (typeof value == "object" && value != null && (typeof value[Symbol.iterator] === "function" || value instanceof Response)) serialized_value = $5c4afc453f904a1f$export$39d526a1194b6499(value, depth);
        else serialized_value = value?.toString?.();
        output[key] = serialized_value;
    }
    return output;
}


const $2cbe7e0ca2ce5438$export$5c069c93d2b7493f = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));





async function $2d1ffbfaa1c2d9e3$export$bcd70d5ed1cf6313(url, options, max_retries = 10) {
    const ONE_MINUTE = 60000;
    const max_backoff_ms = ONE_MINUTE;
    const { stack: stack  } = new Error();
    const calculate_retry = (delay)=>{
        delay *= 2 + Math.random();
        if (delay > max_backoff_ms) delay = max_backoff_ms * (1 + Math.random() / 10);
        return delay;
    };
    let try_again_in_ms = 100;
    let has_succeeded = false;
    let result = false;
    while(max_retries && !has_succeeded)try {
        const response = await fetch(url, options);
        if (!response || !response.ok || response.status !== 200) {
            if (response.status === 422) {
                (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($2d1ffbfaa1c2d9e3$var$send_sentry_422)(response, options?.body || {}, stack);
                has_succeeded = true;
            } else if (response.status === 404) has_succeeded = true;
            (0, $649f456f663da9fc$export$de56f1198d121036)("Response not ok", response);
        } else has_succeeded = true;
        result = response;
    } catch (error) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Error while fetching: ", error, url, options);
        // Don't retry CORS
        if (error.message.includes("CORS") && error.name.includes("CORS")) has_succeeded = true;
    } finally{
        if (!has_succeeded) await (0, $2cbe7e0ca2ce5438$export$5c069c93d2b7493f)(try_again_in_ms);
        try_again_in_ms = calculate_retry(try_again_in_ms);
        max_retries -= 1;
    }
    return result;
}
async function $2d1ffbfaa1c2d9e3$var$send_sentry_422(response, body, stack) {
    const msg = `Validation error: got 422 from API`;
    const text = await response.clone().text();
    (0, $649f456f663da9fc$export$de56f1198d121036)(msg, "body", body, "response", response, "text", text, "stack", stack);
    (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
        scope.setExtra("stack", stack);
        scope.setExtra("request_body", body);
        scope.setExtra("response", response);
        scope.setExtra("serialized_response", (0, $5c4afc453f904a1f$export$39d526a1194b6499)(response));
        scope.setExtra("response_text", text);
        scope.setLevel("error");
        this.captureException(new Error(msg));
    });
}



async function $2d47b009af5bc0a4$export$1bc0df10745d5412(t, options, headers, get_url = $2d47b009af5bc0a4$var$default_get_fetch_url) {
    const res = await $2d47b009af5bc0a4$export$d40679eb4cf32f09(t, options, headers, get_url);
    return res?.displays || [];
}
async function $2d47b009af5bc0a4$export$d40679eb4cf32f09(t, options, headers, get_url = $2d47b009af5bc0a4$var$default_get_fetch_url) {
    const dsid = (0, $43683b1103edab15$export$6399bdb2291895e0)();
    const session_id = options.session_id || (0, $43683b1103edab15$export$61e7e1f11e96692f)();
    const user_id = options.user_id || dsid;
    const body = {
        tenant: t.tenant,
        market: t.market,
        user_id: user_id,
        session_id: session_id,
        dsid: dsid,
        document_referrer: document.referrer,
        ...options
    };
    const endpoint = $2d47b009af5bc0a4$var$get_fetch_endpoint_from_options(options);
    return await (0, $2d1ffbfaa1c2d9e3$export$bcd70d5ed1cf6313)(get_url(endpoint), {
        body: JSON.stringify(body),
        ...headers ? {
            headers: headers
        } : {},
        method: "POST"
    }) // @ts-ignore
    .then((r)=>r.json()).catch((e)=>(0, $649f456f663da9fc$export$de56f1198d121036)("fetch_retry threw", e));
}
function $2d47b009af5bc0a4$var$default_get_fetch_url(type) {
    return (0, $f564adbc4675ceaf$export$fe609f0216e4ebef)(`${(0, $6c2b49f3f564b0d1$export$362abebb4b313340)}/v2/recommend/products/${type}`);
}
function $2d47b009af5bc0a4$var$get_fetch_endpoint_from_options(options) {
    if (options["category_id"] !== undefined) return "category";
    else if (options["product_id"] !== undefined) return "product";
    else if (options["product_ids"] !== undefined) return "products";
    return "general";
}






async function $5cbe24d064a033ed$export$a9fc160c5ed83bd7(t, rendering_options) {
    // clone options to prevent nasty bugs where changes of options change the options somewhere else too
    rendering_options = $5cbe24d064a033ed$export$c42139a43c877ecd(rendering_options);
    const { type: type  } = rendering_options;
    const displays = await $5cbe24d064a033ed$var$make_sure_we_have_displays(t, rendering_options);
    if (!displays?.length) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("RR: Got no displays for type " + type + ", can't recover.", t, rendering_options);
        return {};
    }
    // return if too few displays
    const { min_items_to_run: min_items_to_run  } = rendering_options;
    const good_displays = await $5cbe24d064a033ed$var$check_displays(displays, min_items_to_run).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    if (!good_displays) return {};
    const processed_displays = await $5cbe24d064a033ed$export$c22e610107c5a15a(t, rendering_options, displays);
    if (!processed_displays.length) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("RR: No displays left after preprocessing");
        return {};
    }
    const { template: template , post_processors: post_processors = []  } = rendering_options;
    const caught_post_processing_functions = post_processors.map((post_pro)=>(0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(post_pro));
    let a;
    const caught_html2elems = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583));
    let output_elements;
    if (typeof template === "function") {
        const caught_template = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(template);
        output_elements = (await Promise.allSettled(processed_displays.map(async (display, index)=>{
            const event_listeners = [];
            let keep = true;
            const info = new $5cbe24d064a033ed$export$da854280fb61cd32(t, rendering_options, displays, index, ()=>keep = false, event_listeners);
            const template_result = await caught_template(display, info);
            if (!keep) throw keep;
            const elements = (typeof template_result == "string" ? caught_html2elems(template_result) : template_result) || [];
            const post_processed_elements = await $5cbe24d064a033ed$export$cf7cbc6b76039101(t, rendering_options, processed_displays, index, caught_post_processing_functions, elements, event_listeners);
            return Array.from(post_processed_elements);
        }))).filter((p)=>p.status === "fulfilled").map((p)=>p.value).flat();
    // I don't want to use anything using spread since spread is a nice form of apply and
    // there's a - browser engine dependant - limit of arguments that can be applied to a function
    // we don't know how this will be used and want it to be robust
    } else output_elements = (await Promise.all(processed_displays.map(async (display, index)=>{
        const html = $5cbe24d064a033ed$export$e0009e7da572f99b(template, display);
        const elements = caught_html2elems(html) || [];
        const post_processed_elements = await $5cbe24d064a033ed$export$cf7cbc6b76039101(t, rendering_options, processed_displays, index, caught_post_processing_functions, elements);
        return Array.from(post_processed_elements);
    }))).flat();
    if (!output_elements.length) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("RR: No displays left after postprocessing/rendering");
        return {};
    }
    return {
        elements: output_elements,
        displays: processed_displays
    };
}
function $5cbe24d064a033ed$export$e0009e7da572f99b(template, display = {}) {
    const discount_matcher = /{DISCOUNT{([\s\S]+?)}}/g;
    const no_discount_matcher = /{NODISCOUNT{([\s\S]+?)}}/g;
    if ("variant_index" in display || !("sale_price" in display)) throw new Error("Modern display in ancient templating");
    const { sale_price: sale_price , original_price: original_price  } = display;
    if (sale_price !== original_price) template = template.replaceAll(discount_matcher, "$1").replaceAll(no_discount_matcher, "");
    else template = template.replaceAll(discount_matcher, "").replaceAll(no_discount_matcher, "$1");
    // Conditional statements
    // {if VAR_NAME}
    //    print this if true
    // {else}
    //    print this if false
    // {end}
    // Note: these can't be nested. Else statement is optional
    template = template.replace(/{if\s+(.+?)}([\S\s]*?)(?:{else}([\S\s]*?))?{end}/g, (_, variable, if_yes, if_no)=>{
        if (typeof if_no !== "string") // if_no is a number if there's no {else} statement
        if_no = "";
        return display[variable] ? if_yes : if_no;
    });
    return template.replace(/\${(.*?)}/g, (_, g)=>display[g] ?? "");
// this is copied from here, I hope I'm not breaking any licenses. Need it to transpile for IE11 compatiblity:
// https://github.com/mikemaccana/dynamic-template/blob/master/index.js
}
function $5cbe24d064a033ed$export$c42139a43c877ecd(obj) {
    if (obj && typeof obj === "object" && !(obj instanceof Promise)) {
        // @ts-ignore (I don't know how to type this)
        const new_obj = Object.assign(new obj.constructor(), obj);
        for(const key in new_obj)if (typeof new_obj[key] === "object") new_obj[key] = $5cbe24d064a033ed$export$c42139a43c877ecd(new_obj[key]);
        return new_obj;
    }
    return obj;
}
async function $5cbe24d064a033ed$export$cf7cbc6b76039101(t, rendering_options, displays, index, functions, elements, event_listeners = []) {
    let keep = true;
    const info = new $5cbe24d064a033ed$export$da854280fb61cd32(t, rendering_options, displays, index, ()=>keep = false, event_listeners);
    for(let i = 0; i < functions.length; i++){
        const result = await functions[i](elements, displays[index], info);
        if (result) elements = result;
        if (!keep) break;
    }
    if (keep) {
        for(let i = 0; i < event_listeners.length; i++)for(let j = 0; j < elements.length; j++)elements[j].addEventListener(...event_listeners[i]);
    }
    return keep ? elements : [];
}
async function $5cbe24d064a033ed$export$c22e610107c5a15a(t, rendering_options, displays) {
    const { max_items: max_items , pre_processors: pre_processors = []  } = rendering_options;
    const caught_pre_processors = pre_processors.map((pre_pro)=>(0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(pre_pro));
    const processed_displays = [];
    for(let i = 0; i < displays.length; i++){
        // classic for loop is both fast and can be stopped with break
        let keep = true;
        const info_for_pre_pro = new $5cbe24d064a033ed$export$da854280fb61cd32(t, rendering_options, displays, i, ()=>keep = false);
        let display = displays[i];
        for(let j = 0; j < caught_pre_processors.length; j++){
            const pre_processor = caught_pre_processors[j];
            const result = await pre_processor(display, info_for_pre_pro);
            if (result) display = result; // Don't understand why this cast is needed
            if (!keep) break;
        }
        if (keep) processed_displays.push(display);
        if (processed_displays.length >= max_items) break;
    }
    return processed_displays;
}
class $5cbe24d064a033ed$export$da854280fb61cd32 {
    constructor(t, rendering_options, displays, index, remove_display, event_listeners){
        // @ts-ignore Support for no-tenant recommendation rendering for js-ui/react-ui
        this.t = t;
        this.rendering_options = rendering_options;
        this.displays = displays;
        if (index != null) this.index = index;
        if (remove_display) this.remove_display = remove_display;
        if (event_listeners) {
            this.event_listeners = event_listeners;
            this.register_event_listener = (...args)=>this.event_listeners.push(args);
        }
    }
}
async function $5cbe24d064a033ed$var$check_displays(displays, min_items_to_run) {
    // don't run if too few recs
    if (min_items_to_run && displays.length < min_items_to_run) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("RR: Got too few displays, exiting");
        return false;
    }
    return true;
}
async function $5cbe24d064a033ed$var$make_sure_we_have_displays(t, rendering_options) {
    const recs = await rendering_options.recs;
    if (Array.isArray(recs)) return $5cbe24d064a033ed$export$c42139a43c877ecd(recs);
    if (!t) // No recs and no tenant, so we can't get any. Should never happen.
    return [];
    // get displays with get_displays if none are provided
    const get_displays_options = {
        type: rendering_options.type,
        ...rendering_options.extra_api_options || {}
    };
    for (const key of [
        "product_ids",
        "category_id",
        "product_id"
    ])if (key in rendering_options) get_displays_options[key] = rendering_options[key];
    return await (0, $2d47b009af5bc0a4$export$1bc0df10745d5412)(t, get_displays_options, rendering_options.headers || {}).catch(t.err);
}


async function $f1396aa84761fbe5$export$c83d8da642b5104a(t, options, GWVM_opts) {
    const { catchify: catchify , dlog: dlog , is_debug: is_debug  } = t;
    const { container_selector: container_selector = ".grid" , container_template: container_template , start_rows: start_rows = 1 , rows_per_click: rows_per_click = 1 , override_rec_renderer: override_rec_renderer , button: button , title: title , title_selector: title_selector , only_full_rows: only_full_rows = false , should_preload: should_preload = true  } = GWVM_opts;
    const outer_els = typeof container_template === "string" ? [
        ...(0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583)(container_template)
    ] : container_template;
    const [root] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(outer_els, container_selector);
    const cut_off_promise_obj = /*@__PURE__*/ new (0, $09ff985c7c424fb3$export$32ccf3a614c84258)();
    const i_observer = new IntersectionObserver(catchify($f1396aa84761fbe5$var$observer_callback));
    let cut_off_point = 0;
    const recs_per_row = ()=>typeof GWVM_opts.recs_per_row === "function" ? GWVM_opts.recs_per_row(cut_off_point) : GWVM_opts.recs_per_row ?? 6;
    cut_off_point = recs_per_row() * start_rows;
    const get_show_next_num = ()=>recs_per_row() * rows_per_click;
    const preload_next_row = catchify(()=>{
        const preload_these = [
            ...rendering_results.displays
        ].slice(cut_off_point, cut_off_point + get_show_next_num());
        for (const elem of preload_these){
            const img = new Image();
            img.src = elem.image_url;
        // Element should be garbage collected, and the image source put in cache
        // https://stackoverflow.com/questions/3646036/preloading-images-with-javascript
        }
    });
    const load_more = catchify((num)=>{
        const adds = typeof num == "number" ? num : get_show_next_num();
        cut_off_point += adds;
        cut_off_promise_obj.resolve(cut_off_point);
        if ((only_full_rows ? cut_off_point + adds : cut_off_point) >= displays.length) // TODO: make it remove/add back the button depending on viewport
        load_more_cont.remove();
        if (adds > 0 && should_preload) preload_next_row();
    });
    const our_post_pro = (elements, display, info)=>$f1396aa84761fbe5$var$post_processor(elements, display, info, cut_off_point, i_observer, cut_off_promise_obj, load_more);
    const rendering_results = await (override_rec_renderer || (0, $5cbe24d064a033ed$export$a9fc160c5ed83bd7))(t, {
        ...options,
        post_processors: [
            our_post_pro,
            ...options.post_processors || []
        ]
    });
    const { elements: rendered_elements , displays: displays  } = rendering_results;
    if (!rendered_elements) {
        dlog("Grid with view more is stopping because it got no elements");
        return rendering_results;
    }
    root.append(...rendered_elements);
    const load_more_cont = (0, $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787)(`<div class="load-more-container"></div>`);
    const button_element = button instanceof Element ? button : (0, $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787)(`<button class="load_more">${button || "Visa mer"}</button>`);
    button_element.addEventListener("click", load_more);
    load_more_cont.append(button_element);
    root.after(load_more_cont);
    if (should_preload) {
        const load_more_intersection = async (entries, intersection_observer)=>{
            // Multiple observe calls could potentially (?) be batched into one fn call, so check everything
            let intersected = false;
            for(let i = 0; i < entries.length; i++)if (entries[i].isIntersecting) {
                intersected = true;
                break;
            }
            if (!intersected) return;
            preload_next_row();
            intersection_observer.disconnect(); // The load_more button has its own preload call, so this only needs to happen the first time.
        };
        const load_more_observer = new IntersectionObserver(catchify(load_more_intersection));
        load_more_observer.observe(load_more_cont);
    }
    if (title) {
        const [title_el] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(outer_els, title_selector || "h1.title");
        if (title_el) {
            if (title instanceof Element) title_el.replaceWith(title);
            else title_el.innerText = title;
        } else if (is_debug) {
            console.error("GWVM: Title set but couldn't find title element. Please specify title_selector", ()=>{});
            console.trace();
        }
    }
    return {
        ...rendering_results,
        elements: outer_els,
        load_more: load_more
    };
}
function $f1396aa84761fbe5$var$observer_callback(entries) {
    for(let i = 0; i < entries.length; i++)if (entries[i].isIntersecting) {
        const target = entries[i].target;
        if (!target.src?.length && target.dataset?.src?.length) {
            target.src = target.dataset.src;
            target.removeAttribute("data-src");
        }
    }
}
function $f1396aa84761fbe5$var$post_processor(elements, _, //display: display,
info, cut_off_point, i_observer, cut_off_promise_obj, load_more) {
    const { catchify: catchify , err: err , dlog: dlog  } = info.t;
    const { index: index  } = info;
    const elements_arr = [
        ...elements
    ];
    const [an_element_node] = elements_arr.filter((node)=>node.nodeType == Node.ELEMENT_NODE);
    const is_initially_hidden = index + 1 > cut_off_point;
    const extras = info.extras ||= {};
    extras.load_more ||= load_more;
    extras.load_more_ipo ||= cut_off_promise_obj;
    (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(elements_arr, "img:not(.filler):not(.ngl):not(.nolazy)").forEach((image)=>{
        // "img" also selects "image" in IE11 which can be an SVG element which doesn't have a src property, therefore optional chaining
        if ((image?.src?.length || image?.dataset?.src) && image?.src?.substr?.(0, 6) != "data:") {
            if (is_initially_hidden && !image?.dataset.src) {
                image.dataset.src = image.src;
                image.removeAttribute("src");
            }
            (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(an_element_node).then(catchify((el)=>{
                if (el?.offsetParent !== null) image.src ||= image.dataset.src;
                else i_observer.observe(image);
            }));
        }
    });
    (async function() {
        if (is_initially_hidden) for(let i = 0; i < elements_arr.length; i++){
            // HTMLElement is a lie, but TS is too dumb to understand that we check for it being a Node the line below this
            const { style: style  } = elements_arr[i];
            if (style) style.display = "none";
        }
        while(true){
            cut_off_point = await cut_off_promise_obj.promise;
            extras.load_more_currently_showing = cut_off_point;
            if (index + 1 <= cut_off_point) {
                for(let i = 0; i < elements_arr.length; i++){
                    const { style: style  } = elements_arr[i];
                    if (style) style.display = "";
                }
                break;
            }
        }
    })().catch(err);
    return elements;
}




async function $ea554f5a28904975$export$41de2959a8dd405d(t, options, GWVM_opts, { rec_selector: rec_selector = ".rec_outer"  } = {}) {
    const { start_rows: wished_start_rows = 1  } = GWVM_opts;
    const { dlog: dlog , err: err , catchify: catchify  } = t;
    let result;
    let rec;
    let first = true;
    const modified_GWVM_opts = {
        ...GWVM_opts,
        start_rows: 1 / 6,
        recs_per_row (num) {
            try {
                if (result?.elements && rec) {
                    let { parentElement: parentElement  } = rec;
                    if (!parentElement) {
                        // first rec was removed
                        [rec] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(result?.elements || [], rec_selector);
                        parentElement = rec?.parentElement;
                        if (!parentElement) throw new Error("Could not find element matching " + rec_selector + "to calculate width");
                    }
                    const recs_fitting_in_row = Math.floor(parentElement.getBoundingClientRect().width / Math.floor(rec.getBoundingClientRect().width));
                    // this is not entirely accurate because of margins but seems to work 100% of the time for our use case
                    if (recs_fitting_in_row != Infinity) {
                        dlog("We think there are currently", recs_fitting_in_row, "columns");
                        const { children: children  } = parentElement;
                        const last_visible = $ea554f5a28904975$var$find_last_visible(children);
                        if (!last_visible) {
                            dlog("It seems like no elements are visible, not loading any");
                            return 0;
                        }
                        if (num % recs_fitting_in_row !== 0) {
                            // X % 0 is NaN, prevent this from happening
                            const fill_last_row = recs_fitting_in_row === 0 ? 0 : recs_fitting_in_row - num % recs_fitting_in_row;
                            result.load_more?.(fill_last_row + recs_fitting_in_row * (wished_start_rows - 1));
                        }
                        // Special case for when it's the first "load more" (which is automatically triggered)
                        if (num === 1 && first) {
                            first = false;
                            return 0;
                        }
                        return recs_fitting_in_row;
                    }
                }
            } catch (e) {
                err(e);
            }
            return 6;
        }
    };
    // @ts-ignore
    result = await (0, $f1396aa84761fbe5$export$c83d8da642b5104a)(t, options, modified_GWVM_opts);
    if (!result?.elements) // no chance in finding any elements, API didn't return recs
    return result;
    if (typeof result?.load_more == "function") (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(rec_selector).then(()=>{
        // we load 1 card to be able to determine the width
        // in this situation recs_per_row will not return actual recs per row but recs_to_complete_row, so we add one card to get actual recs per row
        // then we remove the one card again from total calculation
        result.load_more?.();
    });
    else err("Could not find recommendation to calculate recs per row. rec_selector: " + rec_selector);
    return result;
}
function $ea554f5a28904975$var$find_last_visible(items) {
    for(let i = items.length - 1; i > -1; i--){
        // @ts-ignore
        if (items[i]?.offsetParent !== null) return items[i];
    }
}



/**
 * @deprecated use async_iterable_ipns instead. This can skip values which yields unexpected results.
 */ function $92b7ea2cf75c4aec$export$55621c1ce3cd536b() {
    // the idea is to have a new promise available immediately before one resolves, so to say an infinite promise
    let internal_resolve; // copy and pasted from iconbeauty
    const cart_promise_object = {
        // I feel like Anton is not going to like this extremely awesome approach
        promise: new Promise((r)=>internal_resolve = r),
        // which is why I'm reluctant with making it a library
        internal_resolve: internal_resolve,
        // Edit from later on: I have realised that this is actually very useful, it just has a steep learning curve.
        resolve: (argument)=>{
            // it allows both not having to call functions in a loop and instead just awaiting the promise from multiple places
            const oldresolve = cart_promise_object.internal_resolve; // and to effortlessly ensure a process is never running twice with 100% reliability
            cart_promise_object.promise = new Promise((r)=>cart_promise_object.internal_resolve = r); // it could be made a class, but I already know this works, so I'll leave it as is
            oldresolve(argument);
        }
    };
    return cart_promise_object;
}



// import { buildThresholdList } from "../../helpers/build_threshold_list";




async function $075589a94064cf2e$export$c0a4d29bc45a38c6(t, options, GWVM_opts, { rec_selector: rec_selector = ".rec_outer"  } = {}) {
    const options_for_auto_gwvm = {
        ...GWVM_opts,
        start_rows: 1
    };
    let all_rendered_elements = [];
    options.post_processors = [
        ...options.post_processors || [],
        (elements, display, info)=>{
            all_rendered_elements.push(elements);
            if (!info.index) // the plan:
            // observe first element - after dom insertion, count the visible elements and observe the last one thereof
            // once it enters the view port, unobserve it
            // once new elements have been loaded, count the visible elements - only once tho, in response of the first one being visible
            // then attach to last element again and repeat
            $075589a94064cf2e$var$observe_first_el_after_dominsertion(all_rendered_elements, elements, info.extras.load_more);
            return elements;
        }
    ];
    return await (0, $ea554f5a28904975$export$41de2959a8dd405d)(t, options, options_for_auto_gwvm, {
        rec_selector: rec_selector
    });
}
function $075589a94064cf2e$var$observe_first_el_after_dominsertion(all_rendered_elements, elements, load_more) {
    const element = $075589a94064cf2e$var$find_html_element(elements);
    if (!element) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Infinite scroll won't work, couldn't find element to observe", elements);
        return;
    }
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(element).then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
        $075589a94064cf2e$var$find_last_el_and_observe(all_rendered_elements, load_more);
    }));
}
function $075589a94064cf2e$var$find_last_el_and_observe(all_rendered_elements, load_more) {
    const last_visible_el = $075589a94064cf2e$var$find_last_visible(all_rendered_elements);
    if (!last_visible_el) return;
    const i_o = new IntersectionObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
        for (const record of records)if (record.isIntersecting) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("loading more because of", record);
            load_more();
            setTimeout((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($075589a94064cf2e$var$find_last_el_and_observe), 0, all_rendered_elements, load_more);
            i_o.disconnect();
        }
    }));
    i_o.observe(last_visible_el);
}
function $075589a94064cf2e$var$find_html_element(elements) {
    // intersection observers don't work on text nodes
    let element;
    for(let i = 0; !((element = elements[i++]) instanceof HTMLElement) && element;);
    return element;
}
function $075589a94064cf2e$var$find_last_visible(bunch_of_elements) {
    const considered_elements = bunch_of_elements.map((els)=>$075589a94064cf2e$var$find_html_element(els));
    // this is a potentially dangerous assumption - that the visibility status of the first element is the same as all other elements, but it should be true 100% of the time right now since GWVM sets display: none uniformally and why tf would you want it differently?
    for(let i = 0; i < considered_elements.length; i++){
        const respected_element = considered_elements[i];
        if (!respected_element) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Infinite scroll error: couldn't find last visible element", bunch_of_elements);
            return;
        }
        if (respected_element.offsetParent === null) {
            if (!i) {
                // if index is 0 and we are not visible don't return the element at index -1 from the array - shit will hit the fan. Return the first one and everything should work out fine
                (0, $649f456f663da9fc$export$de56f1198d121036)("Inf scroll: No elements visible, ", considered_elements, "will attach to first el", respected_element);
                return considered_elements[i];
            }
            return considered_elements[i - 1];
        }
    }
    (0, $649f456f663da9fc$export$de56f1198d121036)("Seems like all elements are loaded");
}




async function $efda45906c6cbac7$export$9eae832ae57fbf(t, css, extra_html) {
    const head = await (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element("head"), { dlog: dlog  } = t, elems = (0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583)(`<style type="text/css">${css}</style>` + (extra_html ? extra_html : ""));
    dlog("inserting", ...elems, "into", head);
    head.append(...elems);
}


// TODO: Move ArrayElement<> to better util place
// All the supported markets of all the Tenants (all possible markets).
/**
 * @deprecated please use TwoLetterMarket / readonly arrays/objects instead
 */ let $a40013fcba50c9ee$export$3db8c5834c5aa726;
// All the known locales (add more)
/**
 * @deprecated please use TwoLetterMarket / readonly arrays/objects instead
 */ (function(Market) {
    Market["dk"] = "dk";
    Market["uk"] = "uk";
    Market["com"] = "com";
    Market["fi"] = "fi";
    Market["no"] = "no";
    Market["de"] = "de";
    Market["nl"] = "nl";
    Market["fr"] = "fr";
    Market["se"] = "se";
    Market["ch"] = "ch";
    Market["za"] = "za";
    Market["us"] = "us";
    Market["ee"] = "ee";
    Market["default"] = "default";
})($a40013fcba50c9ee$export$3db8c5834c5aa726 || ($a40013fcba50c9ee$export$3db8c5834c5aa726 = {}));
let $a40013fcba50c9ee$export$d4f428a61c37ddfa;
(function(Locale) {
    Locale["sv_SE"] = "sv-SE";
    Locale["no_NO"] = "no-NO";
    Locale["fi_FI"] = "fi-FI";
    Locale["da_DK"] = "da-DK";
    Locale["en_UK"] = "en-UK";
    Locale["de_DE"] = "de-DE";
    Locale["nl_NL"] = "nl-NL";
    Locale["fr_FR"] = "fr-FR";
    Locale["de_CH"] = "de-CH";
})($a40013fcba50c9ee$export$d4f428a61c37ddfa || ($a40013fcba50c9ee$export$d4f428a61c37ddfa = {}));
const $a40013fcba50c9ee$export$ebe860a2db7990ad = {
    SEK: {
        name: "SEK",
        pre: "",
        post: " kr"
    },
    NOK: {
        name: "NOK",
        pre: "",
        post: " kr"
    },
    EUR: {
        name: "EUR",
        pre: "",
        post: " €"
    },
    PLN: {
        name: "PLN",
        pre: "",
        post: " zł"
    },
    GBP: {
        name: "GBP",
        pre: "\xa3",
        post: ""
    },
    DKK: {
        name: "DKK",
        pre: "",
        post: " kr"
    },
    CHF: {
        name: "CHF",
        pre: "CHF ",
        post: ""
    }
};
const $a40013fcba50c9ee$export$6eea148df5c7117c = {
    se: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.SEK,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.sv_SE
    },
    no: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.NOK,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.no_NO
    },
    fi: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.EUR,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.fi_FI
    },
    dk: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.DKK,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.da_DK
    },
    uk: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.GBP,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.en_UK
    },
    com: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.EUR,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.en_UK
    },
    de: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.EUR,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.de_DE
    },
    nl: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.EUR,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.nl_NL
    },
    fr: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.EUR,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.fr_FR
    },
    ch: {
        currency: $a40013fcba50c9ee$export$ebe860a2db7990ad.CHF,
        locale_bcp47: $a40013fcba50c9ee$export$d4f428a61c37ddfa.de_CH
    }
};
function $a40013fcba50c9ee$export$47340c0b196bc0f8(market) {
    return $a40013fcba50c9ee$export$6eea148df5c7117c[market].locale_bcp47;
}
function $a40013fcba50c9ee$export$c5b68ecd5c37aa6c(market) {
    return $a40013fcba50c9ee$export$6eea148df5c7117c[market].currency;
} /**
 * @deprecated please use TwoLetterMarket / readonly arrays/objects instead
 */ 






function $e867e2f1fb3bcc09$export$c7187bbd1a7a9244(...args) {
    $e867e2f1fb3bcc09$var$placeholder_worker(...args).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    return args[0];
}
async function $e867e2f1fb3bcc09$var$placeholder_worker(placeholder_elements, final_elements, switching_trigger) {
    let state = false;
    let has_sanitized_elements = false;
    const sanit_el_if_needed = async ()=>{
        if (!has_sanitized_elements) {
            has_sanitized_elements = true;
            placeholder_elements = await $e867e2f1fb3bcc09$var$convert_to_node_array(placeholder_elements);
            final_elements = await $e867e2f1fb3bcc09$var$convert_to_node_array(final_elements);
        }
    };
    if (switching_trigger instanceof (0, $09ff985c7c424fb3$export$32ccf3a614c84258)) while(true){
        const new_state = await switching_trigger.promise;
        if (new_state != state) {
            await sanit_el_if_needed();
            await $e867e2f1fb3bcc09$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
            state = new_state;
        }
    }
    else if (switching_trigger instanceof Promise) {
        const new_state = await switching_trigger;
        if (state != new_state) {
            await sanit_el_if_needed();
            await $e867e2f1fb3bcc09$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
            state = new_state;
        }
    } else {
        await sanit_el_if_needed();
        placeholder_elements[0].addEventListener("placeholder_switch", (0, $511123bb28a7b6f7$export$535946eb77c946dd)(async (e)=>{
            const new_state = e.detail.state;
            if (state != new_state) {
                await sanit_el_if_needed();
                await $e867e2f1fb3bcc09$var$decide_direction_and_switch(placeholder_elements, final_elements, new_state);
                state = new_state;
            }
        }));
    }
}
async function $e867e2f1fb3bcc09$var$convert_to_node_array(elements) {
    if (typeof elements == "function") elements = elements();
    elements = await elements;
    if (typeof elements[Symbol.iterator] != "function") elements = [
        elements
    ];
    return elements;
}
async function $e867e2f1fb3bcc09$var$decide_direction_and_switch(placeholder_elements, final_elements, switch_to_final) {
    if (switch_to_final) $e867e2f1fb3bcc09$var$switch_elements(placeholder_elements, final_elements);
    else $e867e2f1fb3bcc09$var$switch_elements(final_elements, placeholder_elements);
}
function $e867e2f1fb3bcc09$var$switch_elements(from, to) {
    if (!from.length || !to.length) (0, $649f456f663da9fc$export$c2363754d4758444)("Cannot switch elements as from or to is empty", from, to);
    from[0].replaceWith(...to);
    for(let i = 1; i < from.length; i++)from[i].remove();
}








class $b83068cbd26dcc41$export$3be7054c61590ee3 {
    #verbose = false;
    #images_on_first_page = [];
    #default_lazyfinder = (()=>{
        const class_this = this;
        return {
            unload (image) {
                for (const element of [
                    image,
                    ...$b83068cbd26dcc41$export$e4741190ccada479(image, "source")
                ])for (const attr of [
                    "src",
                    "srcset"
                ]){
                    // I spent 30 minutes on debugging and it turns out IE11 always returns undefined for HTMLImageElementWithLoaded.srcset
                    const attribute_value = element.getAttribute(attr);
                    if (attribute_value?.length) {
                        element.dataset[attr] = attribute_value;
                        element.removeAttribute(attr);
                    }
                }
            },
            load: (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (image)=>{
                for (const element of [
                    ...$b83068cbd26dcc41$export$e4741190ccada479(image, "source"),
                    image
                ]){
                    if ("loaded" in element) {
                        if (class_this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)(element, "is already loading, not loading again");
                        continue;
                    }
                    if (document?.body?.contains?.(image) === false) {
                        if (class_this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)(element, "has been removed from the DOM, can't load");
                        const { elements: elements  } = class_this.lazyfinder;
                        const index = elements.indexOf(image);
                        if (index >= 0) elements.splice(index, 1);
                        continue;
                    }
                    const has_src = element.dataset?.src?.length;
                    const has_srcset = element.dataset?.srcset?.length;
                    if (has_src || has_srcset) {
                        if (class_this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)("Loading", element);
                        element.loaded = false;
                        // here it's of importance that we give the browser the srcset first, otherwise it (safari) might start loading the fallback src at first
                        if (has_srcset) {
                            // in Safari for some reason sometimes the .sizes attribute isn't set yet, like in https://www.notion.so/depictai/Pictures-in-recommendations-are-not-displayed-88e30e0f98de421e94b9eb273aea21dc. In that case, wait up to one event loop execution for it
                            if (!element.sizes) await new Promise((resolve)=>{
                                const mo = new MutationObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((_records)=>{
                                    if (element.sizes) {
                                        resolve();
                                        mo.disconnect();
                                    }
                                }));
                                mo.observe(element, {
                                    attributes: true,
                                    attributeFilter: [
                                        "sizes"
                                    ]
                                });
                                setTimeout((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                                    resolve(); // in case ResizeObserver doesn't set .sizes or something
                                    mo.disconnect();
                                }));
                            });
                            element.setAttribute("srcset", element.dataset.srcset);
                            element.removeAttribute("data-srcset");
                        }
                        if (has_src) {
                            element.src = element.dataset.src;
                            element.removeAttribute("data-src");
                        }
                        class_this.intersection_observer.unobserve(element);
                    } else {
                        if (element.src?.startsWith?.("data:")) continue;
                        // This happens quite often for reasons unknown. One day we will figure out why, or replace this lazyloader with a new one/native.
                        if (class_this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)("Cannot load", element, "as it doesn't have a data-src or data-srcset attribute");
                    }
                }
            }),
            get elements () {
                // define ourselves away with an array containing all elements we find. Said array is "listening" and calling unload and add_load_event_listener on every pushed element
                const lazyfinder_this = this;
                const currently_existing = [];
                Object.defineProperty(lazyfinder_this, "elements", {
                    value: currently_existing
                });
                class_this.start_observing_for_new_children_();
                return currently_existing;
            }
        };
    })();
    #initiate_new_image(image) {
        if (image.loaded === true || image.loaded === false) {
            if (this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)("Not lazyloading", image, "because it was loaded before or is loading");
            return;
        }
        (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.lazyfinder.unload)(image);
        this.#add_load_event_listener(image);
        this.intersection_observer?.observe?.(image); // observe if observer already exists, otherwise it won't and start_observer will do it
    }
    start_observing_for_new_children_(override_container) {
        // should ONLY run on our "stock" elements array and is therefore called if "elements" is get in it - which means it's being used
        // it allows us to just add elements to the observed container and have them added to the elements array if they or their children match the selector
        if (!this.container && !override_container) return;
        const container = override_container ?? this.container;
        const mutation_observer = new MutationObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((mutations)=>{
            for(let i = 0; i < mutations.length; i++){
                const matching_added_els = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(mutations[i].addedNodes, this.selector);
                if (matching_added_els.length) {
                    if (this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)("New elements", matching_added_els, " matching selector", this.selector, "were aded to", container, "lazyloading…");
                    this.lazyfinder.elements.push(...matching_added_els);
                    matching_added_els.forEach(this.#initiate_new_image.bind(this));
                }
            }
        }));
        (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(container, ({ element: element  })=>{
            const new_els = element?.querySelectorAll?.(this.selector) || [];
            this.lazyfinder.elements.push(...new_els);
            new_els.forEach(this.#initiate_new_image.bind(this));
            mutation_observer.observe(element, {
                subtree: true,
                childList: true
            });
        });
        (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(container, ({ element: element  })=>{
            if (!document.documentElement.contains(element)) mutation_observer.disconnect();
        });
    }
    #add_load_event_listener(element) {
        const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((e)=>{
            // cookiebot triggers random "load" events on all elements which make the images load before the intersection observer has started
            if (!element.src.length) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("ignoring load event", e, "because image doesn't have a src");
                return;
            }
            if (this.ignore_data_urls && element.src.startsWith("data:")) {
                if (this.#verbose) (0, $649f456f663da9fc$export$de56f1198d121036)("Ignoring load event", e, "because ignore_data_urls is truthy");
                return;
            }
            element.removeEventListener("load", handler);
            element.loaded = true;
            if (!this.only_load_intersecting) this.#check_if_first_page_has_loaded();
        });
        element.addEventListener("load", handler);
    }
    #unload_images_and_add_load_listeners() {
        const { elements: elements , unload: unload  } = this.lazyfinder;
        const caught_unload = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(unload);
        for(let i = 0; i < elements.length; i++){
            caught_unload(elements[i]);
            this.#add_load_event_listener(elements[i]);
        }
    }
    #start_observer() {
        let observers_first_call = true;
        if (!this.intersection_observer) {
            this.intersection_observer = new IntersectionObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((entries)=>{
                let any_intersected = false;
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    const target = entry.target;
                    if (entry.intersectionRatio > 0) {
                        any_intersected = true;
                        if (target.loaded == null) // if it's false it's already loading
                        this.lazyfinder.load(target);
                        if (observers_first_call) this.#images_on_first_page.push(target);
                    }
                }
                if (any_intersected) observers_first_call = false;
            }), {
                root: this.container,
                threshold: (0, $9ab9ecb74920f343$export$f8ea2e7b15b5d129)(3)
            });
            const { elements: elements  } = this.lazyfinder;
            for(let i = 0; i < elements.length; i++)this.intersection_observer.observe(elements[i]);
        }
    }
    #check_if_first_page_has_loaded() {
        const loaded_images = [];
        const not_loaded_or_loading = [];
        const { elements: elements  } = this.lazyfinder;
        for(let i = 0; i < (elements?.length ?? 0); i++)if (elements[i].loaded === true) loaded_images.push(elements[i]);
        else not_loaded_or_loading.push(elements[i]);
        if (this.#images_on_first_page.length >= loaded_images.length) {
            const caught_loading_fin = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.lazyfinder.load);
            for(let i = 0; i < not_loaded_or_loading.length; i++)caught_loading_fin(not_loaded_or_loading[i]);
        }
    }
    constructor({ container: container , lazyfinder: lazyfinder , selector: selector = [
        `img`,
        `source`
    ].map((t)=>`:not(.d-navbutton) > ${t}:not(.filler):not(.nolazy)`).join(", ") , wait_for_dominsertion: wait_for_dominsertion = true , only_load_intersecting: only_load_intersecting = false , ignore_data_urls: ignore_data_urls = false , verbose: verbose  }){
        // store options in class so class instances can be looked at and their options are transparent
        this.container = container;
        this.selector = selector;
        this.only_load_intersecting = only_load_intersecting;
        this.ignore_data_urls = ignore_data_urls;
        if (verbose) this.#verbose = true;
        // make sure we have a fully-fledged lazyfinder but still allow max customizability
        this.lazyfinder = lazyfinder ||= this.#default_lazyfinder;
        lazyfinder.unload ||= this.#default_lazyfinder.unload;
        lazyfinder.load ||= this.#default_lazyfinder.load;
        if (!("elements" in lazyfinder)) Object.defineProperty(lazyfinder, "elements", Object.getOwnPropertyDescriptor(this.#default_lazyfinder, "elements"));
        this.#unload_images_and_add_load_listeners();
        // check if we need to branch off to an async function and wait for the elements being in the DOM
        if (wait_for_dominsertion) {
            const caught_start_obs = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#start_observer).bind(this);
            if (wait_for_dominsertion instanceof Promise) wait_for_dominsertion.then(caught_start_obs);
            else {
                const el_to_listen_on = container || lazyfinder?.elements?.[0];
                if (el_to_listen_on instanceof Node) (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(el_to_listen_on).then(caught_start_obs);
                else (0, $649f456f663da9fc$export$de56f1198d121036)("Could not find element to attach event listener to", ()=>{}); // right click function in inspector and select "jump to definition" to get here
            }
        } else this.#start_observer();
    }
}
function $b83068cbd26dcc41$export$b87d7e0da8b5cbe3() {
    let supports = false;
    try {
        const proxied_array = new Proxy([], {
            set: ()=>supports = true
        });
        proxied_array.push(1);
    } catch (e) {}
    return supports;
}
function $b83068cbd26dcc41$export$e4741190ccada479(element, selector) {
    const result = [];
    // this is made to return things in the same order as the browser prioritises <source> elements
    const children = element?.parentElement?.children;
    for(let i = 0; i < (children?.length ?? 0); i++){
        const selected_element = children[i];
        if (selected_element?.matches?.(selector)) result.push(selected_element);
    }
    return result;
}









const $b9b0dba897847b2a$export$eb0b9ed911409b57 = (callback, element)=>((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(callback)(element), element);
function $b9b0dba897847b2a$export$f63fcc839cb0f734(event, handler, element) {
    element.addEventListener(event, (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(handler));
    return element;
}
const $b9b0dba897847b2a$export$22a65337c1b43b1f = /* @PURE */ (classes)=>classes.filter((c)=>c !== undefined).join(" ");


const $63cbb5de51d11596$var$appendChild = (parent, child)=>{
    if (!child) return; // null, undefined, false, "", etc should not create nodes
    if (!(child instanceof Node || typeof child === "string") && typeof child[Symbol.iterator] === "function") {
        if (child.length !== undefined) // it's array-like enough to be iterated with a normal for loop (for-of is 20% of that speed)
        for(let i = 0; i < child.length; i++)$63cbb5de51d11596$var$appendChild(parent, child[i]);
        else // fallback for things only implementing iterator interface
        for (const more_kids of child)$63cbb5de51d11596$var$appendChild(parent, more_kids);
        return;
    }
    parent.append(child);
};
const $63cbb5de51d11596$export$34b9dba7ce09269b = (tag, { children: children , ...props }, _unknown)=>{
    if (typeof tag === "function") return tag({
        children: children,
        ...props
    }, _unknown);
    // For partial SVG support
    // Exhaustive list (I think) for these checks should be ["svg","animate","animateMotion","animateTransform","circle","clipPath","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","foreignObject","g","image","line","linearGradient","marker","mask","metadata","path","pattern","polygon","polyline","radialGradient","rect","stop","switch","symbol","text","textPath","tspan","use","view"]
    const is_svg = props?.xmlns || tag == "defs" || tag == "filter" || tag == "fecolormatrix" || tag == "g" || tag == "circle" || tag == "circle" || tag == "svg" || tag == "path" || tag == "polygon";
    if (is_svg) var namespace = props?.xmlns || "http://www.w3.org/2000/svg";
    if (typeof document === "undefined") return {};
    const element = is_svg ? document.createElementNS(namespace, tag) : document.createElement(tag);
    for(const key in props){
        const value = props[key];
        if (key === "onClick") element.addEventListener("click", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(value));
        else if (key.startsWith("xlink:")) // https://stackoverflow.com/a/23142447
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Namespaces_Crash_Course
        element.setAttributeNS("http://www.w3.org/1999/xlink", key, value);
        else if (key == "xmlns" || key.startsWith("xmlns:")) element.setAttributeNS("http://www.w3.org/2000/xmlns/", key, value);
        else if (key.startsWith("xml:")) element.setAttributeNS("http://www.w3.org/XML/1998/namespace", key, value);
        else element.setAttribute(key, props[key]);
    }
    $63cbb5de51d11596$var$appendChild(element, children);
    return element;
};
const $63cbb5de51d11596$export$25062201e9e25d76 = $63cbb5de51d11596$export$34b9dba7ce09269b;
const $63cbb5de51d11596$export$ffb0004e005737fa = ({ children: children  }, _unknown)=>{
    if (typeof document === "undefined") return {};
    const df = document.createDocumentFragment();
    $63cbb5de51d11596$var$appendChild(df, children);
    return df;
};


class $ef9394fafebd5eab$export$692b27c28639e5b9 {
    // this is just here because it's often needed together with the slider
    container = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
        class: "depict-slider depict"
    });
    #elements = {
        sliding_el_: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            class: "sliding"
        }),
        left_: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("button", {
            "aria-label": "Scroll left",
            class: "left d-navbutton",
            type: "button"
        }),
        right_: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("button", {
            "aria-label": "Scroll right",
            class: "right d-navbutton",
            type: "button"
        })
    };
    insert_here = this.#elements.sliding_el_;
    intersecting_items_object = {};
    #mutation_plugins = [];
    stepstoslide = 2;
    dist_to_hide_left = 10;
    dist_to_hide_right = 10;
    center_target = false;
    correct_bs_targets = true;
    on_elements_changed = [
        this.#observe_element
    ];
    #index_cache = {
        last_el_: undefined,
        number_to_el_: new Map(),
        el_to_number_: new Map()
    };
    #cached_visible_sizes;
    #observe_element(records) {
        const { observer: observer  } = this;
        const { sliding_el_: sliding_el_  } = this.#elements;
        for (const record of records){
            for (const node of record.addedNodes)if (node instanceof Element && node.parentElement === sliding_el_) observer.observe(node);
            for (const node of record.removedNodes)if (node instanceof Element && node.parentElement === sliding_el_) observer.unobserve(node);
        }
    }
    #observer_callback(entries) {
        const intersecting_items = this.intersecting_items_object;
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const { target: target  } = entry;
            const rec_idx = this.get_index_of_element(target);
            if (entry.intersectionRatio <= 0) {
                for(const key in intersecting_items)if (intersecting_items[key].target === target) delete intersecting_items[key];
            } else if (rec_idx != null) intersecting_items[rec_idx] = entry;
            else (0, $649f456f663da9fc$export$de56f1198d121036)("Could not find index of", target, "ignoring observer record");
        }
        (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#hide_buttons_if_needed).call(this);
        const mutation_plugins = this.#mutation_plugins;
        for(let i = 0; i < mutation_plugins.length; i++)(0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(mutation_plugins[i]).call(this, entries, intersecting_items);
    }
    observer = new IntersectionObserver(this.#observer_callback.bind(this), {
        root: this.#elements.sliding_el_,
        threshold: (0, $9ab9ecb74920f343$export$f8ea2e7b15b5d129)(100)
    });
    observe = this.observer.observe.bind(this.observer);
    get_index_of_element(target) {
        const { el_to_number_: el_to_number_  } = this.#index_cache;
        const value_from_cache = el_to_number_.get(target);
        if (value_from_cache) return value_from_cache;
        const children = target?.parentElement?.children;
        if (children) {
            const children_as_array = [
                ...children
            ];
            const index = children_as_array.indexOf(target);
            el_to_number_.set(target, index);
            return index;
        }
    }
    #hide_buttons_if_needed() {
        // it should be correct that this routine is using sliding_el because for the buttons the position of the first and last element to the main container is relevant
        const cont = this.#elements.sliding_el_, lastel = this.index_of_last_element, cont_rect = cont.getBoundingClientRect(), is = this.intersecting_items_object;
        let dist_to_left;
        if (is[0] && is[0]?.intersectionRatio < 0.9) // the intersection observer won't trigger again FOR THE LEFT IMAGE when we're very far to the left, this works around that
        dist_to_left = is[0].boundingClientRect.left - cont_rect.left;
        else {
            const first_element = this.element_by_index(0);
            if (first_element) dist_to_left = first_element.getBoundingClientRect().left - cont_rect.left; // need to check anyways because some very violent scrolls will make the buttons go missing otherwise
            else // slider is empty
            dist_to_left = 0;
        }
        if (dist_to_left >= -this.dist_to_hide_left) this.#visibility(this.#elements.left_, 0);
        else this.#visibility(this.#elements.left_, 1);
        const rightmost_edge_of_last_card = Math.floor((this.element_by_index(lastel) || this.#elements.sliding_el_).getBoundingClientRect().right);
        const rightmost_edge_of_container = cont_rect.right, dist_to_right = rightmost_edge_of_last_card - rightmost_edge_of_container;
        // dlog("dist to right", dist_to_right, "dist to left", dist_to_left);
        if (dist_to_right <= this.dist_to_hide_right) this.#visibility(this.#elements.right_, 0);
        else this.#visibility(this.#elements.right_, 1);
    }
    first_intersecting_index(min_ratio = 0.5) {
        return parseInt(Object.keys(this.intersecting_items_object).find((i)=>this.intersecting_items_object[i].intersectionRatio > min_ratio) || "");
    }
    get first_intersecting() {
        return this.intersecting_items_object[this.first_intersecting_index()];
    }
    get index_of_last_element() {
        return this.#index_cache.last_el_ ??= (this.first_intersecting?.target?.parentElement?.children?.length ?? // this is for plantagen which has a double whammy slider
        this.#elements?.sliding_el_?.children?.length) - 1;
    }
    get currently_selected() {
        // this tries to be what distance_to assumes is the current card when converting a relative offset into an absolute one, available for plugins
        if (this.center_target) {
            // try to find index of card under container center
            const { visible_sizes: visible_sizes  } = this;
            let left_offset = 0;
            const rectangle_of_container = this.#elements.sliding_el_.getBoundingClientRect();
            const middle_of_container = rectangle_of_container.width / 2;
            for (const [element, info] of visible_sizes){
                left_offset += info.total_visible;
                if (left_offset >= middle_of_container) // we found the card that's under the center!
                return this.get_index_of_element(element);
            }
        } else return this.first_intersecting_index(0.9);
    }
    #distance_to(offset, is_absolute = false) {
        const intersecting_items = this.intersecting_items_object; // the privateFieldGet babel polyfill isn't very fast so for extra snappyness I won't get it multiple times
        (0, $649f456f663da9fc$export$de56f1198d121036)("intersecting_items", intersecting_items);
        // I know I could have made this.intersecting_items_object a simple array instead, but maybe someone needs the boundingrect information in it some day. Also I thought I could use it, but it isn't always up to date due to the intersection observer not triggering on every scrolling move.
        // Now, some months later: the triggering frequency can easily be adjusted, the problem is that the observer doesn't trigger on hidden elements, meaning when scrolling left we don't have information about the hidden element's position from the observer
        let target; // absolute index to focus on
        if (is_absolute) target = offset;
        else if (this.center_target) {
            const { currently_selected: currently_selected  } = this;
            if (currently_selected == null) {
                // if for whatever reason we don't find a card, don't do anything
                (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(new Error("can't find card in center"), "error");
                return 0;
            }
            target = currently_selected + offset;
        } else {
            let index_of_first_intersecting;
            // we don't want the first one to count as intersecting just because it's 20% visible
            if (offset < 0) {
                index_of_first_intersecting = this.first_intersecting_index(0.9);
                if (isNaN(index_of_first_intersecting)) index_of_first_intersecting = this.first_intersecting_index(); // if this doesn't yield element, try to get all
            } else index_of_first_intersecting = this.first_intersecting_index();
            target = +index_of_first_intersecting + offset;
        }
        target = Math.floor(target);
        let dist;
        (0, $649f456f663da9fc$export$de56f1198d121036)("trying to focus target", target);
        let target_element = this.element_by_index(target);
        if (!target_element) {
            if (this.correct_bs_targets) {
                if (isNaN(target)) {
                    (0, $649f456f663da9fc$export$de56f1198d121036)("target is not a number", target, "can't correct");
                    return 0;
                } else if (target < 0) {
                    (0, $649f456f663da9fc$export$de56f1198d121036)("Target", target, "is < 0, correcting to 0 because correct_bs_targets is enabled");
                    target = 0;
                    target_element = this.element_by_index(target);
                    if (!target_element) {
                        (0, $649f456f663da9fc$export$de56f1198d121036)("can't find element 0");
                        return 0;
                    }
                } else {
                    (0, $649f456f663da9fc$export$de56f1198d121036)("target", target, "does not exist, correcting to last sliding element \uD83E\uDD2D");
                    target = this.index_of_last_element;
                    target_element = this.element_by_index(target);
                    if (!target_element) {
                        (0, $649f456f663da9fc$export$de56f1198d121036)("last element", target, "could not be found");
                        return 0;
                    }
                }
            } else {
                (0, $649f456f663da9fc$export$de56f1198d121036)("target is bs, can't find", target, "by either data-index attribute or as child of", this.#elements.sliding_el_);
                return 0;
            }
        }
        const rectangle_of_target = target_element.getBoundingClientRect();
        const distance_of_li = rectangle_of_target.left + target % 1 * rectangle_of_target.width;
        const rectangle_of_container = this.#elements.sliding_el_.getBoundingClientRect();
        const distance_of_container = rectangle_of_container.left;
        dist = distance_of_li - distance_of_container;
        if (this.center_target) try {
            const { visible_sizes: visible_sizes  } = this;
            const keys = [
                ...visible_sizes.keys()
            ];
            const middle_value_index = Math.floor(visible_sizes.size / 2);
            const target_card = keys[middle_value_index];
            const target_info = visible_sizes.get(target_card);
            const coords_of_container_center = distance_of_container + rectangle_of_container.width / 2;
            const coords_of_chosen_card_center = target_info.rect.left + target_info.rect.width / 2;
            dist = coords_of_chosen_card_center - coords_of_container_center;
            const num_cards_off_target = target - this.get_index_of_element(target_card);
            if (num_cards_off_target !== 0) {
                const biggest_card = Math.max(...[
                    ...visible_sizes.values()
                ].map((s)=>s.total_visible));
                dist += biggest_card * num_cards_off_target;
            }
        } catch (e) {
            (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
        }
        return dist;
    }
    get visible_sizes() {
        if (this.#cached_visible_sizes) return this.#cached_visible_sizes;
        const visible_sizes = new Map();
        const visible_cards = Object.keys(this.intersecting_items_object).map((key)=>+key);
        const to_calculate = [
            visible_cards[0] - 1,
            ...visible_cards,
            visible_cards[visible_cards.length - 1] + 1
        ].map((index)=>this.element_by_index(+index)).filter((e)=>e);
        const root_el = this.#elements.sliding_el_;
        const root = root_el.getBoundingClientRect();
        const root_computed_style = getComputedStyle(root_el);
        const root_left = root.left - parseInt(root_computed_style.marginLeft);
        const root_right = root.right + parseInt(root_computed_style.marginRight);
        // const root_width = root_right - root_left;
        // this.#visualize(root_left + "px", "green");
        // this.#visualize(root_right + "px", "red");
        for(let i = 0; i < to_calculate.length; i++){
            const element = to_calculate[i];
            if (!element) continue;
            const card = element.getBoundingClientRect();
            const card_computed_style = getComputedStyle(element);
            const marginLeft = parseInt(card_computed_style.marginLeft);
            const marginRight = parseInt(card_computed_style.marginRight);
            const card_left = card.left - marginLeft;
            const card_right = card.right + marginRight;
            // this.#visualize(card_left + "px", "rgba(255,0,0,0.5)");
            // this.#visualize(card_right + "px", "rgba(0,255,0,0.5)");
            const actual_left_diff = root_left - card_left;
            const left_diff = actual_left_diff > 0 ? actual_left_diff : 0;
            const actual_right_diff = card_right - root_right;
            const right_diff = actual_right_diff > 0 ? actual_right_diff : 0;
            const intersecting_line = card_right - card_left - left_diff - right_diff;
            if (intersecting_line < 0) continue;
            visible_sizes.set(element, {
                total_visible: intersecting_line,
                get ratio_visible () {
                    const card_width = card_right - card_left;
                    return intersecting_line / card_width;
                },
                margin_left: marginLeft,
                margin_right: marginRight,
                rect: card
            });
        }
        this.#cached_visible_sizes = visible_sizes;
        // let's assume we can cache this for a tick since the slider scrolls smoothly so there's no point in reading it instantly again and assuming a different value
        queueMicrotask((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>this.#cached_visible_sizes = undefined));
        return visible_sizes;
    }
    get cards_fitting_in_viewport() {
        // we can't use intersectionRatio since it's a) also in the y-axis and b) doesn't contain borders and margins
        const visible_sizes = [
            ...this.visible_sizes.values()
        ].map((e)=>e.total_visible);
        const max = Math.max(...visible_sizes);
        const min1 = Math.min(...visible_sizes);
        visible_sizes.splice(visible_sizes.indexOf(min1), 1);
        const min2 = Math.min(...visible_sizes);
        visible_sizes.splice(visible_sizes.indexOf(min2), 1);
        if (min1 + min2 <= max) visible_sizes.push(min1 + min2);
        else visible_sizes.push(min1, min2);
        return visible_sizes.length;
    }
    // #visualize(left: string, color: string) {
    //   const div = document.createElement("div");
    //   div.style.position = "fixed";
    //   div.style.top = "50vh";
    //   div.style.left = left;
    //   div.style.width = "1px";
    //   div.style.height = "10cm";
    //   div.style.background = color;
    //   document.body.append(div);
    //   setTimeout(() => div.remove(), 1000);
    // }
    element_by_index(index) {
        const from_cache = this.#index_cache.number_to_el_.get(index);
        if (from_cache) return from_cache;
        const { sliding_el_: sliding_el_  } = this.#elements;
        let maybe_el = [
            ...sliding_el_?.children || []
        ]?.[index];
        if (!maybe_el) // this is for plantagen which has a double whammy slider
        maybe_el = [
            ...this.first_intersecting?.target?.parentElement?.children || []
        ]?.[index];
        this.#index_cache.number_to_el_.set(index, maybe_el);
        return maybe_el;
    }
    #visibility(element, should_be_visible) {
        const ishidden = element.classList.contains("hidden");
        if (should_be_visible && ishidden) element.classList.remove("hidden");
        else if (!should_be_visible && !ishidden) element.classList.add("hidden");
    }
    #setup_buttons() {
        const goleft = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>this.#scroll_to(-this.stepstoslide, false, -510));
        const goright = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>this.#scroll_to(this.stepstoslide, false, 510));
        const { right_: right_ , left_: left_  } = this.#elements;
        left_.addEventListener("click", goleft);
        right_.addEventListener("click", goright);
        [
            left_,
            right_
        ].forEach((button)=>{
            button.addEventListener("dragstart", (e)=>(e.preventDefault(), false));
        });
    }
    #create_element_structure(autoinvalidate = true) {
        const es = this.#elements;
        this.#setup_buttons();
        this.container.append(es.left_, es.right_);
        this.container.append(es.sliding_el_);
        if (autoinvalidate) {
            const cache_mo = new MutationObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
                this.invalidate_cache();
                for (const extra_fn of this.on_elements_changed)extra_fn.call(this, records);
            }));
            (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(es.sliding_el_, ({ element: element  })=>{
                this.invalidate_cache();
                cache_mo.observe(element, {
                    childList: true,
                    subtree: true
                });
                for (const kid of element.children)this.observer.observe(kid);
                (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_listener("removed", element).then(()=>cache_mo.disconnect());
            });
        }
    }
    invalidate_cache() {
        // dlog("Invalidating index cache");
        this.#index_cache.number_to_el_.clear();
        this.#index_cache.el_to_number_.clear();
        this.#index_cache.last_el_ = undefined;
    }
    #scroll_to(offset1, is_absolute1 = false, fallback_scroll_distance = 500, harsh = false) {
        const left = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#distance_to).call(this, offset1, is_absolute1);
        const distance_after_fallback_applied = Math.round(left ?? fallback_scroll_distance);
        if (getComputedStyle(this.#elements.sliding_el_).scrollSnapType !== "none" && Math.abs(distance_after_fallback_applied) < 10) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Not scrolling because snapping is enabled and distance not over threshold", distance_after_fallback_applied);
            return;
        }
        (0, $649f456f663da9fc$export$de56f1198d121036)("Trying to scroll by", left, "px", "before fallback,", distance_after_fallback_applied, "after");
        this.#elements.sliding_el_.scrollBy({
            left: distance_after_fallback_applied,
            top: 0,
            behavior: harsh ? "auto" : "smooth"
        });
    }
    scroll_to_rel(offset, harsh = false) {
        this.#scroll_to(offset, false, undefined, harsh);
    }
    scroll_to_abs(offset, harsh = false) {
        this.#scroll_to(offset, true, undefined, harsh);
    }
    constructor({ dist_to_hide_left: dist_to_hide_left , dist_to_hide_right: dist_to_hide_right , stepstoslide: stepstoslide , center_target: center_target , mutation_plugins: mutation_plugins , constructor_plugins: constructor_plugins , correct_bs_targets: correct_bs_targets , button_contents: button_contents , button_elems: button_elems , autoinvalidate_cache: autoinvalidate_cache  }){
        dist_to_hide_left && (this.dist_to_hide_left = dist_to_hide_left);
        dist_to_hide_right && (this.dist_to_hide_right = dist_to_hide_right);
        stepstoslide && (this.stepstoslide = stepstoslide);
        center_target && (this.center_target = true);
        mutation_plugins && (this.#mutation_plugins = mutation_plugins);
        correct_bs_targets == false && (this.correct_bs_targets = correct_bs_targets);
        if (button_elems) {
            this.#elements.right_ = button_elems.right;
            this.#elements.left_ = button_elems.left;
        }
        if (button_contents?.right) this.#elements.right_.append(...button_contents.right);
        if (button_contents?.left) this.#elements.left_.append(...button_contents.left);
        (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(this.#create_element_structure).call(this, autoinvalidate_cache);
        // @ts-ignore
        this.#elements.sliding_el_.slider = this; // dunno if this is dumb? So far nordicagolf/kondomvaruhuset depend on it
        // plugin functionality i.e. for dots
        const constructor_args = arguments;
        constructor_plugins?.forEach?.((mplugin)=>{
            (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(mplugin).call(this, constructor_args);
        });
    }
}





class $c33c6faf8acc7442$export$68babfc5be0de5da extends (0, $ef9394fafebd5eab$export$692b27c28639e5b9) {
    constructor(options, lazyfier_options){
        super(options);
        const lazy_promise = new Promise((r)=>{
            (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(this.insert_here, ({ element: element , disconnector: disconnector  })=>{
                const i_o = new IntersectionObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
                    for (const record of records)if (record.intersectionRatio > 0) {
                        r(true);
                        i_o.disconnect();
                        disconnector();
                        return;
                    }
                }), // Fixes https://gitlab.com/depict-ai/depict.ai/-/merge_requests/5816/diffs, don't understand why
                {
                    threshold: (0, $9ab9ecb74920f343$export$f8ea2e7b15b5d129)(10)
                });
                i_o.observe(element);
            });
        });
        this.lazyfier = new (0, $b83068cbd26dcc41$export$3be7054c61590ee3)({
            container: this.insert_here,
            wait_for_dominsertion: lazy_promise,
            ...lazyfier_options || {}
        });
    }
}







const $c1503704e45e6a15$export$f37c58ab3d3e3b75 = [
    $c1503704e45e6a15$export$9e1caada6901f552,
    (0, $405969d60b37fdac$export$d0efd8ed14f5c33),
    $c1503704e45e6a15$export$fb9afe9f540ae069,
    ...process.env.GTAG_VIEW === "true" ? [
        $c1503704e45e6a15$export$1bffac19f9f0d6fc
    ] : []
];
const $c1503704e45e6a15$export$6830ae1fbe21e589 = [
    $c1503704e45e6a15$export$e9106d6e723510d2,
    $c1503704e45e6a15$export$32eb5dd18e963410,
    (0, $61b3c9e5f2cf8171$export$58c56fe2313fdbe3),
    ...process.env.GTAG === "true" ? [
        $c1503704e45e6a15$export$8d72437623fef90c
    ] : []
];
const $c1503704e45e6a15$export$ed8a68dacd075983 = /*@__PURE__*/ new Map();
const $c1503704e45e6a15$export$4b50a4de9c6bbe09 = /*@__PURE__*/ new WeakSet();
function $c1503704e45e6a15$export$fb9afe9f540ae069(elements, _display, info) {
    if (!elements?.length) return elements;
    if (!info.t) return elements;
    const elements_as_array = [
        ...elements
    ];
    const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ()=>{
        const { rendering_options: rendering_options , t: t  } = info;
        if (!$c1503704e45e6a15$export$4b50a4de9c6bbe09.has(rendering_options) && elements_as_array.some((e)=>document.documentElement.contains(e)) // check, just in case
        ) {
            $c1503704e45e6a15$export$4b50a4de9c6bbe09.add(rendering_options);
            (0, $43683b1103edab15$export$82badda1f9923310)({
                ...t,
                product_id: await t.get_product_id(),
                recommendation_type: info.rendering_options.type,
                type: "recommendations_inserted"
            });
        }
    });
    $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$fb9afe9f540ae069, handler);
    const first_el = elements_as_array?.[0];
    if (first_el instanceof Node) (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(first_el).then(handler);
    return elements;
}
const $c1503704e45e6a15$export$3777a14dd8c2363d = /*@__PURE__*/ new WeakSet();
function $c1503704e45e6a15$export$1bffac19f9f0d6fc(elements, _display, info) {
    if (!elements?.length) // don't make it hurt even more that rendering failed
    return elements;
    if (!info.t) // GTAG tracking is deprecated, if we're doing no-tenant recommendation rendering it's SDK anyway.
    return elements;
    const [first_element] = elements;
    const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
        const { rendering_options: rendering_options , displays: displays  } = info;
        if (!$c1503704e45e6a15$export$3777a14dd8c2363d.has(displays)) {
            $c1503704e45e6a15$export$3777a14dd8c2363d.add(displays);
            const { get_product_id: get_product_id  } = info.t;
            const { type: type  } = rendering_options;
            (0, $c749fe63b72056ef$export$7babcd5d4056b2ca)(displays, get_product_id /* yes this might create errors if there's no page_url in the display but don't have time to fix, sorry */ , {
                list_name: "depict_" + type
            });
        }
    });
    $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$1bffac19f9f0d6fc, handler);
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(first_element, handler);
    return elements;
}
function $c1503704e45e6a15$export$9e1caada6901f552(elements, _display, info) {
    const { t: t  } = info;
    if (!t) return elements;
    (async ()=>{
        (0, $aa0140679dc70b7a$export$eee4c4d924348b05)({
            tenant: t.tenant,
            market: t.market,
            product_id: await t.get_product_id()
        }).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    })();
    return elements;
}
function $c1503704e45e6a15$export$8d72437623fef90c(elements, display, info) {
    const handler = ()=>{
        const { ga_product_ids: ga_product_ids , ga_product_id: ga_product_id , product_id: product_id  } = display;
        if (Array.isArray(ga_product_ids)) for(let i = 0; i < ga_product_ids.length; i++)(0, $c749fe63b72056ef$export$f522672c9379e339)(ga_product_ids[i], info.index, {
            list_name: "depict_" + info.rendering_options.type
        });
        else (0, $c749fe63b72056ef$export$f522672c9379e339)(ga_product_id || product_id, info.index, {
            list_name: "depict_" + info.rendering_options.type
        });
    };
    $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$8d72437623fef90c, handler);
    info.register_event_listener("click", handler, {
        once: true
    });
    return elements;
}
function $c1503704e45e6a15$export$e9106d6e723510d2(elements, display, info) {
    const handler = ()=>{
        const { t: t , index: index , rendering_options: rendering_options  } = info;
        return (0, $43683b1103edab15$export$15f8a0cd5a8c0ebb)({
            ...t,
            ...rendering_options,
            ...display,
            click_location: rendering_options.type + "_" + (index + 1),
            recommendation_type: rendering_options.type,
            product_id: "variant_index" in display ? display.variant_displays[display.variant_index].product_id : display.product_id
        });
    };
    $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$e9106d6e723510d2, handler);
    info.register_event_listener("click", handler, {
        once: true
    });
    return elements;
}
function $c1503704e45e6a15$export$32eb5dd18e963410(elements, display, info) {
    const { search_result_id: search_result_id  } = display;
    const { product_id: product_id , recommendation_id: recommendation_id  } = "variant_index" in display ? display.variant_displays[display.variant_index] : display;
    if (!elements?.length) return elements;
    for (const element of elements){
        const handler = (0, $91b2e49f92ed636c$export$82a685f2da2fb027)(element, product_id, recommendation_id || search_result_id);
        if (handler) $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$32eb5dd18e963410, handler);
    }
    return elements;
}
function $c1503704e45e6a15$export$dd32cb565eae0a1f(elements, display, info) {
    const handler = ()=>{
        (0, $c749fe63b72056ef$export$127751e82111fcf)();
    };
    $c1503704e45e6a15$var$push_function($c1503704e45e6a15$export$dd32cb565eae0a1f, handler);
    info.register_event_listener("click", handler, {
        once: true
    });
    return elements;
}
function $c1503704e45e6a15$var$push_function(fn1, handler) {
    const fn_array = $c1503704e45e6a15$export$ed8a68dacd075983.get(fn1) || [];
    fn_array.push(new WeakRef(handler));
    $c1503704e45e6a15$export$ed8a68dacd075983.set(fn1, fn_array);
}



const $893f9af5dbae6bc8$export$deca40f48c0569f8 = typeof window === "undefined" ? false : /*@__PURE__*/ localStorage.getItem("colorize-logics") === "true";
function $893f9af5dbae6bc8$export$16501883f477737a(elements, display) {
    elements.forEach((elem)=>{
        if (elem.nodeType !== Node.TEXT_NODE) {
            // calc a hash for given string
            const hc = (str = "")=>{
                let hash = 0;
                if (str.length === 0) return hash;
                for(let i = 0; i < str.length; i++){
                    const chr = str.charCodeAt(i);
                    hash = (hash << 5) - hash + chr;
                    hash |= 0;
                }
                return hash;
            };
            const hash = hc(display.logic);
            // Change hue based on hash
            const color = "hsl(" + hash % 360 + ",100%,75%)";
            if ("style" in elem) elem.style.background = color;
            // @ts-ignore
            elem?.setAttribute?.("data-logic", display.logic);
            // @ts-ignore
            elem?.setAttribute?.("title", "Logic: " + display.logic);
        }
    });
    return elements;
}


var $6be99244fa573db5$export$2e2bcd8739ae039 = $6be99244fa573db5$export$50ce83ace0cdd87e;
async function $6be99244fa573db5$export$50ce83ace0cdd87e(t, rendering_options) {
    const { view_tracking: view_tracking , click_tracking: click_tracking  } = rendering_options;
    return await (0, $5cbe24d064a033ed$export$a9fc160c5ed83bd7)(t, {
        ...rendering_options,
        headers: {
            ...(0, $893f9af5dbae6bc8$export$deca40f48c0569f8) ? {
                "x-debug": "true"
            } : {},
            ...rendering_options.headers || {}
        },
        pre_processors: [
            ...rendering_options.pre_processors || []
        ],
        post_processors: [
            ...Array.isArray(view_tracking) ? view_tracking : (0, $c1503704e45e6a15$export$f37c58ab3d3e3b75),
            ...Array.isArray(click_tracking) ? click_tracking : (0, $c1503704e45e6a15$export$6830ae1fbe21e589),
            ...(0, $893f9af5dbae6bc8$export$deca40f48c0569f8) ? [
                (0, $893f9af5dbae6bc8$export$16501883f477737a)
            ] : [],
            ...rendering_options.post_processors || []
        ]
    });
}



async function $7e2d59b061c2c528$export$cab8bc58c64c2013(t, rendering_options, options_for_us, slider_options) {
    options_for_us ||= {};
    const { root_selector: root_selector , override_rec_renderer: local_rr = (0, $6be99244fa573db5$export$2e2bcd8739ae039) , insertion_verb: insertion_verb = "replaceWith" , lazyfier_options: lazyfier_options  } = options_for_us;
    let { container: container  } = options_for_us;
    if (typeof container == "string") container = [
        ...(0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583)(container)
    ];
    if (container && !Array.isArray(container)) container = [
        ...container
    ];
    const slider = new (0, $c33c6faf8acc7442$export$68babfc5be0de5da)({
        dist_to_hide_left: 10,
        dist_to_hide_right: 10,
        ...slider_options
    }, lazyfier_options);
    const recs = await local_rr(t, {
        ...rendering_options,
        post_processors: [
            (elements, display)=>{
                (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(elements, ".rec_outer").forEach((ro)=>ro.classList.add("noautospacing"));
                return elements;
            },
            ...rendering_options.post_processors || []
        ]
    });
    if (!recs.elements) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Pro_Slider says bye bye cuz no recs");
        return {};
    }
    slider.insert_here.append(...recs.elements);
    if (container) {
        const [root] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container, root_selector || ".grid");
        root[insertion_verb](slider.container);
    }
    return {
        ...recs,
        displays: recs.displays,
        elements: container ? container : [
            slider.container
        ]
    };
}






const $366fff12da348e66$var$discountMatcher = /{DISCOUNT{([\s\S]+?)}}/g;
const $366fff12da348e66$var$noDiscountMatcher = /{NODISCOUNT{([\s\S]+?)}}/g;
let $366fff12da348e66$var$pageview_sent = false;
class $366fff12da348e66$export$1a8782481a9af507 {
    constructor(settings){
        this.settings = settings;
    }
    #dispatched_recs_inserted = false;
    init(callback, existingDisplays) {
        if (!this.settings.DNT) this.trackPageView();
        if (!existingDisplays) this.loadRecommendations(callback);
        else {
            this.data = existingDisplays;
            callback();
        }
    }
    loadRecommendations(callback) {
        const { tenant: tenant , product_id: product_id , type: type , market: market  } = this.settings;
        (0, $2d47b009af5bc0a4$export$1bc0df10745d5412)(// @ts-ignore - Quick workaround, as we don't have a tenant object here
        {
            tenant: tenant,
            market: market
        }, {
            type: type,
            product_id: product_id()
        }).then((recs)=>{
            this.data = recs;
            (0, $66b898e9bfcef532$export$8582cf3716962dc2)({
                ...this.settings,
                recs: this.data,
                min_recs: this.settings.min_items || this.settings.max_items
            });
        }).catch((e)=>{
            if (this.settings.debug) console.warn("template-tool: error fetching: ", e);
        }).finally(()=>callback());
    }
    trackGAEvent(action, index, product_id, ga_product_ids) {
        if (this.settings.sendGa === false) return;
        if (typeof ga !== "function") {
            console.log("Could not send", action, "to GA. analytics.js not loaded.");
            return;
        }
        if (!action || action instanceof Event) action = "rec_bar_click";
        if (action == "rec_bar_click" && typeof index != "undefined" && product_id) {
            if (Array.isArray(ga_product_ids)) for (const id of ga_product_ids)(0, $c749fe63b72056ef$export$f522672c9379e339)(id, index, {
                list_name: "depict_" + this.settings.type
            });
            else (0, $c749fe63b72056ef$export$f522672c9379e339)(product_id, index, {
                list_name: "depict_" + this.settings.type
            });
        }
        if (this.tracker === undefined) this.tracker = ga("create", this.settings.gaid, "auto", "depict");
        (0, $c749fe63b72056ef$export$f75172d2e289cd02)(action);
    }
    trackPageView() {
        if ($366fff12da348e66$var$pageview_sent) {
            if (this.settings.debug) console.log("template-tool: not sending page view tracking to depict as it has already been sent");
            return;
        }
        $366fff12da348e66$var$pageview_sent = true;
        const { product_id: product_id  } = this.settings;
        (0, $aa0140679dc70b7a$export$eee4c4d924348b05)(typeof product_id === "function" ? product_id() : product_id);
    }
    trackClick(index) {
        const item = this.data[index];
        if (item === undefined) return;
        return (0, $43683b1103edab15$export$15f8a0cd5a8c0ebb)({
            ...this.settings,
            ...item,
            click_location: `${this.settings.type}_${index + 1}`,
            product_id: item.product_id || this.settings.product_id(item.page_url)
        });
    }
    trackAddToCart(pId) {
        return (0, $43683b1103edab15$export$9028351cb994757e)({
            ...this.settings,
            product_id: pId && !(pId instanceof Event) ? pId : this.settings.product_id()
        });
    }
    createContainer(root, container, prepend = false) {
        function htmlToElements(html) {
            const template = document.createElement("template");
            template.innerHTML = html;
            return template.content.childNodes;
        }
        const elements = Array.from(htmlToElements(container));
        if (prepend) {
            elements.reverse();
            for (const el of elements)root.prepend(el);
        } else for (const el of elements)root.appendChild(el);
    }
    renderTemplate({ prep: prep , root: root , template: template , itemPreprocessor: itemPreprocessor , itemPostprocessor: itemPostprocessor  } = this.settings) {
        if (document._depict_modify !== true) {
            if (this.settings.debug) console.warn("Template-tool: not running because document._depict_modify is false!", this);
            return;
        }
        if (!this.data) return;
        const product_id_at_rendering = this.settings.product_id();
        if (typeof prep === "function") prep();
        const interpolator = (t)=>{
            return function(item) {
                // Conditional statements
                // {if VAR_NAME}
                //    print this if true
                // {else}
                //    print this if false
                // {end}
                // Note: these can't be nested
                t = t.replace(/{if\s+(.+?)}([\S\s]*?)(?:{else}([\S\s]*?))?{end}/g, (_, variable, if_yes, if_no)=>{
                    if (typeof if_no !== "string") // if_no is a number if there's no {else} statement
                    if_no = "";
                    return item[variable] ? if_yes : if_no;
                });
                return t.replace(/\${(.*?)}/g, (_, g)=>item[g]); // this is copied from here, I hope I'm not breaking any licenses. Need it to transpile for IE11 compatiblity: https://github.com/mikemaccana/dynamic-template/blob/master/index.js
            // if you need variables that go over multiple lines:
            // const matcher = /\${([^}]+)}/g;
            };
        };
        const elementsFromHTML = (html)=>new DOMParser().parseFromString(html, "text/html").body.children;
        const getContent = ()=>{
            const recsArray = [];
            const resultingElements = [];
            this.data.forEach((item, rec_index)=>{
                if (typeof itemPreprocessor === "function") {
                    item = itemPreprocessor(item, rec_index);
                    if (!Object.keys(item).length) {
                        if (this.settings.debug) console.info("template-tool: discarding display", item, "because it is empty");
                        return;
                    }
                }
                if (recsArray.length >= this.settings.max_items) return;
                recsArray.push(item);
                let itemTemplate;
                if (item.sale_price !== item.original_price) {
                    itemTemplate = template.replaceAll($366fff12da348e66$var$discountMatcher, "$1").replaceAll($366fff12da348e66$var$noDiscountMatcher, "");
                    item.discount = `–${Math.round(100 * (1 - item.sale_price / item.original_price))}%`;
                } else {
                    itemTemplate = template.replaceAll($366fff12da348e66$var$discountMatcher, "").replaceAll($366fff12da348e66$var$noDiscountMatcher, "$1");
                    item.discount = "";
                }
                const resultHTML = interpolator(itemTemplate)(item);
                let elements = elementsFromHTML(resultHTML);
                if (!this.settings.DNT) for (const element of elements){
                    // recommendations_inserted event
                    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).oncreation(element, ()=>{
                        if (!this.#dispatched_recs_inserted) {
                            this.#dispatched_recs_inserted = true;
                            (0, $43683b1103edab15$export$82badda1f9923310)({
                                ...this.settings,
                                product_id: product_id_at_rendering,
                                recommendation_type: this.settings.type,
                                type: "recommendations_inserted"
                            });
                        }
                    });
                    const listener = (e)=>{
                        this.trackClick(rec_index);
                        this.trackGAEvent("rec_bar_click", rec_index, item.ga_product_id || item.product_id || this.settings.product_id(item.page_url), item.ga_product_ids);
                    };
                    element.addEventListener("click", listener);
                    (0, $91b2e49f92ed636c$export$82a685f2da2fb027)(element, item.product_id, item.recommendation_id);
                    if (this.settings.shade) (0, $d4ffde0b9fca0369$export$6ebd242c09192cec)(element);
                    // @ts-ignore
                    if (!element.depict_event_listeners) // @ts-ignore
                    element.depict_event_listeners = [];
                    // @ts-ignore
                    element.depict_event_listeners.push(listener);
                }
                if (typeof itemPostprocessor === "function") elements = itemPostprocessor(elements, item);
                resultingElements.push(...elements);
            });
            this.data = recsArray;
            if (!this.settings.DNT) (0, $c749fe63b72056ef$export$7babcd5d4056b2ca)(recsArray, this.settings.product_id, {
                list_name: "depict_" + this.settings.type
            });
            return resultingElements;
        };
        const renderedContent = getContent();
        if (typeof root === "function") {
            if (this.settings.loadHack === true) {
                const SLEEP_TIME_MS = 50;
                let MAX_RETRY = Math.round(10000 / SLEEP_TIME_MS);
                const tick = setInterval(()=>{
                    const r = root();
                    if (MAX_RETRY === 0) clearInterval(tick);
                    MAX_RETRY--;
                    if (r !== null) {
                        r.append(...renderedContent);
                        clearInterval(tick);
                    }
                }, SLEEP_TIME_MS);
            } else if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
                const r = root();
                r.append(...renderedContent);
            }, {
                once: true
            });
            else {
                const r = root();
                r.append(...renderedContent);
            }
            return;
        }
        root.append(...renderedContent);
    }
}


var /**
 * @deprecated Please use RecommendationRenderer instead
 */ $51bbc74e39f5e5c6$export$2e2bcd8739ae039 = async (options)=>{
    const depict = new (0, $366fff12da348e66$export$1a8782481a9af507)(options.options), done = new Promise((itsdone)=>{
        document._depict_modify = true;
        depict.init(()=>{
            depict.renderTemplate({
                itemPostprocessor: options.postProcessor,
                itemPreprocessor: options.preProcessor,
                root: options.root,
                template: options.template
            });
            itsdone();
        }, options.recs);
    });
    await done;
    return depict;
};


// @ts-ignore
var $d68a965875f09111$exports = {};
$d68a965875f09111$exports = ".depict .rec_outer.noautospacing {\n  width: 6cm;\n  max-width: 46vw;\n  margin-left: 1%;\n  margin-right: 1%;\n}\n\n.depict .rec_outer.noautospacing:nth-child(1) {\n  margin-left: 0;\n}\n\n.depict .rec_outer.noautospacing:nth-last-child(1) {\n  margin-right: 0;\n}\n\n.depict-slider .slider_snap {\n  scroll-snap-type: x mandatory;\n}\n\n.depict-slider {\n  width: 100%;\n  position: relative;\n}\n\n.depict-slider .sliding::-webkit-scrollbar {\n  display: none;\n}\n\n.depict-slider .sliding {\n  scroll-behavior: smooth;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  flex-flow: row;\n  margin-top: -1%;\n  margin-bottom: -2%;\n  padding-top: 1%;\n  padding-bottom: 2%;\n  display: flex;\n  overflow-x: scroll;\n}\n\n.depict-slider .sliding > * {\n  box-sizing: border-box;\n  flex: none;\n}\n\n.depict-slider button.right {\n  right: 0;\n}\n\n.depict-slider button.left, .depict-slider button.right {\n  z-index: 2;\n  touch-action: manipulation;\n  width: 1cm;\n  height: 1cm;\n  cursor: pointer;\n  background: #fff;\n  border: none;\n  padding: .5%;\n  transition-duration: .2s;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.depict-slider button.left.hidden, .depict-slider button.right.hidden {\n  opacity: 0;\n  cursor: default;\n}\n\n.depict-slider button.left {\n  left: 0;\n  transform: translateY(-50%)rotate(180deg);\n}\n\n.depict-slider button.left img, .depict-slider button.right img {\n  width: 100%;\n  height: 100%;\n}\n\n.depict-slider .rec_outer {\n  margin-top: 0 !important;\n}\n\n";




const $762a881271a51d1b$var$default_image_src = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjYsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwb2x5Z29uIHBvaW50cz0iOSwyLjYgOC4zLDMuNCAxMi40LDcuNSAxLjYsNy41IDEuNiw4LjUgMTIuNCw4LjUgOC4zLDEyLjYgOSwxMy40IDE0LjQsOCAiLz4NCjwvc3ZnPg0K";
class $762a881271a51d1b$export$4d41c6499d53639c extends (0, $c33c6faf8acc7442$export$68babfc5be0de5da) {
    constructor(static_options, override_lazyfier_options){
        const options = {
            button_contents: Object.fromEntries([
                "left",
                "right"
            ].map((side)=>[
                    side,
                    [
                        (()=>{
                            const image = new Image();
                            image.src = static_options.arrow_image || $762a881271a51d1b$var$default_image_src;
                            image.alt = side + " arrow";
                            return image;
                        })()
                    ]
                ])),
            ...static_options
        };
        super(options, {
            lazyfinder: {
                unload (image) {
                    (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ()=>{
                        if (!image?.dataset?.src?.length) {
                            image.dataset.src = image.src;
                            image.removeAttribute("src");
                        }
                    })();
                }
            },
            ...override_lazyfier_options || {}
        });
    }
}
function $762a881271a51d1b$export$f1b8b9fd75ddcab1(slider) {
    const style_elem = document.createElement("style");
    style_elem.type = "text/css";
    style_elem.append((0, (/*@__PURE__*/$parcel$interopDefault($d68a965875f09111$exports))));
    slider.container.appendChild(style_elem);
}





async function $e61f371a9bcdeb2f$export$cd12721587f4f16d(t, rendering_options, options_for_us, slider_options, override_lazyfier_options) {
    options_for_us ||= {};
    const { dlog: dlog , catchify: catchify  } = t;
    const { root_selector: root_selector , Rec_Renderer: local_rr = (0, $6be99244fa573db5$export$2e2bcd8739ae039) , insertion_verb: insertion_verb = "replaceWith"  } = options_for_us;
    let { container: container  } = options_for_us;
    if (typeof container == "string") container = [
        ...(0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583)(container)
    ];
    if (container && !Array.isArray(container)) container = [
        ...container
    ];
    const slider = new (0, $762a881271a51d1b$export$4d41c6499d53639c)({
        dlog: dlog,
        catchify: catchify,
        dist_to_hide_left: 6,
        dist_to_hide_right: 6,
        ...slider_options
    }, override_lazyfier_options);
    const recs = await local_rr(t, {
        ...rendering_options,
        post_processors: [
            (elements, display)=>{
                (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(elements, "a.rec_outer").forEach((ro)=>ro.classList.add("noautospacing"));
                return elements;
            },
            ...rendering_options.post_processors || []
        ]
    });
    if (!recs.elements) {
        dlog("RR_Slider says bye bye cuz no recs");
        return {};
    }
    slider.insert_here.append(...recs.elements);
    if (container) {
        const [root] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container, root_selector || ".grid");
        root[insertion_verb](slider.container);
    }
    return {
        ...recs,
        displays: recs.displays,
        elements: container ? container : [
            slider.container
        ]
    };
}







async function $f494377581cfb2b4$export$30933c637c977eef({ t: t , recs: recs , title: title , infinite_scroll: infinite_scroll = false , with_slider: with_slider = false , with_loadmore: with_loadmore = false , template_tool_options: template_tool_options , slider_options: slider_options = {} , pre_processors: pre_processors = [] , post_processors: post_processors = [] , container_template: container_template , template: // container template
template , chunk_size_for_load_more: // recommendation template
chunk_size_for_load_more = 4 , insertion_promise: insertion_promise  }) {
    const { catchify: catchify , dlog: dlog  } = t, container = [
        ...(0, $0bdb8dbcf1bc7f34$export$44951404cb8d0583)(container_template)
    ], root = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container, ".grid")[0], internal_pre_processors = [
        ...pre_processors
    ], // copy arrays so we don't unintentionally modify an array of a script calling us when doing auto postprocessor for slider if insertion_promise is defined
    internal_post_processors = [
        ...post_processors
    ];
    if (with_slider) var slider = catchify(()=>new (0, $762a881271a51d1b$export$4d41c6499d53639c)({
            ...t,
            arrow_image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJkaXNwbGF5OiBpbmxpbmUtYmxvY2s7IHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7IiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgOCAxNSI+PHBhdGggc3R5bGU9ImZpbGw6IHJnYigwLCAwLCAwKTsiIGQ9Ik0uNjI5LjAwMWMuMTUuMDA4LjI5My4wNzIuMzk4LjE4bDYuNzkyIDYuODlhLjYwMS42MDEgMCAwIDEgMCAuODZsLTYuNzkyIDYuODg4YS41ODYuNTg2IDAgMCAxLS44NDYgMCAuNjAxLjYwMSAwIDAgMSAwLS44Nkw2LjU1NCA3LjUuMjExIDEuMDAxYS42MDEuNjAxIDAgMCAxIDAtLjg2Yy4xMTUtLjEuMjY2LS4xNS40MTgtLjE0Ij48L3BhdGg+PC9zdmc+",
            ...slider_options
        }))();
    if (slider) {
        root.replaceWith(slider.container);
        if (insertion_promise) internal_post_processors.push((t, items, d)=>{
            for (const item of items)insertion_promise.then(()=>{
                (0, $21285393646b9849$export$37125ccc5dd98050)({
                    element: item,
                    data: {
                        tenant: t.tenant,
                        entity_price: d.entity_price,
                        recommendation_id: d.recommendation_id,
                        market: t.market,
                        product_id: d.product_id,
                        recommendation_type: d.recommendation_type
                    },
                    wait_for_dom_insertion: false
                });
            });
            return items;
        });
    }
    if (!slider || !insertion_promise) internal_post_processors.push((t, items, d)=>{
        for (const item of items)(0, $21285393646b9849$export$37125ccc5dd98050)({
            element: item,
            data: {
                tenant: t.tenant,
                entity_price: d.entity_price,
                recommendation_id: d.recommendation_id,
                market: t.market,
                product_id: d.product_id,
                recommendation_type: d.recommendation_type
            },
            wait_for_dom_insertion: false
        });
        return items;
    });
    const template_tool = await (0, $51bbc74e39f5e5c6$export$2e2bcd8739ae039)({
        options: {
            ...t,
            ...template_tool_options || {}
        },
        root: slider ? slider.insert_here : root,
        recs: recs,
        template: template,
        preProcessor: (d, i)=>{
            return internal_pre_processors.reduce((accumulator, currentValue)=>{
                // basic pre processor pipeline
                return catchify(currentValue)(t, accumulator, i, with_loadmore, with_slider, infinite_scroll) || accumulator;
            }, d);
        },
        postProcessor: (items, d)=>{
            return internal_post_processors.reduce((accumulator, currentValue)=>{
                // basic post processor pipeline
                return catchify(currentValue)(t, accumulator, d, slider) || accumulator;
            }, items);
        }
    });
    if (with_loadmore) catchify($f494377581cfb2b4$var$setup_load_more)(t, root, chunk_size_for_load_more);
    if (infinite_scroll) catchify($f494377581cfb2b4$var$setup_infinite_scroll)(t, root);
    if (title) {
        const [title_element] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container, "h1.title, h2.title, h3.title, h4.title, h5.title, h6.title");
        if (title_element) {
            if (typeof title == "string") title_element.innerText = title;
            else title_element.replaceWith(...title);
        }
    }
    if (template_tool?.data?.length) return container;
    else dlog("Didn't get recs from API", template_tool);
}
function $f494377581cfb2b4$var$setup_infinite_scroll(t, root) {
    const { dlog: dlog , catchify: catchify  } = t, get_last_visible_el = ()=>[
            ...root.querySelectorAll("a.rec_outer:not(.not_visible)")
        ].slice(-1)[0], last_visible_el = get_last_visible_el();
    if (!last_visible_el) {
        dlog("not setting up infinite scroll as there are no elements");
        return;
    }
    const intersection_observer = new IntersectionObserver(catchify((records)=>{
        dlog("Intersection observer for", last_visible_el, "has records", records);
        records.forEach((record)=>{
            if (record.isIntersecting && record.target == get_last_visible_el()) {
                dlog("Loading more recs because of", record);
                if ($f494377581cfb2b4$var$load_more_elements(root)) $f494377581cfb2b4$var$setup_infinite_scroll(t, root);
            }
        });
    }));
    dlog("starting to intersection observe", last_visible_el, "for infinite scroll");
    intersection_observer.observe(last_visible_el);
}
function $f494377581cfb2b4$var$load_more_elements(root, chunk_size = 4) {
    const hidden_elements = root.querySelectorAll("a.rec_outer.not_visible");
    let i = 0;
    for(; i < Math.min(hidden_elements.length, chunk_size); i++){
        // @ts-ignore
        hidden_elements[i].load_image();
        hidden_elements[i].classList.remove("not_visible");
    }
    const has_more = i >= chunk_size && hidden_elements.length > chunk_size;
    return has_more;
}
function $f494377581cfb2b4$var$setup_load_more(t, root, chunk_size) {
    const { catchify: catchify  } = t, load_more_cont = (0, $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787)(`<div class="load-more-container"></div>`), load_button = load_more_cont.appendChild((0, $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787)(`<button class="load_more">Visa mer</button>`));
    load_button.addEventListener("click", catchify(load_more_recs_and_hide_button_if_needed));
    root.after(load_more_cont);
    load_more_recs_and_hide_button_if_needed();
    function load_more_recs_and_hide_button_if_needed() {
        if (!$f494377581cfb2b4$var$load_more_elements(root, chunk_size)) // there aren't any recs left to display
        load_button.classList.add("not_visible");
    }
}
function $f494377581cfb2b4$export$4f39078bdc72ecd0(_t, d, i, with_loadmore, with_slider, infinite_scroll) {
    d.class ||= "";
    if (infinite_scroll) d.class = i >= 4 ? "not_visible" : ""; // this will make it hold image loading until .load_image is called on .rec_outer
    if (with_loadmore) d.class = "not_visible";
    d.percentage_off = Math.round(100 - d.sale_price / d.original_price * 100);
    if (!d.percentage_off || d.percentage_off < 10) d.percentage_off = "";
    return d;
}
function $f494377581cfb2b4$export$c410ce1205e5118a(_t, itms, d, slider) {
    for (const item of itms){
        const { image_url: image_url  } = d, img = item.querySelector("img.image"), load_image = ()=>{
            img.src = image_url;
            slider?.observe?.(img);
        };
        if (item.classList.contains("not_visible") || slider) // @ts-ignore
        item.load_image = load_image;
        else load_image();
        if (slider) item.classList.add("noautospacing");
    }
    return itms;
}






var /**
 * @deprecated please use `fetch_retry()` instead
 *
 * Windows proof fetch factory: windows proof fetch is a utility which retries fetch requests 10 times when they fail. Reason for this is a certain windows 10 build where the network stack randomly breaks 20% of https connections
 * (Note: this thing really should be rewritten with exponential backoff and a better API)
 * @param  dlog                    logging function to use
 * @param  error_log               an array to which errors will be pushed
 * @return           a windows proof fetch function
 */ $acf11540344875ed$export$2e2bcd8739ae039 = (dlog, error_log)=>{
    // https://sentry.io/organizations/depictai-0o/issues/2025371462/?project=5476183&query=is%3Aunresolved
    // https://stackoverflow.com/a/52947884
    const windows_proof_fetch = async function(url, body, headers, decode_json, fetch_options, attempt) {
        attempt ||= 1;
        decode_json ??= true;
        const { stack: stack  } = new Error();
        const elog = (...args)=>{
            if (Array.isArray(error_log)) error_log.push(args);
            return dlog(...args);
        };
        return await fetch(url, {
            ...body ? {
                body: body
            } : {},
            "method": "POST",
            ...fetch_options ? fetch_options : {},
            ...headers ? {
                headers: headers
            } : {}
        }).then(async (response)=>{
            if (!response || !response.ok || response.status !== 200) {
                if (response.status === 422) (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($acf11540344875ed$var$send_sentry_422)(response, body, stack);
                elog("Response not ok", response);
                return false;
            } else return await response[decode_json ? "json" : "text"]().catch((e)=>elog("error while decoding json", e));
        }).catch((e)=>{
            elog("Error while fetching", e, url, body);
            if ((e.name == "TypeError" || e.message == "Failed to fetch" || e.message == "Network request failed") && !e.message.includes("CORS") && !e.name.includes("CORS") && ++attempt < 10) return windows_proof_fetch(url, body, headers, decode_json, fetch_options, attempt);
            return false;
        });
    };
    return windows_proof_fetch;
};
async function $acf11540344875ed$var$send_sentry_422(response, body, stack) {
    const msg = `Validation error: got 422 from API`;
    const text = await response.text();
    (0, $649f456f663da9fc$export$de56f1198d121036)(msg, "body", body, "response", response, "text", text, "stack", stack);
    (0, $eba382943196079c$export$af2e17a20c2ea3c5).withScope(function(scope) {
        scope.setExtra("stack", stack);
        scope.setExtra("request_body", body);
        scope.setExtra("response", response);
        scope.setExtra("serialized_response", (0, $5c4afc453f904a1f$export$39d526a1194b6499)(response));
        scope.setExtra("response_text", text);
        scope.setLevel("error");
        this.captureException(new Error(msg));
    });
}









const $ca66c9553e84df02$export$dc84183312f0c201 = /*@__PURE__*/ (()=>(0, $63cbb5de51d11596$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("desc", {
                children: "Right arrow"
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("path", {
                d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
            })
        ]
    }))();
const $ca66c9553e84df02$export$6038895ac52bd044 = /*@__PURE__*/ (()=>(0, $63cbb5de51d11596$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 512",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("desc", {
                children: "Left arrow"
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("path", {
                d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            })
        ]
    }))();



const $9a744f57ab06c32e$export$68c017fd93791405 = ({ duration: duration = 500  } = {
    duration: 500
})=>{
    const container = document.createElement("div");
    container.style.overflow = "hidden";
    container.style.height = "0";
    container.style.transition = "height 0.5s";
    const content = document.createElement("div");
    container.append(content);
    const expand = ()=>{
        container.style.height = content.clientHeight + "px";
        setTimeout((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            container.style.overflow = "unset";
            container.style.height = "auto";
        }), duration);
    };
    return {
        expand: expand,
        content: content,
        container: container
    };
};











function $693e2a1517bef984$export$f8913c8a18f7ca21(iterables) {
    const ourselves = (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    const values = new Array(iterables.length);
    Promise.all(iterables.map((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (iterable, index)=>{
        for await (const value of iterable){
            values[index] = value;
            ourselves([
                ...values
            ]);
        }
    }))).then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(ourselves.exit));
    return ourselves;
}







const $30e801eaa3dc319e$export$5c4e09968d6eab33 = (min, max)=>`@media ${min ? `(min-width:${min})` : ``}${min && max ? ` and ` : ``}${max ? `(max-width:${max})` : ``}`;
async function $30e801eaa3dc319e$export$c84671f46d6a1ca({ rows: rows , container_element: container_element , cols_at_size: cols_at_size , grid_spacing: grid_spacing , layout: layout , disable_partial_rows: disable_partial_rows , override_vertical_spacing: override_vertical_spacing  }) {
    const rows_or_empty_object = typeof rows == "object" ? rows : {}; // this is to satisfy typescript
    const { start_rows: start_rows = 1 , button: button , max_rows: max_rows = -1  } = rows_or_empty_object;
    let { ipns: ipns  } = rows_or_empty_object;
    const is_static = !ipns && !button;
    const our_style_el = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("style", {
        type: "text/css"
    });
    const container_class = (0, $460df8550f9d084d$export$a6db784f019668ba)();
    const selector_beginning = `.depict .${container_class}>`;
    const el_count_ipns = (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    const set_length = ()=>el_count_ipns(container_element.children.length);
    const col_styling = $30e801eaa3dc319e$export$17c3166a7ebd4688(selector_beginning, grid_spacing, cols_at_size, layout, override_vertical_spacing);
    let button_class;
    ipns ||= (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    container_element.after(our_style_el);
    container_element.classList.add(container_class);
    if (rows === "all") {
        // no view more functionality requested
        our_style_el.append(col_styling);
        return;
    }
    ipns(start_rows);
    set_length();
    const mutation_observer = new MutationObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(set_length));
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).oncreation(container_element, ({ element: element  })=>{
        mutation_observer.observe(element, {
            childList: true
        });
        set_length(); // might have changed while we weren't in the DOM but no need to observe and update when we aren't
    });
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(container_element, ({ element: element  })=>{
        if (document.documentElement.contains(element)) return;
        mutation_observer.disconnect();
        el_count_ipns.exit();
        ipns.exit();
    });
    if (button) {
        button_class = (0, $460df8550f9d084d$export$a6db784f019668ba)();
        const button_container = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            class: "load-more-container " + button_class,
            children: (0, $b9b0dba897847b2a$export$f63fcc839cb0f734)("click", ()=>ipns(ipns.state + (rows_or_empty_object.rows_per_click ?? 1)), button)
        });
        container_element.after(button_container);
    }
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).oncreation(container_element, async ()=>{
        for await (const [currently_showing_rows, number_of_els] of (0, $693e2a1517bef984$export$f8913c8a18f7ca21)([
            // start for await loop when the container element gets inserted into the DOM
            // the loop is broken by an observer.onremoved above calling .exit on the IPNS this depends on
            // @ts-ignore
            ipns,
            // @ts-ignore too complicated to fix this IMO
            el_count_ipns
        ])){
            our_style_el.innerText = col_styling + cols_at_size.map((options)=>{
                const [, min, max] = options;
                let should_hide_button;
                let visible_recs;
                if (disable_partial_rows) {
                    visible_recs = $30e801eaa3dc319e$var$get_visible_recs_without_partial_rows(currently_showing_rows, number_of_els, options);
                    const visible_recs_next_show_more = $30e801eaa3dc319e$var$get_visible_recs_without_partial_rows(currently_showing_rows + (rows_or_empty_object.rows_per_click || 0), number_of_els, options);
                    should_hide_button = visible_recs === visible_recs_next_show_more;
                } else {
                    visible_recs = $30e801eaa3dc319e$var$get_total_rec_amount_for_row(currently_showing_rows, options);
                    should_hide_button = visible_recs >= number_of_els;
                }
                const should_hide_button_final = button_class && (should_hide_button || max_rows !== -1 && currently_showing_rows >= max_rows);
                return `${$30e801eaa3dc319e$export$5c4e09968d6eab33(min, max)}{${selector_beginning}:nth-child(n+${visible_recs + 1}){display:none}${layout == "slider" ? `${selector_beginning}:nth-child(n+${visible_recs}){margin-right:0}` : ""}${should_hide_button_final ? `.depict .${button_class}{display:none!important}` : ``}}`;
            }).join("");
            if (is_static) break;
        }
    });
}
/** Getting how many recs should be displayed for a certain row (while taking override rules into account)
 * This returns number of recs for this row and all the previous ones
 * @param row The "index" of the row (counting from the top). Starts at 1.
 * @param options Your cols_at_size layout option
 */ function $30e801eaa3dc319e$var$get_total_rec_amount_for_row(row, options) {
    const [default_cols, , , , override_obj] = options;
    const overrides = override_obj?.overrides || {};
    let total = 0;
    for(let current_r = 1; current_r <= row; current_r++){
        const cols = overrides[current_r] || default_cols;
        total += cols;
    }
    return total;
}
/**
 * Same as `get_total_rec_amount_for_row` but caps the result to never exceed @param max_recs
 */ function $30e801eaa3dc319e$var$get_visible_recs_without_partial_rows(rows, max_recs, options) {
    let visible_recs;
    while((visible_recs = $30e801eaa3dc319e$var$get_total_rec_amount_for_row(rows--, options)) > max_recs);
    return visible_recs;
}
function $30e801eaa3dc319e$export$17c3166a7ebd4688(selector_beginning, default_grid_spacing_text, cols_at_size, layout, override_vertical_spacing) {
    function get_width_of_middle_elements(n_cols, spacing) {
        return `width:${$30e801eaa3dc319e$var$css_subtract($30e801eaa3dc319e$var$css_divide(new $30e801eaa3dc319e$var$CSSMeasurement("100%"), n_cols), $30e801eaa3dc319e$var$css_divide($30e801eaa3dc319e$var$css_multiply(n_cols * 2 - 2, spacing), n_cols))}`;
    }
    function get_width_css(n_cols, selector, spacing) {
        const width_css = get_width_of_middle_elements(n_cols, spacing);
        const margin_css = `margin-left:${spacing};margin-right:${spacing}`;
        return `${selector}{${margin_css};${width_css}}`;
    }
    function get_horizontal_spacing_css(start, end, selector, spacing) {
        const left_removed_css = `${selector}:nth-child(${start}){margin-left:0}`;
        const right_removed_css = `${selector}:nth-child(${end}){margin-right:0}`;
        return left_removed_css + right_removed_css;
    }
    function get_vertical_spacing_css(selector, spacing, options) {
        const top_row_selector = `${selector}:nth-child(n+1):nth-child(-n+${$30e801eaa3dc319e$var$get_total_rec_amount_for_row(1, options)})`;
        const between_spacing_css = `${selector}:not(${top_row_selector}){margin-top:${override_vertical_spacing ?? $30e801eaa3dc319e$var$css_multiply(spacing, 2)}}`;
        return between_spacing_css;
    }
    function get_left_right_0_spacing_rest_of_rows_css(n_cols, start, selector_beginning) {
        const right = `${selector_beginning}:nth-child(${n_cols}n+${start}){margin-left:0}`;
        const left = `${selector_beginning}:nth-child(${n_cols}n+${start + n_cols - 1}){margin-right:0}`;
        return right + left;
    }
    const half_default_spacing = $30e801eaa3dc319e$var$css_divide(new $30e801eaa3dc319e$var$CSSMeasurement(default_grid_spacing_text), 2);
    return cols_at_size.map((options)=>{
        const [n_cols, min, max, grid_spacing_for_size, override] = options;
        const half_spacing = grid_spacing_for_size ? $30e801eaa3dc319e$var$css_divide(new $30e801eaa3dc319e$var$CSSMeasurement(grid_spacing_for_size), 2) : half_default_spacing;
        let media_query_body = "";
        if (layout == "grid") {
            const overrides = override?.overrides || {};
            const sorted = Object.keys(overrides).sort((r1, r2)=>parseInt(r1) - parseInt(r2));
            const last_override_row = sorted.at(-1);
            /** We run this loop up until the last override rule + 1.
       * The last iteration will create styling rules that apply to every row that comes after it.
       * Let's say we have one override rule for row 2.
       * We:
       *  1. Create styling for row 1
       *  2. Create styling for row 2
       *  3. Create styling for row 3 which will apply to the rest of the rows. Every row will be the same from now on.
       */ const max_row = last_override_row ? parseInt(last_override_row) + 1 : 1;
            for(let row = 1; row <= max_row; row++){
                const real_n_cols = overrides[row] || n_cols;
                const amount_until_now = $30e801eaa3dc319e$var$get_total_rec_amount_for_row(row - 1, options);
                const amount_next_row = $30e801eaa3dc319e$var$get_total_rec_amount_for_row(row, options);
                const start = amount_until_now + 1;
                const end = amount_next_row;
                const is_last_iteration = row === max_row;
                let row_selector = selector_beginning;
                if (is_last_iteration) row_selector += `:nth-child(n+${start})`;
                else row_selector += `:nth-child(n+${start}):nth-child(-n+${end})`;
                media_query_body += get_width_css(real_n_cols, row_selector, half_spacing);
                media_query_body += get_horizontal_spacing_css(start, end, row_selector, half_spacing);
                media_query_body += get_vertical_spacing_css(row_selector, half_spacing, options);
                if (is_last_iteration) media_query_body += get_left_right_0_spacing_rest_of_rows_css(n_cols, start, selector_beginning);
            }
        } else if (layout == "slider") {
            const margin_and_width_of_middle_elements = get_width_css(n_cols, `${selector_beginning}*`, half_spacing);
            media_query_body += margin_and_width_of_middle_elements;
            const start_and_end_no_margin = `${selector_beginning}:first-child{margin-left:0}${selector_beginning}:last-child{margin-right:0}`;
            media_query_body += start_and_end_no_margin;
        } else throw new Error("invalid layout");
        const retval = `${$30e801eaa3dc319e$export$5c4e09968d6eab33(min, max)}{${media_query_body}}`;
        return retval;
    }).join("");
}
function $30e801eaa3dc319e$var$css_subtract(a, b) {
    if (a.is_fe || b.is_fe || a.u !== b.u) return new $30e801eaa3dc319e$var$CSSMeasurement(`calc(${a} - ${b})`);
    else // @ts-ignore
    return new $30e801eaa3dc319e$var$CSSMeasurement(a - b + a.u);
}
function $30e801eaa3dc319e$var$css_add(a, b) {
    if (a.is_fe || b.is_fe || a.u !== b.u) return new $30e801eaa3dc319e$var$CSSMeasurement(`calc(${a} + ${b})`);
    else // @ts-ignore
    return new $30e801eaa3dc319e$var$CSSMeasurement(+a + +b + a.u);
}
function $30e801eaa3dc319e$var$css_multiply(a, b) {
    const a_is_num = typeof a === "number";
    const b_is_num = typeof b === "number";
    if (a_is_num && b_is_num) throw new Error("At least one value needs a unit");
    // @ts-ignore
    if (a.is_fe || b?.is_fe || !b_is_num && !a_is_num && a.u !== b.u) return new $30e801eaa3dc319e$var$CSSMeasurement(`calc(${a} * ${b})`);
    else // @ts-ignore
    return new $30e801eaa3dc319e$var$CSSMeasurement(a * b + (a.u || b.u));
}
function $30e801eaa3dc319e$var$css_divide(a, b) {
    // @ts-ignore
    if (a.is_fe || b?.is_fe || typeof b !== "number" && a.u !== b.u) return new $30e801eaa3dc319e$var$CSSMeasurement(`calc(${a} / ${b})`);
    else // @ts-ignore
    return new $30e801eaa3dc319e$var$CSSMeasurement(a / b + a.u);
}
class $30e801eaa3dc319e$var$CSSMeasurement {
    [Symbol.iterator] = function*() {
        if (this.is_fe) throw new Error("Function expression isn't iterable: " + this.e);
        yield this.v;
        yield this.u;
    };
    valueOf() {
        if (this.is_fe) throw new Error("Cannot convert function expression: " + this.e + " to number");
        else return this.v;
    }
    toString() {
        if (this.is_fe) return this.e;
        else return this.v + this.u;
    }
    [Symbol.toPrimitive](hint) {
        return hint == "number" ? this.valueOf() : this.toString();
    }
    constructor(measurement){
        if (measurement.includes("(") && measurement.includes(")")) {
            this.is_fe = true;
            this.e = measurement;
            return;
        }
        const number = parseFloat(measurement);
        const unit = measurement.replace("" + number, "");
        if (!unit) throw new Error("CSSValue needs a unit: " + measurement);
        this.v = number;
        this.u = unit;
    }
}









async function $090b8182afa1b2a6$export$b0a773486c1c2312(t, recommendation_renderer_options, { container_elements: container_elements , container_selector: container_selector , override_rec_renderer: override_rec_renderer , lazyfier_options: lazyfier_options = {} , eager_images: eager_images , ...options_for_grid }) {
    const [insertion_point] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container_elements, container_selector || ".grid");
    const rendering_result = await (override_rec_renderer || (0, $6be99244fa573db5$export$2e2bcd8739ae039))(t, recommendation_renderer_options);
    const { elements: elements  } = rendering_result;
    if (!elements) return rendering_result;
    if (!eager_images) // convoluted lazy loading that
    // when the elements are in the DOM starts IntersectionObserver on whole grid
    // when grid intersects starts Lazyfier
    // this is because Lazyfier is fucking stupid
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(insertion_point).then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((element)=>{
        let start_lazy_loading;
        const lazy_loading_promise = new Promise((r)=>start_lazy_loading = r);
        const lf = new (0, $b83068cbd26dcc41$export$3be7054c61590ee3)({
            only_load_intersecting: true,
            wait_for_dominsertion: lazy_loading_promise,
            ...lazyfier_options
        });
        lf.start_observing_for_new_children_(element);
        const i_o = new IntersectionObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
            for (const record of records)if (record.intersectionRatio > 0) {
                start_lazy_loading();
                i_o.disconnect();
                return;
            }
        }));
        i_o.observe(insertion_point);
    }));
    insertion_point.append(...elements);
    (0, $30e801eaa3dc319e$export$c84671f46d6a1ca)({
        ...options_for_grid,
        container_element: insertion_point,
        layout: "grid"
    }).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    return {
        ...rendering_result,
        elements: container_elements
    };
}


// @ts-ignore
var $06ec2e809d7a727f$exports = {};
$06ec2e809d7a727f$exports = ".depict-slider {\n  width: 100%;\n  position: relative;\n}\n\n.depict-slider .sliding {\n  scroll-behavior: smooth;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  flex-flow: row;\n  display: flex;\n  overflow-x: scroll;\n}\n\n.depict-slider .sliding::-webkit-scrollbar {\n  display: none;\n}\n\n.depict-slider .sliding > * {\n  box-sizing: border-box;\n  flex: none;\n}\n\n";









let $30f78542ed78cd31$var$slider_styling_was_inserted = false;
async function $30f78542ed78cd31$export$82cfdc85a4d15688(t, recommendation_renderer_options, { container_elements: container_elements , container_selector: container_selector , override_rec_renderer: override_rec_renderer , lazyfier_options: lazyfier_options = {} , eager_images: eager_images , grid_spacing: grid_spacing , cols_at_size: cols_at_size , override_vertical_spacing: override_vertical_spacing , rows: rows = "all" , ...slider_options }) {
    const [insertion_point] = (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(container_elements, container_selector || ".grid");
    const slider = eager_images ? new (0, $ef9394fafebd5eab$export$692b27c28639e5b9)(slider_options) : new (0, $c33c6faf8acc7442$export$68babfc5be0de5da)(slider_options, lazyfier_options);
    const rendering_result = await (override_rec_renderer || (0, $6be99244fa573db5$export$2e2bcd8739ae039))(t, recommendation_renderer_options);
    const { elements: elements  } = rendering_result;
    if (!elements) return rendering_result;
    if (!$30f78542ed78cd31$var$slider_styling_was_inserted) {
        $30f78542ed78cd31$var$slider_styling_was_inserted = true;
        (0, $0a581f1dfa083522$export$59ba1eb2c083f0cd)((0, (/*@__PURE__*/$parcel$interopDefault($06ec2e809d7a727f$exports))));
    }
    insertion_point.replaceWith(slider.container);
    slider.insert_here.append(...elements);
    (0, $30e801eaa3dc319e$export$c84671f46d6a1ca)({
        grid_spacing: grid_spacing,
        cols_at_size: cols_at_size,
        container_element: slider.insert_here,
        rows: rows,
        layout: "slider",
        override_vertical_spacing: override_vertical_spacing
    }).catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            e,
            "Grid had an error"
        ], "warning"));
    return {
        ...rendering_result,
        slider: slider,
        elements: container_elements
    };
}




function $be40b7bf11a47cc4$export$8cbd8aa1c70f9a13(interval = 5000) {
    let timer;
    let direction = 1;
    function interval_scroll() {
        timer = setInterval(()=>{
            this.scroll_to_rel(this.stepstoslide * direction);
        }, interval);
    }
    function mutation_plugin(_intersections, intersecting_mutations) {
        clearInterval(timer);
        const visible_els = Object.keys(intersecting_mutations).map((v)=>+v);
        if (visible_els.includes(this.index_of_last_element)) direction = -1;
        else if (visible_els.includes(0)) direction = 1;
        interval_scroll.call(this);
    }
    return {
        constructor_plugin () {
            const set_scroll_int = interval_scroll.bind(this);
            this.container.addEventListener("click", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                clearInterval(timer);
                set_scroll_int();
            }));
            this.container.addEventListener("mousedown", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                clearInterval(timer);
            }));
            set_scroll_int();
        },
        mutation_plugin: mutation_plugin
    };
}


function $d31b48b85102c1ec$export$80039a49055269fb() {
    const new_arrowimage = ()=>{
        const img = new Image();
        img.src = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgIDxsaW5lIHgxPSI0IiB5MT0iMTIiIHgyPSIyMCIgeTI9IjEyIi8+CiAgICA8cG9seWxpbmUgcG9pbnRzPSIxNCA2IDIwIDEyIDE0IDE4Ii8+Cjwvc3ZnPg==`;
        return img;
    };
    return Object.fromEntries([
        "left",
        "right"
    ].map((side)=>[
            side,
            [
                new_arrowimage()
            ]
        ]));
}



function $a75adf1478c4522f$export$af88b4929c2dc86() {
    const img = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("img", {
        src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJkaXNwbGF5OiBpbmxpbmUtYmxvY2s7IHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7IiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgOCAxNSI+PHBhdGggc3R5bGU9ImZpbGw6IHJnYigwLCAwLCAwKTsiIGQ9Ik0uNjI5LjAwMWMuMTUuMDA4LjI5My4wNzIuMzk4LjE4bDYuNzkyIDYuODlhLjYwMS42MDEgMCAwIDEgMCAuODZsLTYuNzkyIDYuODg4YS41ODYuNTg2IDAgMCAxLS44NDYgMCAuNjAxLjYwMSAwIDAgMSAwLS44Nkw2LjU1NCA3LjUuMjExIDEuMDAxYS42MDEuNjAxIDAgMCAxIDAtLjg2Yy4xMTUtLjEuMjY2LS4xNS40MTgtLjE0Ij48L3BhdGg+PC9zdmc+"
    });
    return {
        left: [
            img
        ],
        right: [
            img.cloneNode()
        ]
    };
}




function $2436f68ea927d4a8$export$1d17a045bcc711b1({ t: t , navcont_insertion_fn: navcont_insertion_fn , navdot: navdot , dontshowonedot: dontshowonedot = false , bitesize: bitesize  }) {
    const { dlog: dlog , catchify: catchify  } = t;
    const button_states = [];
    const unique_name = Math.round(Math.random() * 1000000);
    function constructor_plugin() {
        // this = slider instance
        const navcont = document.createElement("div");
        navcont.classList.add("navigation_dots");
        this.navcont = navcont;
        if (navcont_insertion_fn) navcont_insertion_fn(this, navcont);
        else {
            const { container: container  } = this;
            container.append(navcont);
        }
    }
    let amount_of_visible_elements = 4; // 4 is just a number to initialize it. Needs to be here so that the event listener gets an updated amount when the window is resized
    function mutation_plugin(intersections, intersecting_mutations) {
        const only_visible_children = (children)=>[
                ...children
            ].filter((el)=>el.offsetParent !== null);
        const { insert_here: sliding , navcont: navcont  } = this;
        const { children: children , offsetWidth: width_of_container  } = sliding;
        const [first_child] = children;
        const amount_of_elements = only_visible_children(children).length;
        const width_of_one_element = first_child.getBoundingClientRect().width;
        const actual_amount_of_visible_elements = width_of_container / width_of_one_element;
        amount_of_visible_elements = bitesize || actual_amount_of_visible_elements; // also bitesize
        const number_of_slides = Math.round(amount_of_elements / amount_of_visible_elements); /* - actual_amount_of_visible_elements + 1*/ 
        const number_of_radio_buttons = only_visible_children(this.navcont.children).length;
        const first_shown_element = +Object.keys(Object.fromEntries(Object.entries(intersecting_mutations).filter(([_, v])=>v.intersectionRatio > 0.1)))[0];
        const position = Math.round(first_shown_element / amount_of_elements * number_of_slides);
        const get_inputs = ()=>navcont.querySelectorAll("input");
        if (number_of_radio_buttons != number_of_slides) {
            dlog("Number of buttons doesn't match number of slides, rerendering buttons", button_states);
            navcont.innerHTML = "";
            if (number_of_slides === 1 && dontshowonedot) {
                dlog("dontshowonedot is on, not rendering any dots");
                return;
            }
            if (number_of_slides == Infinity) {
                dlog("Infinite number of slides, wtf", number_of_slides);
                return;
            }
            for(let i = 0; i < number_of_slides; i++){
                const a_navdot = navdot(unique_name, i);
                const input = a_navdot.querySelector("input");
                if (process.env.DEBUG === "true" && !input) throw new Error("You need to provide a navdot that contains an <input> element to slider_dots");
                input.checked = button_states[i];
                input.addEventListener("click", catchify((e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    dlog("Someone checked a box", e);
                    this.scroll_to_abs(Math.round(amount_of_visible_elements * i));
                    return false;
                }));
                navcont.append(a_navdot);
            }
        }
        const inputs = get_inputs();
        for(let i = 0; i < number_of_slides; i++)set_input(inputs[i], i, position == i);
    }
    function set_input(input, index, value) {
        if (button_states[index] !== value) {
            input.checked = value;
            button_states[index] = value;
        }
    }
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin
    };
}
function $2436f68ea927d4a8$export$a09282b33e69b43f(unique_name) {
    return (0, $63cbb5de51d11596$export$25062201e9e25d76)("label", {
        class: "checkbox_container",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("input", {
                type: "radio",
                name: `radio-${unique_name}`
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("span", {
                class: "checkmark"
            })
        ]
    });
}


// // You need to do this on all elements you insert into the slider before you insert them:
//
// querySelectorAllElements(rendered_slider, ".rec_outer, img, canvas").forEach(el => {
//   el.draggable = false;
//   el.addEventListener("dragstart", e => {
//     e.preventDefault();
//     return false; // https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser
//   });
// });

function $9bb2400c4e2e9335$export$411b0f20794697ce(t) {
    const { dlog: dlog , catchify: catchify , err: err  } = t;
    function constructor_plugin(slider_options) {
        const { insert_here: sliding  } = this;
        let last_mouse_position = 0;
        let starting_position = 0;
        let block_anchor_clicks = false;
        sliding.addEventListener("mousedown", catchify((e)=>{
            sliding.classList.remove("slider_snap");
            const { snap_style: snap_style  } = this;
            if (snap_style) snap_style.remove();
            sliding.classList.add("grabbing");
            last_mouse_position = starting_position = e.clientX;
            sliding.addEventListener("mousemove", scroll_on_mousemove);
        }));
        window.addEventListener("mouseup", catchify((e)=>{
            // use window to prevent dragging from getting stuck
            sliding.classList.remove("grabbing");
            sliding.classList.add("slider_snap");
            sliding.removeEventListener("mousemove", scroll_on_mousemove);
            // readd snap css if needed
            const { snap_style: snap_style  } = this;
            if (snap_style) {
                this.container.append(snap_style);
                // make a scroll so the browser snaps
                // it doesn't snap smoothly. Fuck.
                sliding.scrollBy({
                    left: 0,
                    top: 0,
                    behavior: "smooth"
                });
            }
        }));
        sliding.addEventListener("click", catchify((e)=>{
            if (block_anchor_clicks) {
                dlog("Block anchor clicks is true, blocking click", e);
                block_anchor_clicks = false;
                e.preventDefault();
                return false;
            }
        }));
        function scroll_on_mousemove(e) {
            try {
                const { clientX: clientX  } = e;
                if (Math.abs(clientX - starting_position) > 10) block_anchor_clicks = true;
                sliding.scrollBy({
                    left: last_mouse_position - clientX
                });
                last_mouse_position = clientX;
            } catch (e) {
                err(e);
            }
        }
    }
    function mutation_plugin(intersections, intersecting_mutations) {}
    function instant_post_pro(items) {
        (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(items, "a, img, canvas").forEach((el)=>{
            // @ts-ignore
            el.draggable = false;
            el.addEventListener("dragstart", (e)=>{
                e.preventDefault();
                return false; // https://stackoverflow.com/questions/26356877/html5-draggable-false-not-working-in-firefox-browser
            });
        });
    }
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin,
        post_pro_plugin: {
            instant: instant_post_pro
        }
    };
}


function $1ce2ae6f640f393f$export$5129719c04a52f8c({ fade_in_duration_: fade_in_duration_ = 0 , fade_out_duration_: fade_out_duration_ = 0 , visible_opacity_: visible_opacity_ = 1 , faded_opacity_: faded_opacity_ = 0.5 , easing_: easing_ = "linear" , threshold_: threshold_ = 0.5  } = {}) {
    const faded_els = /*@__PURE__*/ new WeakSet();
    function mutation_plugin_(entries, _intersecting_mutations) {
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const { target: target  } = entry;
            const should_be_faded = entry.intersectionRatio <= threshold_;
            if (should_be_faded !== faded_els.has(target)) {
                faded_els[should_be_faded ? "add" : "delete"](target);
                // try to fix https://sentry.io/organizations/depictai-0o/issues/3391798259/?project=5476183&query=is%3Aunresolved+animate&statsPeriod=14d
                target.animate({
                    opacity: [
                        should_be_faded ? visible_opacity_ : faded_opacity_,
                        should_be_faded ? faded_opacity_ : visible_opacity_
                    ]
                }, {
                    fill: "forwards",
                    duration: should_be_faded ? fade_out_duration_ : fade_in_duration_,
                    easing: easing_
                });
            }
        }
    }
    return {
        mutation_plugin_: mutation_plugin_
    };
}





function $52292921bc0fc31f$export$5723caf9a8335aa6(_t, fraction = 1, max_steps, dont_enable_correct_bs_targets, min_steps) {
    function constructor_plugin(slider_options) {
        const fallback_stepsize = slider_options.stepstoslide || 2;
        const { insert_here: sliding  } = this;
        if (!dont_enable_correct_bs_targets) this.correct_bs_targets = true;
        Object.defineProperty(this, "stepstoslide", {
            configurable: true,
            enumerable: true,
            set (v) {
                (0, $7547e32486a3abc0$export$8048b892d651b310)(new Error("Cannot set steps to slide manually when using fractional scroll"));
                return v;
            },
            get: (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
                const sliding_width = sliding.getBoundingClientRect().width;
                const first_rec = sliding.firstElementChild;
                if (!first_rec) // maybe slider has no elements
                return fallback_stepsize;
                const width_of_first = first_rec.getBoundingClientRect().width;
                const calculated_stepsize = Math.round(Math.floor(sliding_width / width_of_first) * fraction);
                // dlog("calculated stepsize is", calculated_stepsize);
                const stepsize_limited_up = max_steps && calculated_stepsize > max_steps ? max_steps : calculated_stepsize;
                const stepsize_limited_up_and_down = min_steps && stepsize_limited_up < min_steps ? min_steps : stepsize_limited_up;
                const stepby = stepsize_limited_up_and_down || fallback_stepsize;
                if (stepby != calculated_stepsize) (0, $649f456f663da9fc$export$de56f1198d121036)("going by", stepby, "because of max_steps or invalid stepsize");
                return stepby;
            })
        });
    }
    function mutation_plugin(intersections, intersecting_mutations) {}
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin
    };
}



function $f78bc6a06402a6cf$export$93223e488e7ee078(options) {
    function constructor_plugin(_slider_options) {
        const scroll_bar = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            class: "depict_slider_scroll_bar"
        });
        const scroll_container = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            class: "depict_slider_scroll_container"
        });
        if (options.scroll_bar_classes?.length) scroll_bar.classList.add(...options.scroll_bar_classes);
        if (options.scroll_container_classes?.length) scroll_container.classList.add(...options.scroll_container_classes);
        // Default styles always present
        scroll_container.style.overflowX = "hidden";
        scroll_bar.style.left = "0";
        if (options.add_position_styling) {
            scroll_bar.style.position = "absolute";
            scroll_container.style.position = "relative";
        }
        scroll_container.append(scroll_bar);
        this.container.append(scroll_container);
        this.scroll_bar = scroll_bar;
    }
    function mutation_plugin(_intersections, _intersecting_mutations) {
        const { insert_here: slider  } = this;
        const scrolled = slider.scrollLeft / slider.scrollWidth * 100;
        this.scroll_bar.style.width = `${Math.round(slider.offsetWidth / slider.scrollWidth * 100)}%`;
        this.scroll_bar.style.left = `${scrolled}%`;
    }
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin
    };
}







function $06fe260f91efff62$export$b36d2489a5a16728(_t, { snapEvery: snapEvery , align: align  } = {}) {
    function constructor_plugin(_slider_options) {
        const slider_this = this;
        const random_classname = "x" + (0, $460df8550f9d084d$export$656831b7e9c341c3)().replaceAll(".", "");
        slider_this.insert_here.classList.add(random_classname);
        const style = document.createElement("style");
        style.append(`.depict .${random_classname}{scroll-snap-type:x mandatory}.depict .${random_classname}>*:nth-child(${snapEvery ?? 1}n + 1){scroll-snap-align:${align || "start"}}`);
        slider_this.snap_style = slider_this.container.appendChild(style);
        $06fe260f91efff62$export$49b950309ab787ad().then((we_can)=>{
            if (!we_can) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("Disabling slider snapping due browser where it's impossible to have working buttons and css snapping");
                style.remove();
                delete slider_this["snap_style"];
            }
        }).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
    }
    function mutation_plugin(_intersections, intersecting_mutations) {
    // const visible_elems Object.keys(intersecting_mutations).length
    }
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin
    };
}
async function $06fe260f91efff62$export$49b950309ab787ad() {
    if ("scrollBehavior" in document.documentElement.style) return true;
    const test_div = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
        style: "position: absolute; width: 1em; overflow: scroll; scroll-snap-type: x mandatory;",
        children: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            style: "scroll-snap-align: start; color: transparent;",
            children: "test"
        })
    });
    const body = await (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element("body");
    body.append(test_div);
    test_div.scrollLeft = 1;
    const can_be_scrolled = test_div.scrollLeft === 1;
    test_div.remove();
    return can_be_scrolled;
}



function $40bfd400d76a6ec1$export$dac64fd35a4805a4(options = {}) {
    const threshold = options.threshold ?? 0.8;
    const ratio_left = {
        ratio: 0,
        element: document.createElement("div") // createElement is just for typescript
    };
    const ratio_right = {
        ratio: 0,
        element: document.createElement("div") // createElement is just for typescript
    };
    const lock_on_element = {
        left: ratio_left.element,
        right: ratio_right.element,
        lock_active: false
    };
    let currently_left = "0";
    function constructor_plugin(slider_options) {
        const { insert_here: sliding  } = this;
        const scroll_abs_no_negative = (target)=>this.scroll_to_abs(target < 0 ? 0 : target); // the slider ignores everything < 0 but we want it to move to the first card
        sliding.addEventListener("mousedown", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            lock_on_element.lock_active = true;
            const starting_ratio_left = ratio_left.ratio;
            lock_on_element.left = ratio_left.element;
            const starting_ratio_right = ratio_right.ratio;
            lock_on_element.right = ratio_right.element;
            const scroll_left_start = sliding.scrollLeft;
            const mouseup_listener = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((e)=>{
                lock_on_element.lock_active = false;
                const delta_left = Math.abs(ratio_left.ratio - starting_ratio_left);
                const delta_right = Math.abs(ratio_right.ratio - starting_ratio_right);
                // dlog({ delta_left, delta_right }, "elements", ratio_left.element, ratio_right.element);
                window.removeEventListener("mouseup", mouseup_listener);
                const scrolled_right = sliding.scrollLeft - scroll_left_start > 0;
                if (delta_left > threshold || delta_right > threshold || lock_on_element.left != ratio_left.element || lock_on_element.right != ratio_right.element) {
                    let currently_visible;
                    try {
                        currently_visible = Math.floor(this.insert_here.getBoundingClientRect().width / this.insert_here.firstElementChild.getBoundingClientRect().width);
                    } catch (e) {
                        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "warning");
                    }
                    const stepsize = options.stepsize || currently_visible || 4;
                    if (scrolled_right) scroll_abs_no_negative(+currently_left + stepsize);
                    else scroll_abs_no_negative(+currently_left - stepsize);
                } else {
                    const max_left = sliding.scrollLeft < 1;
                    const max_right = sliding.scrollLeft >= (sliding.scrollLeftMax || sliding.scrollWidth - sliding.clientWidth);
                    if (!(max_right || max_left)) // can't attempt to snap to current position when it's not possible because of an edge card being a half card
                    // brought back from the dead from https://gitlab.com/depict-ai/depict.ai/-/blob/f67c67591ab4b3d791a91909dab8fc315c87e64f/browser-tags-v2/src/mq/vasily_rec_bar.ts#L353
                    scroll_abs_no_negative(+currently_left);
                }
            });
            window.addEventListener("mouseup", mouseup_listener);
        }));
    }
    function find_intersection_ratio(records, target) {
        const target_index = records.map((record)=>record.target).indexOf(target);
        return records[target_index]?.intersectionRatio || 2; // element is probably no longer visible, return huge ratio
    }
    function mutation_plugin(intersections, intersecting_mutations) {
        const keys = Object.keys(intersecting_mutations);
        if (lock_on_element.lock_active) {
            const records = Object.values(intersecting_mutations);
            ratio_left.ratio = find_intersection_ratio(records, lock_on_element.left);
            ratio_right.ratio = find_intersection_ratio(records, lock_on_element.right);
        } else {
            const [index_of_first_intersection] = keys;
            currently_left = index_of_first_intersection;
            const [index_of_last_intersection] = keys.slice(-1);
            const first_intersection = intersecting_mutations[index_of_first_intersection];
            const last_intersection = intersecting_mutations[index_of_last_intersection];
            if (first_intersection) {
                ratio_left.ratio = first_intersection.intersectionRatio;
                ratio_left.element = first_intersection.target;
            }
            if (last_intersection) {
                ratio_right.ratio = last_intersection.intersectionRatio;
                ratio_right.element = last_intersection.target;
            }
        }
    }
    return {
        constructor_plugin: (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(constructor_plugin),
        mutation_plugin: (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(mutation_plugin)
    };
}







function $556d9c321900f1d4$export$53306504b987cbf7({ clones_per_side: clones_per_side = 8  } = {}) {
    // YOU NEED TO USE slider_snap_css FOR THIS TO WORK
    // only for usage with recommendation_renderer which you need to pass post_processor as LAST post processor
    const time_of_no_events_to_count_as_scroll_idle = 150;
    const originally_rendered_elements = [];
    const sets_of_els = [
        originally_rendered_elements
    ];
    const removed_by_us = new Set();
    let mutation_busy = false;
    let surplus_in_body = true;
    let last_move = window?.performance?.now?.() || +new Date();
    let touches = 0;
    let inactive_checker_running = false;
    let smallest_seen_intersection_ratio = 0.1;
    let largest_seen_interection_ratio = 0.9;
    let are_far_right = false;
    let inactive_checker_timeout;
    // let elgreen;
    const check_if_we_inactive = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(function() {
        // const { insert_here: sliding } = this;
        const now = window?.performance?.now?.() || +new Date();
        const time_since_ran = now - last_move;
        const last_left_intersection = this.first_intersecting;
        // dlog(last_left_intersection.intersectionRatio, smallest_seen_intersection_ratio, largest_seen_interection_ratio);
        if (time_since_ran > time_of_no_events_to_count_as_scroll_idle && !touches && last_left_intersection && (last_left_intersection.intersectionRatio <= smallest_seen_intersection_ratio || last_left_intersection.intersectionRatio >= largest_seen_interection_ratio || are_far_right)) {
            // if (!elgreen) {
            //   sliding.style.background = "green";
            //   elgreen = true;
            // }
            (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($556d9c321900f1d4$var$scroll_idle)(this, originally_rendered_elements.length, clones_per_side);
            inactive_checker_running = false;
        } else {
            // if (elgreen !== false) {
            // sliding.style.background = "red";
            // elgreen = false;
            // }
            const timeleft = time_of_no_events_to_count_as_scroll_idle - time_since_ran;
            if (timeleft < 1) requestAnimationFrame(check_if_we_inactive.bind(this));
            else setTimeout(check_if_we_inactive.bind(this), timeleft);
        }
    });
    function constructor_plugin() {
        window.addEventListener("touchstart", ()=>touches++);
        window.addEventListener("touchend", ()=>touches--);
        this.insert_here.addEventListener("scroll", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            last_move = window?.performance?.now?.() || +new Date();
        }));
        const mo = new MutationObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
            for (const record of records)for (const node of record.removedNodes){
                if (removed_by_us.has(node)) {
                    removed_by_us.delete(node);
                    continue;
                }
                for (const a_set of sets_of_els){
                    const index_in_el_set = a_set.indexOf(node);
                    if (index_in_el_set >= 0) {
                        (0, $649f456f663da9fc$export$de56f1198d121036)("Removing", node, "from el set", a_set);
                        a_set.splice(index_in_el_set, 1);
                    }
                }
            }
        }));
        mo.observe(this.insert_here, {
            childList: true
        });
    }
    function mutation_plugin(intersections, intersecting_mutations) {
        for(let i = 0; i < intersections.length; i++){
            const { intersectionRatio: intersectionRatio  } = intersections[i];
            const target_large = intersectionRatio * 0.95;
            const target_small = intersectionRatio * 1.05;
            if (target_large > largest_seen_interection_ratio && target_large < 0.999) largest_seen_interection_ratio = target_large;
            else if (intersectionRatio && target_small < smallest_seen_intersection_ratio && target_small > 0.0001) smallest_seen_intersection_ratio = target_small;
        }
        if (mutation_busy) return;
        mutation_busy = true;
        last_move = window?.performance?.now?.() || +new Date();
        const first_element = this.element_by_index(0);
        const second_element = this.element_by_index(1);
        let dont_wraparound = false;
        if (!first_element || !second_element) dont_wraparound = true;
        else {
            // calculate how many cards including margin the slider fits
            const first_rect = first_element.getBoundingClientRect();
            if (!first_rect.width) {
                (0, $649f456f663da9fc$export$de56f1198d121036)(first_rect);
                throw new Error("First rect doesn't have width");
            }
            const second_rect = second_element.getBoundingClientRect();
            const container_rect = this.insert_here.getBoundingClientRect();
            const margin = second_rect.left - first_rect.right;
            let width = 0;
            let amount = 0;
            while(width < container_rect.width){
                if (width < 0) throw new Error("width can't be < 0");
                width += first_rect.width + margin;
                amount++;
            }
            // dlog(originally_rendered_elements.length, amount);
            if (originally_rendered_elements.length <= amount) dont_wraparound = true;
        }
        if (dont_wraparound) {
            if (surplus_in_body) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("Removing surplus of els. Total els: ", sets_of_els);
                // @ts-ignore
                for(let i = (sets_of_els.length || 1) - 1; i--;)for(let j = 0; j < sets_of_els[i].length; j++){
                    const el = sets_of_els[i][j];
                    if ("remove" in el) {
                        removed_by_us.add(el);
                        el.remove();
                    }
                }
                this.invalidate_cache();
                surplus_in_body = false;
            }
            mutation_busy = false;
            return;
        }
        if (!surplus_in_body) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Adding surplus of els");
            this.insert_here.append(...sets_of_els.slice(0, -1).flat());
            this.invalidate_cache();
            surplus_in_body = true;
        }
        are_far_right = intersecting_mutations[this.index_of_last_element]?.intersectionRatio >= largest_seen_interection_ratio;
        clearTimeout(inactive_checker_timeout);
        inactive_checker_timeout = setTimeout((function() {
            if (!inactive_checker_running) {
                inactive_checker_running = true;
                check_if_we_inactive.call(this);
            }
        }).bind(this), time_of_no_events_to_count_as_scroll_idle * 0.8 // schedule a bit earlier so we hit our target
        );
        mutation_busy = false;
    }
    async function post_processor(elements, _display, info) {
        const { index: index , rendering_options: rendering_options  } = info;
        originally_rendered_elements.push(...elements);
        if (index === 0) {
            const { event_listeners: event_listeners  } = info; // so we don't want event listeners to be added twice. We will return our actual index 0 elements and all elements of all indexes. Tracking needs to be right per element per index. That's why we will now add our event listeners to our elements and then prevent RR from doing it for us on all returned elements, on which each RR run will get to add the correct individual ones
            while(event_listeners?.length){
                // order shouldn't matter, this is fast
                const event_listener = event_listeners.pop();
                for(let i = 0; i < elements.length; i++)elements[i].addEventListener(...event_listener);
            }
            // render all elements again four times and adds them to the beginning
            const post_processors = [
                ...rendering_options.post_processors || []
            ];
            const our_index = post_processors.indexOf(post_processor);
            if (our_index >= 0) post_processors.splice(our_index, 1);
            else {
                const msg = "Couldn't find ourselves in post processors, infinite loop might ensue. Exiting. Wraparound will be broken.";
                (0, $eba382943196079c$export$af2e17a20c2ea3c5).captureException(new Error(msg));
                (0, $649f456f663da9fc$export$de56f1198d121036)(msg, ()=>{});
                return elements;
            }
            for(let i = 0; i < clones_per_side * 2; i++){
                const additional_render = await (0, $5cbe24d064a033ed$export$a9fc160c5ed83bd7)(info.t, {
                    ...rendering_options,
                    post_processors: post_processors,
                    pre_processors: [],
                    // don't need to execute pre processors again, displays are already pre-processed
                    recs: info.displays
                });
                sets_of_els.push([
                    ...additional_render.elements
                ]);
            }
            sets_of_els.reverse(); // here sets_of_els gets modified and reversed
            const sets_of_els_without_items_1_plus_n_from_first_render = [
                ...sets_of_els
            ];
            const index_of_first_render = sets_of_els_without_items_1_plus_n_from_first_render.indexOf(originally_rendered_elements);
            if (index_of_first_render < 0) throw new Error("Something's weird, pls check");
            sets_of_els_without_items_1_plus_n_from_first_render[index_of_first_render] = elements;
            // we cannot return the array that _might_ contain the elements from the other rendering passes that run asynchronously, this might lead to duplicated event listeners
            return sets_of_els_without_items_1_plus_n_from_first_render.flat();
        } else return elements;
    }
    return {
        constructor_plugin: constructor_plugin,
        mutation_plugin: mutation_plugin,
        post_processor: post_processor
    };
}
function $556d9c321900f1d4$var$scroll_idle(slider, chunk_size, clones_per_side) {
    const { insert_here: sliding  } = slider;
    const slider_box = sliding.getBoundingClientRect();
    const leftmost_rect = slider.element_by_index(0).getBoundingClientRect();
    const rightmost_rect = slider.element_by_index(slider.index_of_last_element).getBoundingClientRect();
    const leftmost_card_to_left_viewport_edge = slider_box.left - leftmost_rect.left;
    const rightmost_card_to_right_viewport_edge = rightmost_rect.right - slider_box.right;
    const children = [
        ...sliding.children
    ];
    const { intersecting_items_object: intersecting_items_object  } = slider;
    const index_of_first_intersecting = slider.first_intersecting_index();
    const index_of_last_intersecting = Math.max(...Object.keys(intersecting_items_object).map((v)=>+v));
    const post_move = (direction)=>{
        // slider.invalidate_cache();
        // for (const key in intersecting_items_object) {
        //   const value = intersecting_items_object[key];
        //   delete intersecting_items_object[key];
        //   intersecting_items_object[slider.get_index_of_element(value.target)] = value;
        // }
        slider.scroll_to_abs(index_of_first_intersecting - direction * chunk_size, true);
    };
    // dlog(index_of_first_intersecting, index_of_last_intersecting);
    if (index_of_first_intersecting >= chunk_size * clones_per_side && index_of_first_intersecting <= chunk_size * (clones_per_side + 1)) ;
    else {
        if (leftmost_card_to_left_viewport_edge > rightmost_card_to_right_viewport_edge * 1.1 /* add 10% margin */ ) // dlog("Moving", chunk_size, "to the right");
        // sliding.append(...children.slice(0, chunk_size));
        post_move(1);
        else if (rightmost_card_to_right_viewport_edge > leftmost_card_to_left_viewport_edge * 1.1) // dlog("Moving", chunk_size, "to the left");
        // sliding.prepend(...children.slice(-chunk_size));
        post_move(-1);
    }
// dlog("Scroll idle", leftmost_card_to_left_viewport_edge, rightmost_card_to_right_viewport_edge);
}





const $49c4fa2e27e642fa$var$connection_map = /*@__PURE__*/ new WeakMap();
function $49c4fa2e27e642fa$export$3d04c40e7acc1a32(initial_value) {
    let subscribed = false;
    const subscriber_array_fns = new Set();
    const template_text_node = document.createTextNode("");
    const current_els = [
        template_text_node
    ];
    let state;
    const get_state = ()=>{
        if (subscribed) return subscribed.get_state_();
        else return state;
    };
    const update_state = (new_value)=>{
        if (subscribed) {
            // break subscription  - we're supposed to get a new value
            subscribed.unsubscribe_();
            subscribed = false;
        }
        const input_as_array = typeof new_value === "object" && typeof new_value?.[Symbol.iterator] === "function" ? [
            ...new_value
        ] : [
            new_value
        ];
        if (!input_as_array.length) input_as_array.push(template_text_node.cloneNode());
        const array_with_replacewithable_nodes = [];
        for(let i = 0; i < input_as_array.length; i++){
            const entry = input_as_array[i];
            if (!(entry instanceof Node)) array_with_replacewithable_nodes.push(document.createTextNode(entry));
            else if (entry instanceof DocumentFragment) array_with_replacewithable_nodes.push(...entry.childNodes);
            else array_with_replacewithable_nodes.push(entry);
        }
        // we need to remove the overshoot-nodes first since they might contain one of the new nodes in array_with_replacewithable_nodes, in which case we would otherwise first re-insert them and then remove them
        for(let i = 1; i < current_els.length; i++)current_els[i].remove();
        current_els[0].replaceWith(...array_with_replacewithable_nodes);
        while(current_els.length)current_els.pop();
        current_els.push(...array_with_replacewithable_nodes);
        for (const set_fn of subscriber_array_fns)set_fn(array_with_replacewithable_nodes);
        state = new_value;
        // set subscribed and then synchronize here, if should subscribe
        const connection_fn = $49c4fa2e27e642fa$var$connection_map.get(new_value /* if we get updated to the `elements` of another reactive_template it has to be an array */ );
        if (connection_fn) // merge with reactive_template we got set to
        subscribed = connection_fn((new_state)=>{
            while(current_els.length)current_els.pop();
            current_els.push(...new_state);
        });
    };
    if (initial_value != null) update_state(initial_value);
    $49c4fa2e27e642fa$var$connection_map.set(current_els, (set_template_array)=>{
        subscriber_array_fns.add(set_template_array);
        set_template_array(current_els);
        return {
            get_state_: get_state,
            unsubscribe_: ()=>subscriber_array_fns.delete(set_template_array)
        };
    });
    return [
        current_els,
        get_state,
        update_state
    ];
}





function $29407d8301dc2f23$export$515c3ea4d599b05a(// inspired by code in houdinisportswear modify script
query, handler, initial_call = true) {
    const catchified_handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(handler, "Error in media query listener callback");
    if (typeof window !== "object") {
        // on server call the handler in case nothing is rendered if it isn't called, then do nothing
        catchified_handler({
            matches: false
        });
        return {
            remove () {}
        };
    }
    const media_query = window?.matchMedia?.(query);
    if (initial_call && media_query) catchified_handler(media_query);
    let the_function;
    if (the_function = media_query?.addEventListener) the_function.call(media_query, "change", catchified_handler);
    else if (the_function = media_query?.addListener) the_function.call(media_query, catchified_handler);
    return {
        remove () {
            let remove_function;
            if (remove_function = media_query?.removeEventListener) remove_function.call(media_query, "change", catchified_handler);
            else if (remove_function = media_query?.removeListener) remove_function.call(media_query, catchified_handler);
        }
    };
}


async function $159237486410355f$export$417ef0ab13d8b984({ surface_rendering_functions_: surface_rendering_functions_ , current_surface_: current_surface_  }) {
    let resolve_success_promise;
    const success_promise = new Promise((r)=>resolve_success_promise = r);
    const cache = new Map();
    const [template_els, _get, set_els] = (0, $49c4fa2e27e642fa$export$3d04c40e7acc1a32)();
    const catchified_switch_to_surface = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($159237486410355f$var$switch_to_surface);
    (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ()=>{
        for await (const surface of current_surface_){
            const rendering_function = surface_rendering_functions_[surface];
            catchified_switch_to_surface(surface, rendering_function, current_surface_, cache, set_els, resolve_success_promise);
        }
    })();
    const fake_surface = {
        elements: template_els,
        should_stay_inserted: success_promise
    };
    return fake_surface;
}
async function $159237486410355f$var$switch_to_surface(surface_index, rendering_function, current_surface_ipns, cache, set_els, resolve_success_promise) {
    let rendered_surface = cache.get(surface_index);
    if (!rendered_surface) {
        const { cache_until_: cache_until_ , surface_: surface_  } = await rendering_function().catch((e)=>((0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                e,
                "error in rendering"
            ], "warning"), {}));
        if (!surface_ || !surface_?.elements?.length) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Got no/empty surface, not switching");
            // also tell insert_surface that we didn't get recs so it can revert, dunno if we want this
            resolve_success_promise(false);
            return;
        }
        rendered_surface = surface_;
        if (cache_until_ instanceof Promise) {
            cache.set(surface_index, surface_);
            cache_until_.then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>cache.delete(surface_index)));
        }
    }
    if (current_surface_ipns.state !== surface_index) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Surface switched to", current_surface_ipns.state, "while rendering surface", surface_index, "discarding results");
        return;
    }
    set_els(rendered_surface.elements);
    if (rendered_surface.should_stay_inserted instanceof Promise) // if there is promise that says if surface succeeded or not, use that
    rendered_surface.should_stay_inserted.then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((success)=>{
        resolve_success_promise(success);
    }));
    else // otherwise let's just assume it suceeded since there are elements
    resolve_success_promise(true);
}
function $159237486410355f$export$419f84efad7d9fe(surface_per_size, cleanup_promise) {
    let microtask_queued = false;
    const ipns = (0, $607fc90221d440a6$export$e806c6c1615a59ae)();
    const target_indexes = new Set();
    const dedupe_overlapping_queries = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
        microtask_queued = false;
        const first_value = target_indexes[Symbol.iterator]().next().value;
        if (first_value === ipns.latest_call_value) (0, $649f456f663da9fc$export$de56f1198d121036)("surface", first_value, "is already selected");
        else ipns(first_value);
        if (target_indexes.size > 1) {
            const error_string = "Multiple matching media queries detected, used first one: " + JSON.stringify(surface_per_size.filter(([index])=>target_indexes.has(index)));
            target_indexes.clear();
            throw new Error(error_string);
        }
        target_indexes.clear();
    });
    surface_per_size.forEach(([surface_index, min, max])=>{
        const media_query = (0, $30e801eaa3dc319e$export$5c4e09968d6eab33)(min, max).split("@media ").pop();
        const { remove: remove  } = (0, $29407d8301dc2f23$export$515c3ea4d599b05a)(media_query, ({ matches: matches  })=>{
            if (!matches) return;
            target_indexes.add(surface_index);
            if (!microtask_queued) {
                queueMicrotask(dedupe_overlapping_queries);
                microtask_queued = true;
            }
        });
        if (cleanup_promise instanceof Promise) cleanup_promise.then(remove);
        else (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(remove);
    });
    return ipns;
}
function $159237486410355f$export$be95cb0e8cfd099e() {
    return new Promise((r)=>(0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(r));
}

















function $847e4a06ea6767c0$export$3ebd86018b39d9d2(t, selector, filter) {
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(selector, (eoe)=>{
        (0, $649f456f663da9fc$export$de56f1198d121036)("Order confirmation element showed up!", eoe);
        const { element: element  } = eoe;
        const the_id = element.innerText;
        $847e4a06ea6767c0$export$1ac466d53a6636ac(t, the_id, (0, $43683b1103edab15$export$6399bdb2291895e0)(), filter);
    });
}
function $847e4a06ea6767c0$export$b11248fa13a8a86c(tenant, id_extractor) {
    // Use the given extractor to find a transaction ID from each entry pushed to dataLayer.
    // If it finds any IDs, send them.
    const maybe_send_entries = (entries)=>entries.map(id_extractor).filter((id)=>id && typeof id === "string").forEach((id)=>{
            $847e4a06ea6767c0$export$1ac466d53a6636ac(tenant, id);
        });
    const dataLayer = globalThis.dataLayer ||= [];
    // Process entries that are already queued at this point
    maybe_send_entries(dataLayer);
    // And then process any future entries, making sure to pass them on to other potential proxies to the push function
    dataLayer.push = new Proxy(dataLayer.push, {
        apply (target, this_arg, args_list) {
            try {
                maybe_send_entries(args_list);
            } catch (e) {
                (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                    e,
                    "Extracting and sending transaction IDs from dataLayer failed"
                ], "warning");
            }
            return target.apply(this_arg, args_list);
        }
    });
}
function $847e4a06ea6767c0$export$ff8673d5dea82bd4(tenant, id_extractor) {
    (async ()=>{
        for await (const href of (0, $0d2acf276472ebf7$export$a9d39e43ae273d26)){
            const order_id = id_extractor(new URL(href));
            if (order_id && typeof order_id === "string") $847e4a06ea6767c0$export$1ac466d53a6636ac(tenant, order_id);
        }
    })().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            e,
            "Extracting and sending transaction IDs from URL failed"
        ], "warning"));
}
function $847e4a06ea6767c0$export$1ac466d53a6636ac(t, input_id, dsid = (0, $43683b1103edab15$export$6399bdb2291895e0)(), filter) {
    const transaction_id = typeof filter == "function" ? filter(input_id) : input_id;
    if (!transaction_id) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Not sending", transaction_id, "because it didn't pass filter");
        return;
    }
    (0, $649f456f663da9fc$export$de56f1198d121036)("Sending this order id:", transaction_id, "(before filtering it was", input_id, ")");
    const payload = {
        "tenant": t.tenant,
        "market": t.market,
        "events": [
            {
                event_type: "transaction_mapping",
                transaction_id: transaction_id,
                dsid: dsid
            }
        ]
    };
    (0, $cafa1ff1049985c2$export$cc3b6ddf805f6156)((0, $6c2b49f3f564b0d1$export$362abebb4b313340) + "/v2/track", payload);
}





function $3abef00489070e23$export$1ff14fec60ed5697(t, filter) {
    try {
        (0, $42bbbba8196bd057$export$674d8cd8b6868154)();
        ga((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async function(tracker) {
            let get_all_function = window?.ga?.getAll; // https://sentry.io/organizations/depictai-0o/issues/3621911835/?project=5476183&referrer=slack
            if (typeof get_all_function !== "function") get_all_function = await (0, $d0e7629fb3179e02$export$2fc1a072736ae2f6)(window, "ga", "getAll");
            const all_trackers = get_all_function.call(ga);
            (0, $649f456f663da9fc$export$de56f1198d121036)("we have trackers", all_trackers);
            // @ts-ignore
            const { P: P  } = ga;
            (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(modify_trackers_of_iterable)(all_trackers);
            if (typeof P?.push === "function") // this check is just so we don't fail if this doesn't exist for some reason, but it always should
            P.push = new Proxy(P.push, {
                apply (target, this_arg, args_list) {
                    const retval = target.apply(this_arg, args_list);
                    (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(modify_trackers_of_iterable)(args_list);
                    return retval;
                }
            });
            function modify_trackers_of_iterable(array) {
                for (const tracker of array)(0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($3abef00489070e23$var$make_tracker_send_to_depict)(tracker, t, filter);
            }
        }));
    } catch (error) {
        (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(error, "error");
    }
}
function $3abef00489070e23$var$make_tracker_send_to_depict(ga_tracker, t, filter) {
    // Docs for analytics.js Tasks:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
    const sendHitTask = "sendHitTask";
    const originalSendHitTask = ga_tracker.get(sendHitTask);
    ga_tracker.set(sendHitTask, (model)=>{
        originalSendHitTask(model);
        // console.log('Sent original hit, now sending to depict');
        try {
            const dsid = (0, $43683b1103edab15$export$6399bdb2291895e0)();
            const payload = model.get("hitPayload");
            const sp = new URLSearchParams(payload);
            const id = sp.get("ti");
            if (id) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("Got interesting analytics request", payload, id);
                (0, $847e4a06ea6767c0$export$1ac466d53a6636ac)(t, id, dsid, filter);
            }
        } catch (e) {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)(e, "error");
        }
    });
}











async function $54793663e06a1437$export$d63b08f4f29ddba5(t, unavailability_type) {
    const product_id = await t.get_product_id();
    (0, $649f456f663da9fc$export$de56f1198d121036)(`Notifying Depict that product id: ${product_id} is ${unavailability_type}`);
    const payload = {
        "tenant": t.tenant,
        "market": t.market,
        "events": [
            {
                event_type: "product_unavailable",
                product_id: product_id,
                unavailability_type: unavailability_type,
                user_id: (0, $43683b1103edab15$export$adc61a405a4cabed)(),
                dsid: (0, $43683b1103edab15$export$6399bdb2291895e0)()
            }
        ]
    };
    (0, $cafa1ff1049985c2$export$cc3b6ddf805f6156)((0, $6c2b49f3f564b0d1$export$362abebb4b313340) + "/v2/track", payload);
}




/**
 * Set but you can listen for values being added or removed
 * i.e. my_set.addEventListener("add", ({detail}) => console.log(detail, "was added to", my_set));
 */ class $2030306bed68a8c7$export$74108888f38788f3 extends Set {
    #et = new EventTarget();
    addEventListener(event, callback, options) {
        this.#et.addEventListener(event, callback, options);
    }
    removeEventListener(event, callback) {
        this.#et.removeEventListener(event, callback);
    }
    add(property) {
        Set.prototype.add.call(this, property);
        this.#et.dispatchEvent(new CustomEvent("add", {
            detail: property
        }));
        return this;
    }
    delete(property) {
        const return_value = Set.prototype.delete.call(this, property);
        this.#et.dispatchEvent(new CustomEvent("delete", {
            detail: property
        }));
        return return_value;
    }
}




/**
 * This does what you'd think Element.closest does. It finds the closest node in the DOM tree matching a selector. So it starts out with the siblings and then goes upwards in the DOM and checks the siblings and their children of the parent until there's no parent anymore.
 * @param  element                        Element to start out at
 * @param  selector                       Selector to search for
 * @param  start_right=true               In what direction to start: true = right, false = left
 * @return                                The found element or undefined
 */ function $1ce9aeebfbcb93f9$export$d9fdc6ce2907f95b(element, selector, start_right = true) {
    for(; element; element = element.parentNode){
        if (element?.matches?.(selector)) return element;
        const has_matching_child = element?.querySelector?.(selector);
        if (has_matching_child) return has_matching_child;
        const child_nodes = [
            ...element?.parentNode?.childNodes || []
        ];
        const our_index = child_nodes.indexOf(element);
        for(let i = 0; i < Math.ceil(child_nodes.length / 2); i++)for(let j = 2; j--;){
            const direction = start_right ? j ? 1 : -1 : j ? -1 : 1;
            const node_to_test = child_nodes[our_index + i * direction];
            if (node_to_test?.matches?.(selector)) return node_to_test;
            const matching_child = node_to_test?.querySelector?.(selector);
            if (matching_child) return matching_child;
        }
    }
}



const $d832040ef2097a0e$export$6b75200e58bc97d0 = (arr1, arr2, compareFunc)=>{
    return arr1.filter((e1)=>arr2.every((e2)=>!compareFunc(e1, e2)));
};
const $d832040ef2097a0e$export$9426572bd5645bc1 = (arr1, arr2)=>$d832040ef2097a0e$export$6b75200e58bc97d0(arr1, arr2 || [], (i1, i2)=>i1.product_id === i2.product_id);



function $ead1f6ae93c69da9$export$82539d9817116aff(e, url) {
    if (e.button) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Not single page navigating because button is not 0", e);
        return;
    }
    if (e.metaKey || e.ctrlKey) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Someone command-clicked a link, not single page navigating");
        return;
    }
    // single page navigate
    const router = window?.next?.router;
    if (typeof router?.push == "function") {
        const parsed = new URL(url);
        const path_and_query_params = parsed.pathname + parsed.search;
        router.push(path_and_query_params, path_and_query_params, {
            shallow: false,
            scroll: true
        });
        e.preventDefault();
        return false;
    }
}


/**
 * This module contains utillities for working with ecom sites using shoppify.
 *
 * Shopify cart API reference: https://shopify.dev/api/ajax/reference/cart
 */ 

async function $b6f5b218b1a73900$export$85be83e1935d93c2(fetch_proxy_handler, // we assume fetch is actually fetch, therefore proxy handler is typed like this
unsafe_throw_up = false) {
    window.fetch = new Proxy(window.fetch, {
        apply: fetch_apply
    }); // this is the magic
    async function fetch_apply(target, this_arg, arguments_list) {
        // this wraps fetch_proxy_handler in case it fails
        // the types of the arguments of this function *should* be the same as for fetch_proxy_handler but are written as `any` because someone MIGHT replace fetch and they'd no longer be accurate
        if (unsafe_throw_up) return await fetch_proxy_handler(target, this_arg, arguments_list);
        return await fetch_proxy_handler(target, this_arg, arguments_list)?.catch?.((0, $7547e32486a3abc0$export$8048b892d651b310)) || await target.apply(this_arg, arguments_list);
    }
}
class $b6f5b218b1a73900$export$f8da66bc4f1d059e extends Response {
    constructor(response_string, url, headers = {}, override_options = {}){
        const options = {
            status: 200,
            statusText: "OK",
            headers: {
                "content-type": "application/json; charset=utf-8",
                ...headers
            },
            ...override_options
        };
        super(response_string, options);
        Object.defineProperty(this, "url", {
            value: url,
            configurable: true,
            enumerable: true
        });
        Object.defineProperty(this, "type", {
            value: "basic",
            configurable: true,
            enumerable: true
        });
    }
}




function $802201ed0a316c43$export$ab0f802c05dd969b(on_request) {
    (0, $b6f5b218b1a73900$export$85be83e1935d93c2)(async (target, this_arg, argument_list)=>{
        const response_promise = target.apply(this_arg, argument_list);
        try {
            const input = argument_list[0];
            const url = input instanceof Request ? input.url : input instanceof URL ? input.href : input;
            // TODO, doing it like this doesn't feel very robust.
            // And what if the developer wants to override which url's corespond to which events?
            const url_segement_to_type = [
                [
                    "/cart.js",
                    "get_items"
                ],
                [
                    "/cart/add.js",
                    "add_items"
                ],
                [
                    "/cart/update.js",
                    "update_items"
                ],
                [
                    "/cart/change.js",
                    "change_items"
                ],
                [
                    "/cart/clear.js",
                    "clear_items"
                ]
            ];
            for (const [segment, type] of url_segement_to_type){
                if (!url.includes(segment)) continue;
                let decoded_body;
                try {
                    const body = argument_list[1]?.body;
                    if (typeof body === "string") decoded_body = JSON.parse(body);
                } catch (e) {}
                const body = decoded_body ? {
                    body: decoded_body
                } : {};
                if (type === "clear_items") on_request({
                    type: "clear_items",
                    response: response_promise.then(()=>[]),
                    ...body
                });
                else on_request({
                    type: type,
                    ...body,
                    response: response_promise.then(async (response)=>{
                        const response_copy = response.clone();
                        // The raw untyped shopify response
                        const json = await response_copy.json();
                        // There wasn't an `items` field, so we assume there was an error
                        if (typeof json.items === "undefined") return json;
                        else return json.items;
                    })
                });
                break;
            }
        } catch (e) {
            (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                e,
                "error in shopify interception logic"
            ], "warning");
        }
        return await response_promise;
    }, true);
}
async function $802201ed0a316c43$export$774bc87373c4fc6c(shopify_id, options) {
    const id = shopify_id;
    const quantity = options?.quantity ?? 1;
    const url = "/cart/add.js";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            items: [
                {
                    id: id,
                    quantity: quantity
                }
            ]
        })
    });
    const json = await response.json();
    if (Array.isArray(json.items)) return json.items;
    else if (typeof json.status === "number") return json;
    else throw new Error(`Shopify ${url} did not respond as expected`);
}
async function $802201ed0a316c43$export$337197b94b3bd680() {
    const url = "/cart.js";
    const response = await fetch(url, {
        method: "GET"
    });
    const json = await response.json();
    if (Array.isArray(json.items)) return json.items;
    else if (typeof json.status === "number") return json;
    else throw new Error(`Shopify ${url} did not respond as expected`);
}
const $802201ed0a316c43$export$783ef16647773b3d = (0, $511123bb28a7b6f7$export$535946eb77c946dd)((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async ()=>{
    const meta = await (0, $d0e7629fb3179e02$export$2fc1a072736ae2f6)(window, "ShopifyAnalytics", "meta");
    return meta?.product;
}));





async function $1813f33dd0fc7e1d$export$b404e20f3c4a490e({ t: t , experiment_id: experiment_id , functions_to_variants: functions_to_variants  }) {
    const { dlog: dlog , err: err , Sentry: Sentry  } = t, start = new Date().getTime(), optimize = await (0, $d0e7629fb3179e02$export$2fc1a072736ae2f6)(window, "google_optimize"), end = new Date().getTime();
    dlog("Waited for google_optimize for", end - start, "ms");
    // if (!optimize.get) {
    //   debugger;
    // }
    let modify_asnum = Number(optimize.get(experiment_id));
    dlog("optimize says variant is", modify_asnum);
    if (isNaN(modify_asnum)) {
        fail_hard("couldn't get if we're version A or B from google optimize, please check experiment id (" + experiment_id + ")");
        return;
    }
    const function_for_variant = functions_to_variants[modify_asnum];
    if (!function_for_variant) {
        fail_hard("Invalid variant " + modify_asnum);
        return;
    }
    dlog("found function for variant", function_for_variant, "executing");
    return function_for_variant.call(t); // be nice to someone who needs t
    function fail_hard(msg) {
        dlog(msg);
        Sentry.captureMessage(msg);
    }
}








function $4f24151f2cddad7b$export$2c2f50b30b7b2576(el, attribute_name, async_iterable, quit_after_navigation = true) {
    (async ()=>{
        const [exit, exitable_iterable] = (0, $b8270fcf290bb3af$export$927664b47117acb0)(async_iterable);
        if (quit_after_navigation) (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(exit);
        for await (const new_value of exitable_iterable)el.setAttribute(attribute_name, new_value);
    })().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            e,
            "Failed to set attribute"
        ], "error"));
    return el;
}






function $8c97019b5f7b0d0e$export$7c081fdbc65b6a2a(async_iterable, quit_after_navigation = true) {
    const [template_els, _get, set] = (0, $49c4fa2e27e642fa$export$3d04c40e7acc1a32)();
    (async ()=>{
        const [exit, exitable_iterable] = (0, $b8270fcf290bb3af$export$927664b47117acb0)(async_iterable);
        if (quit_after_navigation) (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(exit);
        for await (const els of exitable_iterable)set(els);
    })().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
            e,
            "Failed to convert AsyncIterable to elements"
        ], "error"));
    return template_els;
}









let $8bed543774ca0dd4$var$context_counter = 0; // last context that was created (unless 0), to make sure we don't have two of the same
let $8bed543774ca0dd4$var$current_context;
const $8bed543774ca0dd4$var$failed_contexts = /*@__PURE__*/ new Set();
const $8bed543774ca0dd4$export$b8d1e1d07a3f3776 = (cb)=>{
    const context = ++$8bed543774ca0dd4$var$context_counter;
    return (...args)=>{
        const prev_context = $8bed543774ca0dd4$var$current_context;
        $8bed543774ca0dd4$var$current_context = context;
        if ($8bed543774ca0dd4$var$failed_contexts.has(context)) {
            const [first_arg] = args;
            if (first_arg instanceof (0, $cb50cd7a49e824ee$export$ea60432919e69303)) first_arg.disconnector();
            return;
        }
        const retval = cb(...args);
        $8bed543774ca0dd4$var$current_context = prev_context;
        return retval;
    };
};
function $8bed543774ca0dd4$export$f811d2ce0aa6019b({ surfaces: input_surfaces , verb: verb , target: target , remove_after_navigation: remove_after_navigation = true , try_forever: try_forever = false , preserve_elements: preserve_elements = false  }) {
    const surfaces = input_surfaces.map((s)=>{
        let resolve;
        const promise = new Promise((r)=>resolve = r);
        return {
            surface_: s,
            resolve_promise_: resolve,
            promise_: promise
        };
    });
    const { href: href  } = location;
    let context = $8bed543774ca0dd4$var$current_context;
    if (typeof target === "string") {
        context ??= ++$8bed543774ca0dd4$var$context_counter; // assign a context so that we don't add `undefined` or `null` to failed_contexts
        let disconnect_reinsertion_observers;
        const disconnect_observer = (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(target, ({ element: element , disconnector: disconnector  })=>{
            if ($8bed543774ca0dd4$var$failed_contexts.has(context)) {
                disconnector(); // prevent infinite loop
                return;
            }
            disconnect_reinsertion_observers?.(); // Not sure if necessary? But if we re-insert in the same container and don't disconnect preserve_elements observers before it might lead to two observers acting on one element
            disconnect_reinsertion_observers = $8bed543774ca0dd4$var$actual_insertion(element, verb, surfaces, try_forever, href, context, remove_after_navigation, preserve_elements);
        });
        if (!try_forever) (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(disconnect_observer);
    } else {
        if (!context && verb !== "replaceChildren") throw new Error("insert_surface, provided an element, may not be called without a context." + (process.env.DEBUG === "true" ? " Please wrap the function calling it into prevent_infinite_loop(). If you have already done that, make sure that there's no `await` before the calling of insert_surface" : ""));
        (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)($8bed543774ca0dd4$var$actual_insertion)(target, verb, surfaces, try_forever, href, context, remove_after_navigation, preserve_elements);
    }
    return surfaces.map(({ promise_: promise_  })=>promise_);
}
const $8bed543774ca0dd4$export$e3f70ef7e3d00501 = /*@__PURE__*/ (0, /*@__PURE__*/$b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (target, should_stay_inserted)=>{
    const per_el_fn = (el, disconnect_observer)=>{
        const comment_node = document.createComment("Old recs were here // Depict");
        (0, $649f456f663da9fc$export$de56f1198d121036)("Replacing", el, "with", comment_node);
        el.replaceWith(comment_node);
        should_stay_inserted.then((keep)=>{
            if (!keep) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("Reverting", comment_node, "to", el);
                comment_node.replaceWith(el);
                disconnect_observer?.();
            }
        });
    };
    if (typeof target == "string") {
        const disconnect_observer = (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onexists(target, ({ element: element , disconnector: disconnector  })=>per_el_fn(element, disconnector));
        (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(disconnect_observer);
    } else {
        let did_already_fail = false;
        should_stay_inserted.then((should_stay_inserted)=>{
            if (!should_stay_inserted) did_already_fail = true;
        });
        await 0;
        if (did_already_fail) {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Not removing", target, should_stay_inserted, "is already resolved to false");
            return;
        }
        if (Array.isArray(target)) for(let i = 0; i < target.length; i++)per_el_fn(target[i]);
        else per_el_fn(target);
    }
});
function $8bed543774ca0dd4$var$actual_insertion(target, verb, surfaces, try_forever, starting_href, context, remove_after_navigation, preserve_elements) {
    let failed_surfaces = 0;
    let old_children;
    if (verb === "replaceChildren") old_children = [
        ...target.childNodes
    ];
    const was_replaced = verb == "replaceWith";
    const disconnectors = [];
    const disconnect_all_observers = ()=>disconnectors.forEach((disconnector)=>disconnector());
    const check_if_revert_whole = ()=>{
        if (failed_surfaces !== surfaces.length) return; // we didn't fail
        (0, $649f456f663da9fc$export$de56f1198d121036)(`All surfaces`, surfaces, `failed. ${was_replaced ? "Reverting to old els" : "removing els"}`);
        $8bed543774ca0dd4$var$failed_contexts.add(context);
        disconnect_all_observers();
        const flat_tnodes = template_nodes.flat();
        if (was_replaced) {
            flat_tnodes[0].replaceWith(target);
            for(let i = 1; i < flat_tnodes.length; i++)flat_tnodes[i].remove();
        } else if (old_children) target.replaceChildren(...old_children);
        else flat_tnodes.forEach((n)=>n.remove());
    };
    const template_nodes = surfaces.map(({ surface_: surface_ , resolve_promise_: resolve_promise_  })=>{
        const [template_els, _get, set] = (0, $49c4fa2e27e642fa$export$3d04c40e7acc1a32)();
        (async ()=>{
            let surface;
            try {
                surface = await surface_;
            } catch (e) {
                (0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                    e,
                    "A surface promise rejected" + (process.env.DEBUG === "true" ? " please catch this earlier" : "")
                ], "warning");
            }
            if (!try_forever && location.href !== starting_href) // navigated away
            return;
            // @ts-ignore
            if (surface?.elements) {
                (0, $649f456f663da9fc$export$de56f1198d121036)("insert_surface:", target, "." + verb, surface);
                set(surface.elements);
                if (surface.should_stay_inserted instanceof Promise) surface.should_stay_inserted.then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((keep)=>{
                    if (keep) // @ts-ignore
                    resolve_promise_({
                        surface: surface,
                        succeeded: true
                    });
                    else {
                        (0, $649f456f663da9fc$export$de56f1198d121036)("Removing surface", surface, "because it failed");
                        set("");
                        // @ts-ignore
                        resolve_promise_({
                            surface: surface,
                            succeeded: false
                        });
                        failed_surfaces++;
                        check_if_revert_whole();
                    }
                }));
                else resolve_promise_({
                    surface: surface,
                    succeeded: true
                });
            } else {
                // @ts-ignore
                resolve_promise_({
                    surface: surface,
                    succeeded: false
                });
                failed_surfaces++;
                check_if_revert_whole();
            }
        })().catch((e)=>(0, $b04e44fad5ea42c7$export$f18d5b0af29128b7)([
                e,
                "insert_surface failed due to technical errors"
            ], "error"));
        return template_els;
    });
    target[verb](...template_nodes.flat());
    if (preserve_elements) for(let i = 0; i < template_nodes.length; i++){
        const node_array = template_nodes[i];
        const already_observing_nodes = new WeakSet();
        $8bed543774ca0dd4$var$deal_w_removal_of_node_array(node_array, disconnectors.push.bind(disconnectors), already_observing_nodes);
    }
    if (remove_after_navigation) (0, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b)(()=>{
        disconnect_all_observers();
        template_nodes.flat().forEach((tn)=>tn.remove());
        (0, $649f456f663da9fc$export$de56f1198d121036)("Removed", template_nodes, "due to navigation");
    });
    return disconnect_all_observers;
}
function $8bed543774ca0dd4$var$deal_w_removal_of_node_array(node_array, push_disconnector, already_observing_nodes) {
    let removals_in_last_s = 0;
    for(let j = 0; j < node_array.length; j++){
        const previous_parent = node_array[j].parentNode;
        const node_to_observe = node_array[j];
        // this function is "recursive"
        // it is possible that the reactive_template switches back to a Node_Array that it has already previously contained or to a new one that contains the same elements
        // there we don't want to re-add an observer
        if (already_observing_nodes.has(node_to_observe)) continue;
        else already_observing_nodes.add(node_to_observe);
        const disconnect_observer = (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(node_to_observe, (eoe)=>{
            const mutation_record = eoe.mutation_record; // .onremoved always has a mutation_record
            const { element: element  } = eoe;
            const { nextSibling: nextSibling , previousSibling: previousSibling , target: target  } = mutation_record;
            if (previous_parent !== target) {
                (0, $649f456f663da9fc$export$de56f1198d121036)(element, "was removed", eoe, "but because a parent got removed we're keeping it that way");
                return;
            }
            if (node_array.every((node)=>target.contains(node))) {
                // we know that this change was done by updating the reactive_template or a connected/synchronized reactive_template
                // node_array is a reference to an updating array
                // it has always updated once this callback is ran, so we can just check if the new value are currently in the DOM
                // here we don't check the order but I don't think it's going to be an issue?
                (0, $649f456f663da9fc$export$de56f1198d121036)("Ignoring removal of", element, eoe, "because it seems to come from reactive_template change");
                // protect future nodes
                $8bed543774ca0dd4$var$deal_w_removal_of_node_array(node_array, push_disconnector, already_observing_nodes);
            } else if (!target.contains(element)) {
                // it's possible that the element already was re-inserted at the same time (this callback is executed a tick late), we obv. don't want to attempt to reinsert then
                if (removals_in_last_s > 10) {
                    (0, $649f456f663da9fc$export$de56f1198d121036)("More than 10 reinsertions in last second, ignoring");
                    return;
                }
                removals_in_last_s++;
                setTimeout(()=>removals_in_last_s--, 1000);
                (0, $649f456f663da9fc$export$de56f1198d121036)(element, "was removed from DOM,", eoe, "reinserting");
                const { documentElement: documentElement  } = document;
                // try to get right place, didn't test this
                if (nextSibling && documentElement.contains(nextSibling)) nextSibling.before(element);
                else if (previousSibling && documentElement.contains(previousSibling)) previousSibling.after(element);
                else // let's hope nobody made the target a textnode or this throws (unlikely since the typing of insert_surface doesn't allow it)
                target.append(element);
            }
        });
        push_disconnector(disconnect_observer);
    }
}













const $78270f2ea7ca229f$export$3b75288f46cadd96 = ()=>new Array((0, $d89638655e64f324$export$bb0a9c36cf454ea0)(3, 8)).fill("⬜").join("");
const $78270f2ea7ca229f$var$make_sel = (image_url, attribute)=>`[${attribute}=${JSON.stringify(image_url)}]`;
const $78270f2ea7ca229f$export$a4eccf92efefa04d = (image_width, image_height, color = "#f6f7f8")=>`data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='${image_width}' height='${image_height}' xmlns:v='https://vecta.io/nano'%3e%3cpath d='M0 0h${image_width}.016v${image_height}.01H0' fill='${encodeURIComponent(color)}'/%3e%3c/svg%3e`;
async function $78270f2ea7ca229f$export$2dd69958012e3e49({ override_rec_renderer: override_rec_renderer = (0, $6be99244fa573db5$export$50ce83ace0cdd87e) , image_width: image_width = 2000 , image_height: image_height = 2000 , num_items: num_items = 10 , color: color = "#d9d9d9" , on_no_rendering_result: on_no_rendering_result , post_rendering: post_rendering  } = {}) {
    const image_url = $78270f2ea7ca229f$export$a4eccf92efefa04d(image_width, image_height, color);
    return async (t, rendering_options)=>{
        // @ts-ignore FIXME: this is a hack to make the type checker happy
        const actual_rendering = override_rec_renderer(t, rendering_options).catch((0, $7547e32486a3abc0$export$8048b892d651b310)); // start rendering first
        const placeholder_opts = {
            ...rendering_options,
            type: "placeholder",
            recs: Array(num_items).fill(1).map((_)=>({
                    sale_price: NaN,
                    page_url: "#",
                    image_url: image_url,
                    original_price: NaN,
                    product_id: "placeholder",
                    recommendation_id: "placeholder",
                    title: $78270f2ea7ca229f$export$3b75288f46cadd96(),
                    brand: $78270f2ea7ca229f$export$3b75288f46cadd96()
                })),
            view_tracking: [],
            click_tracking: [],
            pre_processors: [],
            post_processors: [
                (elems)=>{
                    if (!elems?.length) return elems;
                    for (const elem of elems){
                        if (elem instanceof HTMLElement) elem.style.cursor = "default";
                        elem?.classList?.add?.("placeholder");
                        elem.addEventListener("click", (e)=>((0, $649f456f663da9fc$export$de56f1198d121036)("Supressing placeholder click", e), e.preventDefault(), e.stopPropagation(), false), true);
                    }
                    for (const img of (0, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0)(elems, [
                        "src",
                        "srcset",
                        "data-src",
                        "data-srcset"
                    ].map((attribute)=>$78270f2ea7ca229f$var$make_sel(image_url, attribute)).join(", ")))img.classList.add("nolazy"); // this gets ignored by all lazyloaders
                    return elems;
                }
            ]
        };
        // @ts-ignore FIXME: this is a hack to make the type checker happy
        const placeholder_rendering = await override_rec_renderer(t, placeholder_opts).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
        let set_should_stay_inserted;
        const should_stay_inserted = new Promise((r)=>set_should_stay_inserted = r);
        if (placeholder_rendering?.elements) {
            const [template_els, _get_state, set_state] = (0, $49c4fa2e27e642fa$export$3d04c40e7acc1a32)(placeholder_rendering.elements);
            actual_rendering.then(async (rendering_result)=>{
                if (typeof post_rendering == "function") await (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(post_rendering)(rendering_result);
                const { elements: elements  } = rendering_result || {};
                await (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element(placeholder_rendering.elements[0]);
                // await new Promise(r => window.addEventListener("contextmenu", r, { once: true }));
                // it's possible that something after this ruins the array reference (aka [...elements]) and therefore it's not safe to call set_state again before the elements are sure to have a parentElement aka being in the DOM
                set_state(elements ?? "");
                if (!elements) {
                    on_no_rendering_result?.(rendering_result);
                    set_should_stay_inserted(false);
                }
                set_should_stay_inserted(true);
            }).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
            return {
                ...placeholder_rendering,
                elements: template_els,
                should_stay_inserted: should_stay_inserted
            };
        } else {
            (0, $649f456f663da9fc$export$de56f1198d121036)("Placeholder rendering went wrong, this is bad! Ditching placeholders");
            return await actual_rendering || {};
        }
    };
}








function $a79c7168700020ff$export$8ec5c86406f333ff() {
    const element_weak_set = new WeakSet();
    Node.prototype.removeChild = new Proxy(Node.prototype.removeChild, {
        apply (target, this_arg, arguments_list) {
            const el = arguments_list[0];
            if (el instanceof Node && element_weak_set.has(el)) {
                try {
                    return target.apply(this_arg, arguments_list);
                } catch (e) {
                    (0, $649f456f663da9fc$export$de56f1198d121036)("Swallowing error of removal of node that we have removed or created", e, el);
                }
                return el;
            }
            return target.apply(this_arg, arguments_list);
        }
    });
    return element_weak_set;
}



// source: https://davidwalsh.name/detect-native-function
function $67acdcc7df099ae4$export$4fbbab6c30e664d5(value) {
    // Used to resolve the internal `[[Class]]` of values
    const toString = Object.prototype.toString;
    // Used to resolve the decompiled source of functions
    const fnToString = Function.prototype.toString;
    // Used to detect host constructors (Safari > 4; really typed array specific)
    const reHostCtor = /^\[object .+?Constructor\]$/;
    // Compile a regexp using a common native method as a template.
    // We chose `Object#toString` because there's a good chance it is not being mucked with.
    const reNative = RegExp("^" + // Coerce `Object#toString` to a string
    String(toString)// Escape any special regexp characters
    .replace(/[.*+?^${}()|[\]\/\\]/g, "\\$&")// Replace mentions of `toString` with `.*?` to keep the template generic.
    // Replace thing like `for ...` to support environments like Rhino which add extra info
    // such as method arity.
    .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    const type = typeof value;
    return type == "function" ? reNative.test(fnToString.call(value)) : value && type == "object" && reHostCtor.test(toString.call(value)) || false;
}



const $1dd4146ad893cfb2$var$promise_as_string = "Promise";
function $1dd4146ad893cfb2$export$38e89c688f9d553a() {
    try {
        const w = window;
        let da_promise = w[$1dd4146ad893cfb2$var$promise_as_string];
        let iframe_promise;
        if ((typeof da_promise.allSettled !== "function" || typeof da_promise?.prototype?.finally !== "function") && !(0, $67acdcc7df099ae4$export$4fbbab6c30e664d5)(da_promise) && (iframe_promise = $1dd4146ad893cfb2$export$e647444ed9403635())) da_promise = iframe_promise;
        if (da_promise) {
            if (Object.getOwnPropertyDescriptor(w, $1dd4146ad893cfb2$var$promise_as_string)?.configurable !== false) Object.defineProperty(w, $1dd4146ad893cfb2$var$promise_as_string, {
                configurable: false,
                enumerable: true,
                get () {
                    return da_promise;
                },
                set (value) {
                    return value;
                }
            });
            else (0, $649f456f663da9fc$export$de56f1198d121036)("Unable to redefine " + $1dd4146ad893cfb2$var$promise_as_string + ", it's already nonconfigurable");
        }
    } catch (e) {
        (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
    }
}
function $1dd4146ad893cfb2$export$e647444ed9403635() {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.head.appendChild(iframe);
    return iframe?.contentWindow?.[$1dd4146ad893cfb2$var$promise_as_string];
}






function $4a6ab5f7377729b1$export$33d1643df63073a8(fetch_handler) {
    fetch_handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(fetch_handler);
    const { prototype: prototype  } = XMLHttpRequest;
    prototype.open = new Proxy(prototype.open, {
        apply (target, this_arg, arg_array) {
            if (Array.isArray(arg_array)) {
                const request = this_arg;
                const [method, url] = arg_array;
                (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(fetch_handler)(request, method, url, arg_array);
            }
            return target.apply(this_arg, arg_array);
        }
    });
}
function $4a6ab5f7377729b1$export$f314addd5f976083(handler) {
    $4a6ab5f7377729b1$export$33d1643df63073a8((req, method, url)=>req.addEventListener("load", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((event)=>handler(req, method, url, event))));
}
async function $4a6ab5f7377729b1$export$c74578d2cd47a84a(send_callback) {
    const catchified_callback = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(send_callback);
    const requests = new WeakMap();
    $4a6ab5f7377729b1$export$33d1643df63073a8((request, _method, _url, arg_array)=>{
        requests.set(request, arg_array);
    });
    const { prototype: prototype  } = XMLHttpRequest;
    prototype.send = new Proxy(prototype.send, {
        apply (target, this_request, arg_list) {
            try {
                if (requests.has(this_request)) catchified_callback(this_request, requests.get(this_request), arg_list);
            } catch (e) {
                (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
            }
            return target.apply(this_request, arg_list);
        }
    });
}
async function $4a6ab5f7377729b1$export$8e16c51fd2b6507(read_callback) {
    const catchified_read_callback = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(read_callback);
    const open_send_arg_map = new WeakMap();
    const { prototype: prototype  } = XMLHttpRequest;
    const proxy_response = (n)=>{
        const prev_desc = Object.getOwnPropertyDescriptor(prototype, n);
        const new_desc = {
            ...prev_desc,
            get: new Proxy(prev_desc.get, {
                apply (target, this_arg, arg_list) {
                    const default_value = target.apply(this_arg, arg_list);
                    try {
                        const stored_args = open_send_arg_map.get(this_arg);
                        if (!stored_args) // request was sent before we proxied `.send`
                        return default_value;
                        const [open_args, send_args] = stored_args;
                        return catchified_read_callback(this_arg, open_args, send_args, default_value, n) || default_value;
                    } catch (e) {
                        // in case the weakmaps fail for some reason
                        (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
                        return default_value;
                    }
                }
            })
        };
        Object.defineProperty(prototype, n, new_desc);
    };
    $4a6ab5f7377729b1$export$c74578d2cd47a84a((request, ...open_send_args)=>open_send_arg_map.set(request, open_send_args));
    [
        "responseText",
        "response",
        "responseXML"
    ].forEach(proxy_response);
}




async function $bbb9f33eb5feb86a$export$83ec13b10b391f13(orig_url = process.env.ORIG_URL) {
    if (process.env.DEBUG !== "true") return;
    const o_u_u_o = new URL(orig_url || "", location.href);
    const orig_url_with_trailing_slash = o_u_u_o.protocol + "//" + o_u_u_o.host + "/";
    if (orig_url) {
        // change links
        (0, $0bdb8dbcf1bc7f34$export$d4bd03f19260ef1c)(orig_url_with_trailing_slash, false, location.hostname);
        $bbb9f33eb5feb86a$export$2a1cc61cffa1f36f(orig_url_with_trailing_slash);
        $bbb9f33eb5feb86a$export$2a38b176ce969e2c(orig_url_with_trailing_slash);
        $bbb9f33eb5feb86a$export$f14a775632a826c4(orig_url_with_trailing_slash);
    } else (0, $649f456f663da9fc$export$de56f1198d121036)(new Error("No ORIG_URL env var was set, demo fixes not gonna work."));
}
function $bbb9f33eb5feb86a$export$f14a775632a826c4(orig_url_with_trailing_slash) {
    // rewrite history.pushState and history.replaceState so that it works if someone calls it with absolute URLs
    const hist_proxy = (fn)=>{
        const history_prototype = History.prototype;
        history_prototype[fn] = new Proxy(history_prototype[fn], {
            apply (target, this_arg, arg_list) {
                if (typeof arg_list[2] == "string") arg_list[2] = arg_list[2].replaceAll(orig_url_with_trailing_slash, "/");
                return target.apply(this_arg, arg_list);
            }
        });
    };
    [
        "replaceState",
        "pushState"
    ].forEach(hist_proxy);
}
function $bbb9f33eb5feb86a$export$2a1cc61cffa1f36f(orig_url_with_trailing_slash) {
    // rewrite fetch requests just in case, maybe we should also rewrite responses
    (0, $b6f5b218b1a73900$export$85be83e1935d93c2)(async (target, this_arg, arg_list)=>{
        try {
            const [url] = arg_list;
            if (typeof url == "string") arg_list[0] = url.replaceAll(orig_url_with_trailing_slash, "/");
            else if (url instanceof Request) {
                if (url.url.includes(orig_url_with_trailing_slash)) arg_list[0] = new Request(url.url.replaceAll(orig_url_with_trailing_slash, "/"), url);
            }
        } catch (e) {
            (0, $7547e32486a3abc0$export$8048b892d651b310)(e);
        }
        return target.apply(this_arg, arg_list);
    });
}
function $bbb9f33eb5feb86a$export$2a38b176ce969e2c(orig_url_with_trailing_slash) {
    // rewrite xhr requests just in case
    (0, $4a6ab5f7377729b1$export$33d1643df63073a8)((request, method, url, arg_array)=>{
        if (url instanceof URL) url.href = url.href.replaceAll(orig_url_with_trailing_slash, "/");
        else if (typeof url == "string") arg_array[1] = url.replaceAll(orig_url_with_trailing_slash, "");
    });
}



/**
 * Recursively sorts the keys in an object (NOT in-place, returns a new object). Do not provide objects containing anything other than primitives or other objects. Do not provide objects that have cyclical values.
 */ function $8d4dfadc5e12c7fb$export$12b4c6cbc6b8b4e4(maybe_obj) {
    if (!maybe_obj) return maybe_obj;
    if (typeof maybe_obj != "object") return maybe_obj;
    if (maybe_obj.constructor !== Object) {
        if (Array.isArray(maybe_obj)) return maybe_obj.map((item)=>$8d4dfadc5e12c7fb$export$12b4c6cbc6b8b4e4(item));
        return maybe_obj;
    }
    const cloned_obj = {};
    const sorted_keys = Object.keys(maybe_obj).sort();
    for(let i = 0; i < sorted_keys.length; i++){
        const key = sorted_keys[i];
        const value = maybe_obj[key];
        cloned_obj[key] = $8d4dfadc5e12c7fb$export$12b4c6cbc6b8b4e4(value);
    }
    return cloned_obj;
}


/**
 * Tries to figure out the tenant's market (`TwoLetterMarket` for new integrations) through various means.
 *
 * 1. Checks if there is a market in one of the url segments (www.tentant.se/foo/se/bar)
 * 2. Checks if the market is specified in the tenant's domain name (www.tenant-se.com)
 * 3. Checks the toplevel domain (www.tenant.se/foo/bar)
 *
 * @param allowed_markets An array the possible markets for the tenant.
 *    Dont forget to specify the allowed market as const (`["se", "en"] as const`) to get the best typing
 * @param url Specify this to overide the url to check, defaults to the current url
 * @param tenant The tenant's name
 * @returns If a market specified in `allowed_markets`was found that is returned, `undefined` otherwise
 */ function $eda086e0899e75b0$export$a422d714c8cb1a5d(allowed_markets, url, tenant = process.env.TENANT) {
    const u_o = url ? new URL(url) : location;
    const { hostname: hostname  } = u_o;
    const is_demosite = process.env.DEBUG === "true" && hostname.endsWith("demo.depict.ai");
    // strategy 0: demo sites
    if (is_demosite) {
        const last_in_orig_site = hostname.replace("demo.depict.ai", "").split("-").pop();
        if (allowed_markets.includes(last_in_orig_site)) return last_in_orig_site;
    }
    // strategy 1 pathname startsWith
    const { pathname: pathname  } = u_o;
    const market = allowed_markets.find((v)=>pathname.startsWith("/" + v + "/") || pathname === "/" + v);
    if (market) return market;
    // strategy 2 <tenant><divider><market>
    if (tenant) {
        const e = new RegExp(tenant + "[.-]" + `(${allowed_markets.join("|")})`);
        const matches = hostname.match(e);
        if (matches?.[1]) return matches[1];
    }
    // strategy 3 top level domain
    const tld = hostname.split(".").pop();
    if (allowed_markets.includes(tld)) return tld;
    // strategy 4 html lang attribute
    const lang_attr = document.documentElement.lang;
    if (lang_attr) {
        const e = new RegExp(`${allowed_markets.join("|")}`);
        const matches = lang_attr.toLowerCase().match(e);
        if (matches?.[0]) return matches[0];
    }
    if (is_demosite) // hail mary attempt to get something to run
    return "se";
}





function $e72f2f1d48dc3a53$export$3427ec8268623f1(listener) {
    if (!(0, $b83068cbd26dcc41$export$b87d7e0da8b5cbe3)()) {
        (0, $649f456f663da9fc$export$de56f1198d121036)("Not hooking localStorage as it would freeze it due to lacking Proxy support");
        return;
    }
    const caught_listener = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(listener);
    let changed_instance;
    const update_changed_instance = ()=>changed_instance = Storage.prototype.setItem !== localStorage.setItem;
    update_changed_instance();
    const orig_storage = localStorage;
    const proxied_set_items = new WeakMap();
    const changed_this_args = new WeakSet();
    const create_setItem_proxy = (setItem_fn)=>{
        if (proxied_set_items.has(setItem_fn)) return proxied_set_items.get(setItem_fn);
        const proxied_fn = new Proxy(setItem_fn, {
            apply (target, this_arg, arg_list) {
                // this function can also run on sessionStorage.setItem, hence this check
                if (this_arg === proxied_localStorage || this_arg === orig_storage) {
                    caught_listener(...arg_list);
                    return target.apply(orig_storage, arg_list);
                }
                return target.apply(this_arg, arg_list);
            }
        });
        proxied_set_items.set(setItem_fn, proxied_fn);
        return proxied_fn;
    };
    // stolen from src/nordicagolf/repairing_their_cart.ts, which was in turn
    // stolen from stackoverflow but let's give credit to this instead because I didn't find the post again: https://gist.github.com/mynameislau/b7eabfcdc0a17ac41cdc0b974f94d807
    // much adapted after that, probably no longer that similar
    const proxied_localStorage = new Proxy(orig_storage, {
        set (storage, key, value) {
            caught_listener(key, value);
            storage[key] = value;
            if (key === "setItem") update_changed_instance();
            return true;
        },
        get (storage, key) {
            const orig_value = storage[key];
            if (typeof orig_value === "function") {
                if (key === "setItem") {
                    if (changed_instance) return create_setItem_proxy(orig_value);
                    else return orig_value; // will have been proxied with create_setItem_proxy in Storage.prototype further down
                }
                if (!changed_this_args.has(orig_value)) return new Proxy(orig_value, {
                    // for some reason all functions like getItem throw when called with `this` being a proxied Storage Object
                    apply (target, this_arg, arg_list) {
                        return target.apply(this_arg === proxied_localStorage ? orig_storage : this_arg, arg_list);
                    }
                });
            }
            return orig_value;
        }
    });
    Object.defineProperty(window, "localStorage", {
        configurable: true,
        enumerable: true,
        value: proxied_localStorage
    });
    const storage_prototype = Storage.prototype;
    storage_prototype.setItem = create_setItem_proxy(storage_prototype.setItem);
    for(const key in storage_prototype)try {
        const value = storage_prototype[key];
        if (key !== "setItem" && typeof value === "function") {
            const fn_with_changed_this_arg = new Proxy(value, {
                apply (target, this_arg, arg_list) {
                    return target.apply(this_arg === proxied_localStorage ? orig_storage : this_arg, arg_list);
                }
            });
            storage_prototype[key] = fn_with_changed_this_arg;
            changed_this_args.add(fn_with_changed_this_arg);
        }
    } catch (e) {
        if (key !== "length") (0, $649f456f663da9fc$export$de56f1198d121036)(e);
    }
}



/**
 * Timeout a promise after `ms` milliseconds.
 * If the promise is timed out this function will return `undefined` and not throw.
 */ function $55698e6e298abcb0$export$cd1adfb8059b5fcd(promise, ms) {
    const timeout = new Promise((res)=>setTimeout(res, ms));
    return Promise.race([
        promise,
        timeout
    ]);
}





const $690d8897acf7a743$var$default_id = (0, $43683b1103edab15$export$6399bdb2291895e0)();
const $690d8897acf7a743$var$get_voyado_id = ()=>{
    const va = /\b_vaI=([^;]+)/.exec(document.cookie)?.[1];
    return va || $690d8897acf7a743$var$default_id;
};
const $690d8897acf7a743$export$a739d9a07da7f9ce = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
    (0, $43683b1103edab15$export$336e7ad40bae0652)($690d8897acf7a743$var$get_voyado_id);
});





function $769ce417b39aa7d3$export$4a3043e508dd72f0({ children: children , ...attributes }) {
    const button = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("button", {
        ...attributes,
        type: "button",
        children: children
    });
    button.classList.add("show-more");
    return button;
}








async function $cf7ca80454d7b4c0$export$8a0e4d6f6abf7e90({ title_: title_ , children: children , CloseIcon: CloseIcon  }) {
    // TODO: make so once can't accidentally have multiple at once
    let close_;
    const open_promise = new Promise((r)=>close_ = r);
    const body = await (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).wait_for_element("body");
    const backdrop = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
        class: "slidein-backdrop",
        onClick: close_
    });
    const [exit_title_iterator, exitable_title_iterator] = (0, $b8270fcf290bb3af$export$927664b47117acb0)(title_);
    const closing_handlers = [
        exit_title_iterator
    ];
    const slidein = (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
        class: "slidein",
        children: [
            (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
                class: "header",
                children: [
                    (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("span", {
                        class: "title",
                        children: (0, $8c97019b5f7b0d0e$export$7c081fdbc65b6a2a)(exitable_title_iterator, false)
                    }),
                    (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("button", {
                        class: "close",
                        onClick: close_,
                        children: CloseIcon()
                    })
                ]
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "body",
                children: children
            })
        ]
    });
    const elements_in_container = (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
        class: "depict",
        children: [
            backdrop,
            slidein
        ]
    });
    body.append(elements_in_container);
    backdrop.animate({
        opacity: [
            0,
            1
        ]
    }, {
        easing: "ease-in",
        duration: 260
    });
    slidein.animate({
        transform: [
            "translateX(50%) scaleX(0.6)",
            "translateX(0) scaleX(1)"
        ],
        opacity: [
            0,
            1
        ]
    }, {
        easing: "ease-in",
        duration: 220
    });
    const handler = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(({ key: key  })=>{
        if (key === "Escape") // make pressing escape close the slidein
        close_();
    });
    window.addEventListener("keydown", handler);
    open_promise.then((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
        window.removeEventListener("keydown", handler);
        backdrop.animate({
            opacity: [
                1,
                0
            ]
        }, {
            easing: "ease-out",
            duration: 200,
            fill: "forwards"
        });
        slidein.animate({
            transform: [
                "translateX(0) scaleX(1)",
                "translateX(50%) scaleX(0.6)"
            ],
            opacity: [
                1,
                0
            ]
        }, {
            easing: "ease-out",
            duration: 220
        }).addEventListener("finish", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            elements_in_container.remove();
            closing_handlers.forEach((handler)=>handler());
        }));
    }));
    return {
        close_: close_,
        on_close_: (fn)=>closing_handlers.push(fn)
    };
}








async function $72d170fd5c7cb3fe$export$c068ad5361be7646({ title_: title_ , items_: items_ , out_of_stock_text_: out_of_stock_text_ , CloseIcon: CloseIcon  }) {
    const [exit_oos_iterator, exitable_oos_iterator] = (0, $b8270fcf290bb3af$export$927664b47117acb0)(out_of_stock_text_);
    // eslint-disable-line  no-async-promise-executor
    return new Promise((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (size_selected)=>{
        const { close_: close_ , on_close_: on_close_  } = await (0, $cf7ca80454d7b4c0$export$8a0e4d6f6abf7e90)({
            CloseIcon: CloseIcon,
            title_: title_,
            children: [
                (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                    class: "option-list",
                    children: items_.map(({ size_name_: size_name_ , is_available_: is_available_ , id_: id_  })=>{
                        const button = (0, $63cbb5de51d11596$export$25062201e9e25d76)("button", {
                            type: "button",
                            class: "option" + (is_available_ ? " available" : ""),
                            onClick: ()=>{
                                size_selected(id_);
                                close_();
                            },
                            children: [
                                (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("span", {
                                    class: "size",
                                    children: size_name_
                                }),
                                !is_available_ && (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("span", {
                                    class: "sold-out",
                                    children: (0, $8c97019b5f7b0d0e$export$7c081fdbc65b6a2a)(exitable_oos_iterator)
                                })
                            ]
                        });
                        if (!is_available_) button.disabled = true;
                        return button;
                    })
                })
            ]
        });
        on_close_(size_selected);
        on_close_(exit_oos_iterator);
    }));
}


var $1418dcbe557b544c$exports = {};
$1418dcbe557b544c$exports = ".depict-placeholder {\n  will-change: mask, -webkit-mask;\n  mask-position-x: 125%;\n  mask-position-y: center;\n  background: #ddd;\n  animation: 1.5s linear infinite depict-placeholder;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) 125% / 300% 100%;\n  -webkit-mask-image: ;\n  mask-image: ;\n  -webkit-mask-size: ;\n  mask-size: ;\n}\n\n@keyframes depict-placeholder {\n  0% {\n    mask-position-x: 125%;\n    -webkit-mask-position-x: 125%;\n  }\n\n  10% {\n    mask-position-x: 125%;\n    -webkit-mask-position-x: 125%;\n  }\n\n  90% {\n    mask-position-x: -25%;\n    -webkit-mask-position-x: -25%;\n  }\n\n  100% {\n    mask-position-x: -25%;\n    -webkit-mask-position-x: -25%;\n  }\n}\n\n";




let $ad592d9ddbcffe72$var$inserted = false;
const $ad592d9ddbcffe72$export$84712d0562a614b8 = ({ width: width , height: height = "1em" , class: extra_classes , style: style = "" , ...attributes })=>{
    if (!$ad592d9ddbcffe72$var$inserted) {
        // Insert styling on first import
        (0, $0a581f1dfa083522$export$59ba1eb2c083f0cd)((0, (/*@__PURE__*/$parcel$interopDefault($1418dcbe557b544c$exports))));
        $ad592d9ddbcffe72$var$inserted = true;
    }
    return(// @ts-ignore
    (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
        class: `depict-placeholder${extra_classes ? " " + extra_classes : ""}`,
        style: style ? style : `width:${width};height:${height};`,
        ...attributes
    }));
};
const $ad592d9ddbcffe72$export$d613f5b6d0a331a8 = ({ aspect_ratio: aspect_ratio , ...attributes })=>{
    return (0, $63cbb5de51d11596$export$34b9dba7ce09269b)($ad592d9ddbcffe72$export$84712d0562a614b8, {
        style: `position:relative;width:100%;padding-bottom:${1 / aspect_ratio * 100}%`,
        ...attributes
    });
};





const $fbe64cf2cf408e4f$export$97f31f44c68c1d5 = (title, surface_classes = [])=>(0, $b9b0dba897847b2a$export$eb0b9ed911409b57)((e)=>e.classList.add(...surface_classes), (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
        class: "depict recommendation_container",
        children: [
            title && typeof title === "string" ? (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("h4", {
                class: "recs_header",
                children: title
            }) : title,
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "grid"
            })
        ]
    }));




const $7693290d077384da$export$32a55d57d151bc5a = ()=>(0, $63cbb5de51d11596$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 320 512",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("desc", {
                children: "Right arrow"
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("path", {
                d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
            })
        ]
    });
const $7693290d077384da$export$ddd70fdae1b350e6 = ()=>(0, $63cbb5de51d11596$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 320 512",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("desc", {
                children: "Left arrow"
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("path", {
                d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            })
        ]
    });




/**
 * Internal color circle used in ColorPicker
 * @see {createColorPicker}
 */ function $6f1582c15e13f2f0$var$ColorCircle({ color: color , onClick: onClick , onHoverUpdate: onHoverUpdate  }) {
    const button = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("button", {
        class: "color-circle-container",
        onClick: (e)=>onClick(e.currentTarget, color),
        title: color.label || "",
        children: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            class: "outer-circle",
            style: `border-color: ${color.value};`,
            children: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "inner-circle",
                style: `background-color: ${color.value};`
            })
        })
    });
    button.addEventListener("mouseenter", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>onHoverUpdate(button, color, true)));
    button.addEventListener("mouseleave", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>onHoverUpdate(button, color, false)));
    return button;
}
function $6f1582c15e13f2f0$export$590326cc34f49e2d({ colors: colors , initialColor: initialColor , onSelect: onSelect , selectOnHover: selectOnHover = false , onHoverUpdate: onHoverUpdate , dontSetActiveOnClick: dontSetActiveOnClick , onlyCircles: onlyCircles  }) {
    let setActiveIndex;
    // Don't actually construct anything if the component we return isn't used
    return {
        setActiveIndex: (index)=>setActiveIndex?.(index),
        ColorPicker () {
            /** The currently active ColorCircle */ let activeCircle = null;
            /** The currently active color object */ let activeColor = null;
            /**
       * Update the currently active color object and HTMLElement
       * Toggles the active class.
       */ const setActive = (e, color)=>{
                if (e !== activeCircle) {
                    if (activeCircle) activeCircle.classList.remove("active");
                    e.classList.add("active");
                    activeCircle = e;
                    activeColor = color;
                }
            };
            const handleClick = function(clicked, color) {
                if (!dontSetActiveOnClick) setActive(clicked, color);
                onSelect(color);
            };
            /**
       * Handles the preview logic.
       */ const handleSelectOnHover = (hovered, color, hovering)=>{
                // Don't do any selection if the hovered circle is already selected
                if (hovered === activeCircle) return;
                if (hovering) onSelect(color); // mouseenter - select a new color
                else if (activeColor) onSelect(activeColor); // mouseleave - select the last activeColor
            };
            const handleHoverUpdate = function(hovered, color, hovering) {
                // Pass the event up
                if (onHoverUpdate) onHoverUpdate(color, hovering);
                // If enabled, select the hovered color
                if (selectOnHover) handleSelectOnHover(hovered, color, hovering);
            };
            // Create the color circles
            const circles = colors.map((color)=>(0, $63cbb5de51d11596$export$34b9dba7ce09269b)($6f1582c15e13f2f0$var$ColorCircle, {
                    color: color,
                    onClick: handleClick,
                    onHoverUpdate: handleHoverUpdate
                }));
            // Function to set active color to an index
            setActiveIndex = (index)=>setActive(circles[index], colors[index]);
            // Set the initial color, if any
            const initial_index = initialColor == undefined ? -1 : colors.findIndex((c)=>typeof initialColor === "string" ? c.value === initialColor : c.value === initialColor.value && c.label === initialColor.label);
            if (initial_index > -1) setActiveIndex(initial_index);
            if (onlyCircles) return circles;
            return (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "color-picker",
                role: "form",
                "aria-label": "Color picker",
                children: circles
            });
        }
    };
}




const $7f57d546b5d5b3d6$export$237455ad7e59d4e5 = ({ duration: duration = 500 , delay: delay = 0  } = {
    duration: 500,
    delay: 0
})=>{
    let outerRef;
    let innerRef;
    let current_animation;
    const child_computed_style = ()=>{
        if (innerRef.childNodes.length === 1) {
            const [first_child] = innerRef.children;
            if (first_child instanceof Element) return getComputedStyle(first_child);
        }
    };
    const get_height = ()=>(child_computed_style() ? parseInt(child_computed_style().marginTop) + parseInt(child_computed_style().marginBottom) + parseInt(child_computed_style().height) : innerRef.clientHeight) + "px";
    const get_current_height_possibly_during_transition = ()=>(child_computed_style() && outerRef.style.overflow !== "hidden" ? parseInt(child_computed_style().marginBottom) + parseInt(child_computed_style().marginTop) // don't ask me why we need to do this 😭 but I'm sure it works
         : 0) + outerRef.clientHeight + "px";
    const ExpandingContainer = ({ children: children  })=>{
        if (Array.isArray(children) && children.length === 1) children = children[0];
        innerRef = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            children: children
        });
        outerRef = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
            style: `overflow:hidden;height:0px;visibility:hidden`,
            "aria-hidden": "true",
            children: innerRef
        });
        return outerRef;
    };
    const expand = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (expanding_delay = delay, time_to_expand = duration)=>{
        const start = get_current_height_possibly_during_transition(); // need to read this before cancelling the old animation
        outerRef.style.visibility = "";
        outerRef.removeAttribute("aria-hidden");
        current_animation?.cancel?.(); // cancel already running animation so it doesn't get a finish event while we're still animating
        const animation = outerRef.animate({
            height: [
                start,
                get_height()
            ]
        }, {
            duration: time_to_expand,
            delay: expanding_delay,
            easing: "ease-in"
        });
        current_animation = animation;
        animation.addEventListener("finish", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            current_animation = undefined;
            outerRef.style.overflow = "";
            outerRef.style.height = "auto";
        }));
        return animation;
    });
    const collapse = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(async (collapsing_delay = delay, time_to_collapse = duration)=>{
        const start = get_current_height_possibly_during_transition();
        current_animation?.cancel?.();
        outerRef.style.overflow = "hidden";
        outerRef.ariaHidden = "true";
        const animation = outerRef.animate({
            height: [
                start,
                "0px"
            ]
        }, {
            duration: time_to_collapse,
            delay: collapsing_delay,
            easing: "ease-out"
        });
        current_animation = animation;
        animation.addEventListener("finish", (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)(()=>{
            current_animation = undefined;
            outerRef.style.height = "0";
            outerRef.style.visibility = "hidden";
        }));
        return animation;
    });
    return {
        ExpandingContainer: ExpandingContainer,
        expand: expand,
        collapse: collapse
    };
};


var $0643fffeaad31076$exports = {};
$0643fffeaad31076$exports = ".depict-img-cont {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.depict-img-filler {\n  width: 100%;\n  height: auto;\n  display: inline-block;\n}\n\n.depict-img-comp {\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.depict-img-mod {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n  inset: 0;\n}\n\n";








const $45af9e834781a9bc$export$3d13beba9b52c947 = "https://img.depict.ai/ResizeImage" + (process.env.TENANT ? "/" + process.env.TENANT : "");
const $45af9e834781a9bc$export$a98fc8a2c818d3d8 = /*@__PURE__*/ (()=>typeof navigator === "undefined" ? false : /^((?!chrome|android).)*safari/i.test(navigator.userAgent))(); // https://stackoverflow.com/a/23522755
function $45af9e834781a9bc$export$f39a7d0667e924a(what_to_watch, sizes_communicator = (0, $607fc90221d440a6$export$e806c6c1615a59ae)(), resolution_factor = 1) {
    let currently_live = false;
    const ro = new ResizeObserver((0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((records)=>{
        for(let j = 0; j < records.length; j++){
            const { width: width  } = records[j].contentRect;
            if (!width) continue;
            // add extra 5% just in case. + safari is (in some cases) acting a bit questionable and needs a third extra to fill the set width
            const new_size = width * 1.05 * ($45af9e834781a9bc$export$a98fc8a2c818d3d8 ? 4 / 3 : 1) * resolution_factor;
            sizes_communicator(Math.round(new_size));
        }
    }));
    // start and stop ResizeObserver to make sure we're not hindering GC
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).oncreation(what_to_watch, ({ element: element  })=>{
        ro.observe(element);
        currently_live = true;
    });
    (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).onremoved(what_to_watch, ()=>{
        ro.disconnect();
        sizes_communicator.exit();
        currently_live = false;
    });
    if (document.documentElement.contains(what_to_watch)) {
        ro.observe(what_to_watch); // if already in DOM, start observing directly
        currently_live = true;
    }
    const start_updating_sizes_of_el = async (el_to_resize)=>{
        for await (const target_size of sizes_communicator){
            const target_size_in_px = target_size + "px";
            (el_to_resize.sizes &&= target_size_in_px) || el_to_resize.setAttribute("sizes", target_size_in_px);
        }
    };
    return async (el_to_resize)=>{
        const weakrefd_el_to_resize = new WeakRef(el_to_resize);
        // if the watched el exits it will run .exit on the IPNS and exit the iterators.
        // then if it's recreated, the observer below will restart the iterators.
        (0, $0b48ba2f40ce6067$export$b6ae1bc530f4c149).oncreation(what_to_watch, async ({ disconnector: disconnector  })=>{
            const el_to_update = weakrefd_el_to_resize.deref();
            if (!el_to_update) {
                disconnector(); // we're useless, el got GCd
                return;
            }
            await start_updating_sizes_of_el(el_to_update);
        });
        if (currently_live) await start_updating_sizes_of_el(el_to_resize);
    // FYI: this will still hold strong references to the els that get their sizes attribute set until the watched el is removed from the DOM and GC'd. I wrote a version before where that's not the case which you can find here: https://gitlab.com/depict-ai/depict.ai/-/merge_requests/1901/diffs?commit_id=111d72c0f58777786dfcc00cc18d76cb0ac96c7c and I didn't end up using because I think it's wasting too many CPU cycles
    };
}
function $45af9e834781a9bc$export$a62825542f1bfcf5({ what_to_watch: what_to_watch , set_dataset: set_dataset = true , formats: formats = [
    "webp",
    "jpeg"
] , resolutions: resolutions = [
    64,
    128,
    256,
    300,
    400,
    512,
    1024,
    2048,
    4096
] , sizes_communicator: sizes_communicator , resolution_factor: resolution_factor , market_: market_ , sizes_setter_: sizes_setter_  } = {}) {
    /**
   * We support what_to_watch being optional, meaning we will take the first image we get.
   * For that we need to have created the image before being able to create the sizes setter.
   */ const local_base_url = market_ ? $45af9e834781a9bc$export$3d13beba9b52c947 + "/" + market_ : $45af9e834781a9bc$export$3d13beba9b52c947;
    return (image_options)=>{
        const raw_src = image_options?.src || image_options?.["data-src"]; // get wanted src
        const src = new URL(raw_src, location.origin).href;
        if (!src) {
            (0, $649f456f663da9fc$export$de56f1198d121036)(image_options, ()=>{}); // noop function is to allow to get here quickly by "jump to function definition"
            (0, $7547e32486a3abc0$export$8048b892d651b310)(new Error("no image src provided: " + src));
            return (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("img", {
                ...image_options
            }); // we don't want everything to fail if someone misused this component
        }
        // Create an array of elements that will get their `sizes` attribute updated when what_to_watch resizes
        const sources = [];
        // Create <source> tags for all wanted formats
        for(let i = 0; i < formats.length; i++){
            // Much faster than .map and this will run kinda often
            const format = formats[i];
            const srcset = $45af9e834781a9bc$var$make_srcset(src, format, resolutions);
            sources.push(// 0px important because chrome will load the biggest size otherwise until sizes attribute is set to the correct value
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("source", {
                sizes: "0px",
                type: `image/${format}`,
                ...set_dataset ? {
                    "data-srcset": srcset
                } : {
                    srcset: srcset
                }
            }));
        }
        const opts_without_src = {
            ...image_options
        }; // Prevents the image from instantly loading the original source
        delete opts_without_src["src"];
        delete opts_without_src["srcset"];
        const the_image = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("img", {
            ...opts_without_src
        }); // create image
        sources.push(the_image); // chrome seems to be the dumbest piece of cake that has ever existed and just load the first source?????
        what_to_watch ||= the_image;
        sizes_setter_ ||= $45af9e834781a9bc$export$f39a7d0667e924a(what_to_watch, sizes_communicator, resolution_factor); // now we can finally create the sizes_setter
        // start a sizes_setter for every source (including fallback image)
        for(let i = 0; i < sources.length; i++)sizes_setter_(sources[i]).catch((0, $7547e32486a3abc0$export$8048b892d651b310));
        // embed all sources into a <picture> so that the browser understands they're "together"
        const picture = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("picture", {
            children: sources
        });
        // Create src and srcset for fallback image and set it.
        // This is so that the browser doesn't start loading the fallback image for fun (chrome loads very eagerly)
        const fallback_src = $45af9e834781a9bc$var$optimized_img_url_generator("png", src, 400);
        const fallback_srcset = $45af9e834781a9bc$var$make_srcset(src, "png", resolutions, local_base_url);
        if (set_dataset) {
            the_image.dataset.srcset = fallback_srcset;
            the_image.dataset.src = fallback_src;
        } else {
            the_image.setAttribute("srcset", fallback_srcset);
            the_image.src = fallback_src;
        }
        return picture;
    };
}
function $45af9e834781a9bc$export$f7c915448031deac(base, params) {
    // do this so we don't end up in escape hell
    const url_object = new URL(base, location.origin);
    const search = new URLSearchParams(Object.entries(params));
    url_object.search = search.toString();
    return url_object.href;
}
function $45af9e834781a9bc$var$make_srcset(url, format, resolutions, local_base_url = $45af9e834781a9bc$export$3d13beba9b52c947) {
    return resolutions.map((width)=>`${$45af9e834781a9bc$var$optimized_img_url_generator(format, url, width)} ${width}w`).join(", ");
}
function $45af9e834781a9bc$var$optimized_img_url_generator(format, url, width) {
    // using make_url_with_query_params takes ~100ms on CDON with 2 surfaces and hover images, we can't afford that when it could be essentially free
    return `${$45af9e834781a9bc$export$3d13beba9b52c947}?format=${format}&url=${encodeURIComponent(url)}&width=${width}`;
}







const $914971fb43986a16$var$rendering_options_to_sourceset_component = /*@__PURE__*/ new WeakMap();
// Add nolazy to placeholders to avoid errors with the stupid lazyfier
const $914971fb43986a16$var$add_nolazy_to_placeholder = (type)=>type === "placeholder" ? "nolazy" : "";
let $914971fb43986a16$var$inserted = false;
const $914971fb43986a16$export$788756b42446dc2d = ({ init_with_placeholder: init_with_placeholder , ...options })=>{
    if (!$914971fb43986a16$var$inserted) {
        // Insert styling on first import
        (0, $0a581f1dfa083522$export$59ba1eb2c083f0cd)((0, (/*@__PURE__*/$parcel$interopDefault($0643fffeaad31076$exports))));
        $914971fb43986a16$var$inserted = true;
    }
    const img = process.env.BUILD_TARGET === "modern" || process.env.BUILD_TARGET === "dev" ? $914971fb43986a16$var$Image(options) : $914971fb43986a16$var$CompatibleImage(options);
    if (init_with_placeholder) // 10000 is a magic value, that is just supposed to be bigger than the size of the actual image.
    img.querySelectorAll("img").forEach((i)=>i.src = (0, $78270f2ea7ca229f$export$a4eccf92efefa04d)(10000 * options.aspect_ratio, 10000));
    return img;
};
function $914971fb43986a16$var$Image({ aspect_ratio: aspect_ratio , alt: alt , remove_on_error: remove_on_error , rendering_options: rendering_options , srcset_opts: srcset_opts , init_with_placeholder: _ , ...image_options }) {
    const div = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
        style: `position:relative;width:100%;padding-bottom:${1 / aspect_ratio * 100}%`
    });
    const sourceset_component = $914971fb43986a16$var$srcset_comp_from_map_or_new(rendering_options, srcset_opts, div);
    const IMG_tag = image_options.src?.startsWith("data:") || !sourceset_component ? "img" : sourceset_component;
    div.append(// @ts-ignore
    (0, $63cbb5de51d11596$export$34b9dba7ce09269b)(IMG_tag, {
        alt: alt,
        ...remove_on_error ? {
            onerror: "this.remove()"
        } : {},
        ...image_options,
        class: (0, $b9b0dba897847b2a$export$22a65337c1b43b1f)([
            "depict-img-mod ",
            image_options.class,
            $914971fb43986a16$var$add_nolazy_to_placeholder(rendering_options?.type)
        ])
    }));
    return div;
}
function $914971fb43986a16$var$CompatibleImage({ aspect_ratio: aspect_ratio , alt: alt , remove_on_error: remove_on_error , rendering_options: rendering_options , srcset_opts: srcset_opts , ...image_options }) {
    const canvas = (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("canvas", {
        class: "depict-img-filler",
        width: 3000 * aspect_ratio,
        height: 3000
    });
    const sourceset_component = $914971fb43986a16$var$srcset_comp_from_map_or_new(rendering_options, srcset_opts, canvas);
    const IMG_tag = image_options.src?.startsWith("data:") || !sourceset_component ? "img" : sourceset_component;
    return (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
        style: "position:relative",
        children: [
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "depict-img-cont",
                children: (0, $63cbb5de51d11596$export$34b9dba7ce09269b)(IMG_tag, {
                    alt: alt,
                    ...remove_on_error ? {
                        onerror: "this.remove()"
                    } : {},
                    ...image_options,
                    class: (0, $b9b0dba897847b2a$export$22a65337c1b43b1f)([
                        "depict-img-comp",
                        image_options.class,
                        $914971fb43986a16$var$add_nolazy_to_placeholder(rendering_options?.type)
                    ])
                })
            }),
            canvas
        ]
    });
}
function $914971fb43986a16$var$srcset_comp_from_map_or_new(rendering_options, srcset_opts = {}, canvas) {
    let sourceset_component;
    if (typeof rendering_options == "object" && rendering_options) {
        sourceset_component = $914971fb43986a16$var$rendering_options_to_sourceset_component.get(rendering_options)?.deref?.();
        if (!sourceset_component) {
            const cloned_opts = {
                ...srcset_opts
            };
            cloned_opts.what_to_watch = canvas;
            sourceset_component = (0, $45af9e834781a9bc$export$a62825542f1bfcf5)(cloned_opts);
            $914971fb43986a16$var$rendering_options_to_sourceset_component.set(rendering_options, new WeakRef(sourceset_component));
        }
    }
    return sourceset_component;
}


var $b3103e84e0d4371c$exports = {};
$b3103e84e0d4371c$exports = ".depict .images-container {\n  position: relative;\n}\n\n.depict .second-image-container {\n  width: 100%;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n}\n\n.depict .hovering .main-image-container {\n  opacity: 0;\n}\n\n.depict .hovering .second-image-container {\n  opacity: 1;\n}\n\n";






// Saving bytez
// Maybe? @Daniel
const $8483d1d9fcee52ec$var$TOUCHSTART = "touchstart";
const $8483d1d9fcee52ec$var$TOUCHEND = "touchend";
const $8483d1d9fcee52ec$var$TOUCHMOVE = "touchmove";
const $8483d1d9fcee52ec$var$TOUCHCANCEL = "touchcancel";
const $8483d1d9fcee52ec$var$MOUSEOVER = "mouseover";
const $8483d1d9fcee52ec$var$MOUSELEAVE = "mouseleave";
const $8483d1d9fcee52ec$var$HOVER_CLASS = "hovering";
/** This number represents how many elements are in front of div.images-container
 *  Here are the elements: img.depict-img-mod, div, img.depict-img-mod, div, div.second-image-container, div.main-image-container, div.images-container
 * This number is not very dynamic but much more performant than iterating
 */ const $8483d1d9fcee52ec$var$HOVER_IMAGE_DEPTH = 7;
const $8483d1d9fcee52ec$var$MAX_COLLISION_DETECTION_RATE = 70; // ms
const $8483d1d9fcee52ec$var$touch_hover_elements = /*@__PURE__*/ new WeakMap();
let $8483d1d9fcee52ec$var$listening_for_mobile_hover = false;
function $8483d1d9fcee52ec$var$register_element_for_touch_hover(el, navigation_minimum) {
    $8483d1d9fcee52ec$var$touch_hover_elements.set(el, {
        navigation_minimum: navigation_minimum
    });
    if (!$8483d1d9fcee52ec$var$listening_for_mobile_hover) {
        $8483d1d9fcee52ec$var$start_checking_for_touch_hover();
        $8483d1d9fcee52ec$var$listening_for_mobile_hover = true;
    }
}
function $8483d1d9fcee52ec$var$start_checking_for_touch_hover() {
    const currently_hovering = new Map();
    const handle_touch_start = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((evt)=>{
        const touch = evt.changedTouches[0];
        const id = touch.identifier;
        const { clientX: clientX , clientY: clientY  } = touch;
        const hover_element = get_hover_element_from_coords(clientX, clientY);
        if (hover_element && $8483d1d9fcee52ec$var$touch_hover_elements.has(hover_element)) {
            hover_element.classList.add($8483d1d9fcee52ec$var$HOVER_CLASS);
            $8483d1d9fcee52ec$var$touch_hover_elements.set(hover_element, {
                navigation_minimum: $8483d1d9fcee52ec$var$touch_hover_elements.get(hover_element)?.navigation_minimum
            });
            currently_hovering.set(id, {
                element_: hover_element,
                start_time_: +new Date(),
                start_x_: clientX,
                start_y_: clientY
            });
        }
    });
    let last_collision_check = +new Date();
    const handle_touch_move = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((evt)=>{
        const { identifier: identifier , clientY: clientY , clientX: clientX  } = evt.changedTouches[0];
        const our_touch_data = currently_hovering.get(identifier);
        if (!our_touch_data) return;
        if (+new Date() - last_collision_check > $8483d1d9fcee52ec$var$MAX_COLLISION_DETECTION_RATE) {
            last_collision_check = +new Date();
            // Checking if the finger has left the image
            if (get_hover_element_from_coords(clientX, clientY) !== our_touch_data.element_) clear_hover(identifier, our_touch_data, clientX, clientY);
        }
    });
    const handle_touch_cancel = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((evt)=>{
        const touch = evt.changedTouches[0];
        const id = touch.identifier;
        const info = currently_hovering.get(id);
        if (info) clear_hover(id, info, touch.clientX, touch.clientY);
    });
    const get_hover_element_from_coords = (clientX, clientY)=>{
        const elements = document.elementsFromPoint(clientX, clientY);
        const hover_element = elements[$8483d1d9fcee52ec$var$HOVER_IMAGE_DEPTH - 1];
        return hover_element && $8483d1d9fcee52ec$var$touch_hover_elements.has(hover_element) ? hover_element : null;
    };
    const clear_hover = (0, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9)((id, info_about_touch, now_x, now_y)=>{
        const { element_: element_ , start_y_: start_y_ , start_x_: start_x_ , start_time_: start_time_  } = info_about_touch;
        const info = $8483d1d9fcee52ec$var$touch_hover_elements.get(element_);
        const now = +new Date();
        remove_hover_class: {
            emulate_click: {
                if (!info?.navigation_minimum) break emulate_click;
                const time_touched = now - start_time_;
                if (time_touched >= info.navigation_minimum) break emulate_click;
                // Just above checks led to oversensitive clicks, where a quick swipe in a slider led to product cards being clicked.
                // We're trying to avoid this by not clicking if the mouse moved much or fast
                // We're doing this whole click emulation because MobileSafari doesn't dispatch click events if we listen for touchmove (I *think* it's "move" specifically) so we basically have to emulate clicking heuristics
                // It seems like MobileSafari has a curve based on movement and speed that decides if something counts as a click, but we'll start with something more rudimentary
                const distance_travelled = Math.sqrt(Math.pow(start_x_ - now_x, 2) + Math.pow(start_y_ - now_y, 2)); // https://www.varsitytutors.com/calculus_3-help/distance-between-vectors
                // educated guess that moving the finger 20px will cancel the click regardless
                if (distance_travelled > 20) break emulate_click;
                const swipe_speed = distance_travelled / time_touched; // pixels per millisecond
                if (swipe_speed > 0.2) break emulate_click; // after some testing it feels like a faster swipe than 0.2px/ms would get cancelled by the OS so we cancel that too
                element_.closest("a")?.click();
                break remove_hover_class; //we don’t want to see a quick flash of hover if we’re navigating since that looks bad
            }
            element_.classList.remove($8483d1d9fcee52ec$var$HOVER_CLASS);
        }
        currently_hovering.delete(id);
    });
    window.addEventListener($8483d1d9fcee52ec$var$TOUCHSTART, handle_touch_start);
    window.addEventListener($8483d1d9fcee52ec$var$TOUCHMOVE, handle_touch_move);
    window.addEventListener($8483d1d9fcee52ec$var$TOUCHEND, handle_touch_cancel);
    window.addEventListener($8483d1d9fcee52ec$var$TOUCHCANCEL, handle_touch_cancel);
}
let $8483d1d9fcee52ec$var$styling_inserted = false;
const $8483d1d9fcee52ec$export$2369f6fc1c911576 = ({ second_src: second_src , second_srcset: second_srcset , second_srcset_opts: second_srcset_opts , fade_length_seconds: fade_length_seconds , mobile_touch_hover: mobile_touch_hover , navigation_minimum_ms: navigation_minimum_ms = 100 , ...options })=>{
    if (!$8483d1d9fcee52ec$var$styling_inserted) {
        (0, $0a581f1dfa083522$export$59ba1eb2c083f0cd)((0, (/*@__PURE__*/$parcel$interopDefault($b3103e84e0d4371c$exports))));
        $8483d1d9fcee52ec$var$styling_inserted = true;
    }
    const main_image = (0, $914971fb43986a16$export$788756b42446dc2d)({
        ...options
    });
    const second_image = (0, $914971fb43986a16$export$788756b42446dc2d)({
        ...options,
        [second_srcset_opts?.set_dataset === false ? "src" : "data-src"]: second_src || "",
        [second_srcset_opts?.set_dataset === false ? "srcset" : "data-srcset"]: second_srcset || "",
        srcset_opts: second_srcset_opts || {}
    });
    const no_second_img = !second_src && !second_srcset && !second_srcset_opts;
    const images_container = (0, $63cbb5de51d11596$export$25062201e9e25d76)("div", {
        class: "images-container",
        children: [
            !no_second_img && (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "second-image-container",
                children: second_image
            }),
            (0, $63cbb5de51d11596$export$34b9dba7ce09269b)("div", {
                class: "main-image-container",
                children: main_image
            })
        ]
    });
    if (no_second_img) return images_container;
    const hover_element = images_container;
    const event_handler_mouse = ({ type: type  })=>{
        if (type == $8483d1d9fcee52ec$var$MOUSEOVER) {
            images_container.classList.add($8483d1d9fcee52ec$var$HOVER_CLASS);
            hover_element.addEventListener($8483d1d9fcee52ec$var$MOUSELEAVE, event_handler_mouse, {
                once: true
            });
        } else if (type == $8483d1d9fcee52ec$var$MOUSELEAVE) images_container.classList.remove($8483d1d9fcee52ec$var$HOVER_CLASS);
    };
    hover_element.addEventListener($8483d1d9fcee52ec$var$MOUSEOVER, event_handler_mouse);
    if (mobile_touch_hover) $8483d1d9fcee52ec$var$register_element_for_touch_hover(hover_element, navigation_minimum_ms);
    if (fade_length_seconds) Array.from(images_container.children).forEach((container)=>{
        container.style.transition = `opacity ${fade_length_seconds}s`;
    });
    return images_container;
};






/**
 * Shallowly converts all keys in an object from snake_case to camelCase.
 * Does not support symbol keys.
 *
 * @param obj the object. It will be cloned and not modified in-place.
 */ function $4d49697a7a9a77a6$export$9dc8f3a0aa3efc85(obj) {
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>[
            key.split("_").map((part, index)=>index ? part[0].toUpperCase() + part.slice(1) : part).join(""),
            value
        ]));
}
function $4d49697a7a9a77a6$export$b481488de1caa85(obj) {
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>[
            key.replace(/[A-Z]/g, (match)=>"_" + match.toLowerCase()),
            value
        ]));
}


/**
 * Converts RGB to HSL
 * Source of function: https://www.30secondsofcode.org/js/s/rgb-to-hsl
 */ function $b828952b0fe1df8f$export$499ef00a6a3417f8(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const l = Math.max(r, g, b);
    const s = l - Math.min(r, g, b);
    const h = s ? l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s : 0;
    return [
        60 * h < 0 ? 60 * h + 360 : 60 * h,
        100 * (s ? l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s)) : 0),
        100 * (2 * l - s) / 2
    ];
}
function $b828952b0fe1df8f$export$e4fd3b61e79357a7(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $b828952b0fe1df8f$export$486b165479b9284f(h, s, b) {
    s /= 100;
    b /= 100;
    const k = (n)=>(n + h / 60) % 6;
    const f = (n)=>b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
    return [
        255 * f(5),
        255 * f(3),
        255 * f(1)
    ];
}
function $b828952b0fe1df8f$export$98c2b3491e76c1f(R8bit, G8bit, B8bit) {
    // from from http://www.w3.org/TR/WCAG20/#relativeluminancedef
    const RsRGB = R8bit / 255;
    const GsRGB = G8bit / 255;
    const BsRGB = B8bit / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}


(0, $f564adbc4675ceaf$export$2cefb7e61fcbae00)("utilishared", (0, $0766c85d387a9765$export$83d89fbfd8236492));


export {$5ea3131c5e08d52e$export$a7e53ec3b3fdd030 as base64_decode_unicode, $5ea3131c5e08d52e$export$a1893782a2a6be0d as base64_encode_unicode, $f809bc98a1cb5f92$export$6f051469dd676a8b as make_plp_recommendations_inserted_handler, $f564adbc4675ceaf$export$60d1d0e3cfc8b9ed as version_info, $f564adbc4675ceaf$export$fe609f0216e4ebef as add_version_query_params, $a1c80794e6bf4cc2$export$6e7454c733fa1fb2 as cache_args, $66b898e9bfcef532$export$8582cf3716962dc2 as check_displays, $7547e32486a3abc0$export$8048b892d651b310 as err, $b55a70757989faf4$export$16d7c76794a38a4 as require_event_listener, $ea554f5a28904975$export$41de2959a8dd405d as Auto_GWVM, $f1396aa84761fbe5$export$c83d8da642b5104a as GWVM_Renderer, $92b7ea2cf75c4aec$export$55621c1ce3cd536b as infinite_promise_creator, $09ff985c7c424fb3$export$32ccf3a614c84258 as infinite_promise_no_skip, $075589a94064cf2e$export$c0a4d29bc45a38c6 as infinite_renderer, $efda45906c6cbac7$export$9eae832ae57fbf as deprecated_insert_styling, $a40013fcba50c9ee$export$47340c0b196bc0f8 as get_market_locale, $a40013fcba50c9ee$export$c5b68ecd5c37aa6c as get_market_currency, $a40013fcba50c9ee$export$6eea148df5c7117c as MARKET_MAP, $e867e2f1fb3bcc09$export$c7187bbd1a7a9244 as placeholder, $7e2d59b061c2c528$export$cab8bc58c64c2013 as Pro_Slider, $51bbc74e39f5e5c6$export$2e2bcd8739ae039 as simplified_template_tool, $762a881271a51d1b$export$f1b8b9fd75ddcab1 as insert_styling_into_slider, $e61f371a9bcdeb2f$export$cd12721587f4f16d as RR_Slider, $366fff12da348e66$export$1a8782481a9af507 as Depict, $f494377581cfb2b4$export$30933c637c977eef as get_recs_with_template, $f494377581cfb2b4$export$c410ce1205e5118a as default_post_processor, $f494377581cfb2b4$export$4f39078bdc72ecd0 as default_pre_processor, $acf11540344875ed$export$2e2bcd8739ae039 as wpff, $cdca9fea6eb103e5$export$12e07a2a9f87578a as ElementObserver, $0b48ba2f40ce6067$export$b6ae1bc530f4c149 as observer, $63cbb5de51d11596$export$34b9dba7ce09269b as jsx, $63cbb5de51d11596$export$25062201e9e25d76 as jsxs, $b9b0dba897847b2a$export$eb0b9ed911409b57 as use_element, $b9b0dba897847b2a$export$f63fcc839cb0f734 as use_listener, $b9b0dba897847b2a$export$22a65337c1b43b1f as classlist, $649f456f663da9fc$export$de56f1198d121036 as dlog, $649f456f663da9fc$export$997143d41f6a0c9b as derror, $649f456f663da9fc$export$c2363754d4758444 as dwarn, $649f456f663da9fc$export$2dd75a6b038dc8cb as set_browser_prefix, $b04e44fad5ea42c7$export$b3bbfd758f11cfa9 as catchify, $b04e44fad5ea42c7$export$f18d5b0af29128b7 as report, $571bce04eb920cd8$export$55fe61489d2c7417 as is_debug, $ca66c9553e84df02$export$6038895ac52bd044 as chevronLeft, $ca66c9553e84df02$export$dc84183312f0c201 as chevronRight, $9a744f57ab06c32e$export$68c017fd93791405 as expandingContainer, $b83068cbd26dcc41$export$3be7054c61590ee3 as Lazyfier, $b83068cbd26dcc41$export$b87d7e0da8b5cbe3 as test_array_proxy_support, $ef9394fafebd5eab$export$692b27c28639e5b9 as Amazing_Slider, $893f9af5dbae6bc8$export$16501883f477737a as colorize_elements, $893f9af5dbae6bc8$export$deca40f48c0569f8 as should_colorizeLogics, $6be99244fa573db5$export$50ce83ace0cdd87e as default_rr, $2d47b009af5bc0a4$export$1bc0df10745d5412 as fetch_recs, $2d47b009af5bc0a4$export$d40679eb4cf32f09 as fetch_recs_whole_response, $5cbe24d064a033ed$export$c42139a43c877ecd as clone_deep, $5cbe24d064a033ed$export$e0009e7da572f99b as regex_templating, $5cbe24d064a033ed$export$a9fc160c5ed83bd7 as Rec_Renderer, $30e801eaa3dc319e$export$17c3166a7ebd4688 as n_col_styling_with_dist, $30e801eaa3dc319e$export$c84671f46d6a1ca as Layout, $090b8182afa1b2a6$export$b0a773486c1c2312 as RecommendationGrid, $30f78542ed78cd31$export$82cfdc85a4d15688 as RecommendationSlider, $c1503704e45e6a15$export$6830ae1fbe21e589 as default_click_tracking, $c1503704e45e6a15$export$f37c58ab3d3e3b75 as default_view_tracking, $c1503704e45e6a15$export$dd32cb565eae0a1f as ga_click, $c1503704e45e6a15$export$8d72437623fef90c as gtag_click_post_processor, $c1503704e45e6a15$export$1bffac19f9f0d6fc as gtag_view_post_processor, $c1503704e45e6a15$export$e9106d6e723510d2 as depict_click_tracking_post_processor, $c1503704e45e6a15$export$fb9afe9f540ae069 as recs_inserted_tracking, $c1503704e45e6a15$export$32eb5dd18e963410 as add_to_localstorage, $c1503704e45e6a15$export$9e1caada6901f552 as depict_page_view, $be40b7bf11a47cc4$export$8cbd8aa1c70f9a13 as slider_autoscroll_factory, $d31b48b85102c1ec$export$80039a49055269fb as make_button1, $a75adf1478c4522f$export$af88b4929c2dc86 as make_button2, $2436f68ea927d4a8$export$1d17a045bcc711b1 as slider_dots_factory, $2436f68ea927d4a8$export$a09282b33e69b43f as navdot, $9bb2400c4e2e9335$export$411b0f20794697ce as slider_draggable_factory, $1ce2ae6f640f393f$export$5129719c04a52f8c as slider_fading_factory, $52292921bc0fc31f$export$5723caf9a8335aa6 as slider_fractional_factory, $f78bc6a06402a6cf$export$93223e488e7ee078 as slider_show_scroll, $06fe260f91efff62$export$b36d2489a5a16728 as slider_snap_css, $06fe260f91efff62$export$49b950309ab787ad as can_use_snapping_and_still_scroll, $40bfd400d76a6ec1$export$dac64fd35a4805a4 as slider_snapping_factory, $c33c6faf8acc7442$export$68babfc5be0de5da as Amazing_Lazy_Slider, $556d9c321900f1d4$export$53306504b987cbf7 as slider_wraparound_factory, $159237486410355f$export$419f84efad7d9fe as sizes_to_surface, $159237486410355f$export$417ef0ab13d8b984 as surface_mixer, $159237486410355f$export$be95cb0e8cfd099e as promise_until_next_navigation, $d4ffde0b9fca0369$export$29a6094e0bd8bc5f as AIO, $d4ffde0b9fca0369$export$6ebd242c09192cec as paint_red, $91b2e49f92ed636c$export$2c34560c3749dc63 as bind_to_a2c_button, $91b2e49f92ed636c$export$82a685f2da2fb027 as bind_tracking_to_link, $43683b1103edab15$export$336e7ad40bae0652 as set_depict_id_fn, $43683b1103edab15$export$8a96793bf9f87d90 as set_user_id_fn, $43683b1103edab15$export$6399bdb2291895e0 as get_depict_id, $43683b1103edab15$export$adc61a405a4cabed as get_user_id, $43683b1103edab15$export$15f8a0cd5a8c0ebb as depict_click, $43683b1103edab15$export$82badda1f9923310 as depict_prefilled, $43683b1103edab15$export$9028351cb994757e as depict_add_to_cart, $43683b1103edab15$export$93ae15b1ae509334 as set_session_id_fn, $43683b1103edab15$export$61e7e1f11e96692f as get_session_id, $43683b1103edab15$export$622991c71a1f52b3 as get_cookie, $43683b1103edab15$export$8c6f26a5b6921b95 as get_tracking_event_context_data, $cafa1ff1049985c2$export$72036d950e1fae95 as filter_depict_payload, $cafa1ff1049985c2$export$28cacbd9b4306ffc as send_depict, $cafa1ff1049985c2$export$cc3b6ddf805f6156 as foolproof_send_beacon, $cafa1ff1049985c2$export$608478473a3304a0 as send_depict_unfiltered, $cafa1ff1049985c2$export$aa26019042811d4f as send_websocket, $42bbbba8196bd057$export$674d8cd8b6868154 as create_ga_queue, $42bbbba8196bd057$export$edfedd0557ca5a2d as make_tracker_send_to_depict, $3abef00489070e23$export$1ff14fec60ed5697 as ga_to_transaction_api, $c749fe63b72056ef$export$f75172d2e289cd02 as send_ga, $c749fe63b72056ef$export$ac7296527cb52311 as setup_ga, $c749fe63b72056ef$export$d031e55ccd4c52dc as setup_gtag, $c749fe63b72056ef$export$f522672c9379e339 as gtag_click, $c749fe63b72056ef$export$bf205937e5e012cb as ga_purchase_click, $c749fe63b72056ef$export$127751e82111fcf as ga_rec_click, $c749fe63b72056ef$export$7babcd5d4056b2ca as gtag_view, $c749fe63b72056ef$export$f3354ec2ce95ebd9 as load_gtag, $ccf918da074d7243$export$4205dc6835bc0d9f as send_impression_event, $21285393646b9849$export$37125ccc5dd98050 as impression_track_element, $405969d60b37fdac$export$d0efd8ed14f5c33 as impression_tracking_post_processor, $ccf918da074d7243$export$c543ee4cdb0d0964 as set_impression_threshold, $ccf918da074d7243$export$135da44d0ba958bc as impression_threshold, $ccf918da074d7243$export$ca8321ea61dc2544 as has_to_be_intersecting_for, $61b3c9e5f2cf8171$export$58c56fe2313fdbe3 as add_new_tab_listener, $61b3c9e5f2cf8171$export$836f70a28c317905 as broadcast_product_id, $61b3c9e5f2cf8171$export$8f66c4c7fb96eda2 as contextmenu_callback, $5dbacdc6a3feeb15$export$7e4427e80d5fc619 as optanon_get_cookie_ipns, $5dbacdc6a3feeb15$export$f0f6c846d96fdbec as init_optanon_tracking, $5dbacdc6a3feeb15$export$1dd9ce50e201eff1 as optanon_get_consent, $5dbacdc6a3feeb15$export$7a6d436e0782c6ed as optanon_wait_for_consent, $847e4a06ea6767c0$export$1ac466d53a6636ac as send_transaction_id_to_depict, $847e4a06ea6767c0$export$b11248fa13a8a86c as datalayer_transaction_id_extractor, $847e4a06ea6767c0$export$3ebd86018b39d9d2 as orderpage_transaction_id_extractor, $847e4a06ea6767c0$export$ff8673d5dea82bd4 as url_transaction_id_extractor, $54793663e06a1437$export$d63b08f4f29ddba5 as send_product_unavailable_to_depict, $aa0140679dc70b7a$export$eee4c4d924348b05 as send_page_view_if_needed, $aa0140679dc70b7a$export$f7cb1bd47199ec38 as send_page_view_on_navigation, $4ce764ddfee055ef$export$1d9c6fddbff3441f as DepictAPIWS, $2030306bed68a8c7$export$74108888f38788f3 as ListenableSet, $511123bb28a7b6f7$export$535946eb77c946dd as deparallelize, $511123bb28a7b6f7$export$f241be8e610f5c77 as deparallelize_no_drop, $9ab9ecb74920f343$export$f8ea2e7b15b5d129 as buildThresholdList, $1ce9aeebfbcb93f9$export$d9fdc6ce2907f95b as chaotic_closest, $0bdb8dbcf1bc7f34$export$cfef5d5c9ac09253 as standard_price_format, $0bdb8dbcf1bc7f34$export$9590700a594aef08 as ensure_object_path, $0bdb8dbcf1bc7f34$export$925772df9b4d16e5 as ensure_parameter_in_url, $0bdb8dbcf1bc7f34$export$44951404cb8d0583 as html2elems, $0bdb8dbcf1bc7f34$export$d3e2a0560cbf4787 as html2elem, $0bdb8dbcf1bc7f34$export$5e63aea0cac01fa0 as querySelectorAllElements, $0bdb8dbcf1bc7f34$export$785f04709990c4ec as querySelectorUpwards, $0bdb8dbcf1bc7f34$export$f124e3ee16e6b45d as intl_number_format_with_fallback, $0bdb8dbcf1bc7f34$export$d4bd03f19260ef1c as relativify, $d832040ef2097a0e$export$6b75200e58bc97d0 as deduplicate, $d832040ef2097a0e$export$9426572bd5645bc1 as dedup_products, $ead1f6ae93c69da9$export$82539d9817116aff as navigate_with_next_router, $802201ed0a316c43$export$774bc87373c4fc6c as add_item, $802201ed0a316c43$export$337197b94b3bd680 as get_items_in_cart, $802201ed0a316c43$export$783ef16647773b3d as get_shopify_analytics_meta_product, $802201ed0a316c43$export$ab0f802c05dd969b as intercept, $b6f5b218b1a73900$export$85be83e1935d93c2 as fetch_replacer, $b6f5b218b1a73900$export$f8da66bc4f1d059e as FakeResponse, $2d1ffbfaa1c2d9e3$export$bcd70d5ed1cf6313 as fetch_retry, $1813f33dd0fc7e1d$export$b404e20f3c4a490e as get_optimize_variant, $0d2acf276472ebf7$export$20e9533e68ee72e7 as stateless_href_change_ipns, $0d2acf276472ebf7$export$a9d39e43ae273d26 as href_change_ipns, $0d2acf276472ebf7$export$baccefee4a395d8f as history_replacer, $0d2acf276472ebf7$export$1cd22bab0d2c3b0b as on_next_navigation, $0d2acf276472ebf7$export$7500cdfd37aafd43 as instant_exec_on_suspect_history_change, $607fc90221d440a6$export$e806c6c1615a59ae as async_iterable_ipns, $607fc90221d440a6$export$10c3e52ef388b81b as make_ipns_stateful, $607fc90221d440a6$export$90740b5bc9c2b3b7 as make_ipns_stateless, $ec58be30798d6e95$export$3e42f5078e3abfc0 as make_simple_async_iterable, $ec58be30798d6e95$export$e2c811ae0eb35313 as RawObservableInformation, $4f24151f2cddad7b$export$2c2f50b30b7b2576 as iterable_to_attribute, $8c97019b5f7b0d0e$export$7c081fdbc65b6a2a as iterable_to_elems, $b8270fcf290bb3af$export$927664b47117acb0 as make_asyncIterable_exiter, $693e2a1517bef984$export$f8913c8a18f7ca21 as zip_async_iterables, $8bed543774ca0dd4$export$f811d2ce0aa6019b as insert_surfaces, $8bed543774ca0dd4$export$b8d1e1d07a3f3776 as prevent_infinite_loop, $8bed543774ca0dd4$export$e3f70ef7e3d00501 as revertable_remove, $0a581f1dfa083522$export$59ba1eb2c083f0cd as insert_styling, $0a581f1dfa083522$export$692b606677218a16 as depict_init, $0a581f1dfa083522$export$328e81c44cddf3c0 as depict_init_with_market_logic, $0a581f1dfa083522$export$a4f97b27a0592e6c as normal_get_product_id, $0a581f1dfa083522$export$a96c18473f2af463 as track_a2c, $29407d8301dc2f23$export$515c3ea4d599b05a as javascript_media_query, $39ef887981612535$export$33f937d741e49339 as patched_querySelectorAll, $78270f2ea7ca229f$export$a4eccf92efefa04d as placeholder_svg, $78270f2ea7ca229f$export$2dd69958012e3e49 as make_placeholder_rr, $78270f2ea7ca229f$export$3b75288f46cadd96 as random_text_placeholder, $bb3252f70898acd6$export$947a20746936143d as Promise_Any, $9e268c1aeeb86b34$export$c50e1901e8ed0615 as queueMacroTask, $d89638655e64f324$export$bb0a9c36cf454ea0 as rand, $460df8550f9d084d$export$656831b7e9c341c3 as random_string, $460df8550f9d084d$export$a6db784f019668ba as make_random_classname, $49c4fa2e27e642fa$export$3d04c40e7acc1a32 as reactive_template, $a79c7168700020ff$export$8ec5c86406f333ff as removeChild_error_swallowing_factory, $1dd4146ad893cfb2$export$38e89c688f9d553a as replace_promise_with_native_if_exists_and_enforce, $1dd4146ad893cfb2$export$e647444ed9403635 as get_iframe_promise, $bbb9f33eb5feb86a$export$2a1cc61cffa1f36f as rp_relativify_fetch, $bbb9f33eb5feb86a$export$f14a775632a826c4 as rp_relativify_history, $bbb9f33eb5feb86a$export$2a38b176ce969e2c as rp_relativify_xhr, $bbb9f33eb5feb86a$export$83ec13b10b391f13 as default_rp_fixes, $5c4afc453f904a1f$export$39d526a1194b6499 as serialize_object, $8d4dfadc5e12c7fb$export$12b4c6cbc6b8b4e4 as sort_obj, $eda086e0899e75b0$export$a422d714c8cb1a5d as standard_get_market, $e72f2f1d48dc3a53$export$3427ec8268623f1 as listenToLocalStorage, $26eaaddf434c84f1$export$8d42ce4827f43582 as Tenant, $55698e6e298abcb0$export$cd1adfb8059b5fcd as timeout_promise, $d0e7629fb3179e02$export$79f910a98828378d as variable_setter_to_ipns, $d0e7629fb3179e02$export$d5062f468a0454f3 as find_descriptor, $d0e7629fb3179e02$export$2fc1a072736ae2f6 as is_available_in, $690d8897acf7a743$export$a739d9a07da7f9ce as use_voyado_id, $2cbe7e0ca2ce5438$export$5c069c93d2b7493f as wait, $4a6ab5f7377729b1$export$f314addd5f976083 as xhr_load, $4a6ab5f7377729b1$export$8e16c51fd2b6507 as xhr_read_interceptor, $4a6ab5f7377729b1$export$c74578d2cd47a84a as xhr_send_interceptor, $4a6ab5f7377729b1$export$33d1643df63073a8 as xhr_replace, $769ce417b39aa7d3$export$4a3043e508dd72f0 as DefaultViewMoreButton, $cf7ca80454d7b4c0$export$8a0e4d6f6abf7e90 as GeneralSideSlidein, $72d170fd5c7cb3fe$export$c068ad5361be7646 as GeneralSizeSelector, $ad592d9ddbcffe72$export$84712d0562a614b8 as Placeholder, $ad592d9ddbcffe72$export$d613f5b6d0a331a8 as ContainedPlaceholderImage, $fbe64cf2cf408e4f$export$97f31f44c68c1d5 as RecommendationContainer, $7693290d077384da$export$ddd70fdae1b350e6 as LeftChevron, $7693290d077384da$export$32a55d57d151bc5a as RightChevron, $6f1582c15e13f2f0$export$590326cc34f49e2d as createColorPicker, $7f57d546b5d5b3d6$export$237455ad7e59d4e5 as useExpandingContainer, $8483d1d9fcee52ec$export$2369f6fc1c911576 as ContainedHoverImage, $914971fb43986a16$export$788756b42446dc2d as ContainedImage, $45af9e834781a9bc$export$f39a7d0667e924a as make_sizes_setter, $45af9e834781a9bc$export$a62825542f1bfcf5 as make_sourceset_component, $45af9e834781a9bc$export$a98fc8a2c818d3d8 as is_safari, $45af9e834781a9bc$export$f7c915448031deac as make_url_with_query_params, $45af9e834781a9bc$export$3d13beba9b52c947 as resize_base_url, $6c2b49f3f564b0d1$export$362abebb4b313340 as base_url, $eba382943196079c$export$af2e17a20c2ea3c5 as Sentry, $4d49697a7a9a77a6$export$9dc8f3a0aa3efc85 as camelCasifyObject, $4d49697a7a9a77a6$export$b481488de1caa85 as snakeCasifyObject, $b828952b0fe1df8f$export$499ef00a6a3417f8 as rgb_to_hsl, $b828952b0fe1df8f$export$e4fd3b61e79357a7 as hsl_to_rgb, $b828952b0fe1df8f$export$98c2b3491e76c1f as relative_luminance_from_rgb, $b828952b0fe1df8f$export$486b165479b9284f as hsb_to_rgb, $0766c85d387a9765$export$83d89fbfd8236492 as version, $f564adbc4675ceaf$export$2cefb7e61fcbae00 as add_to_version_info, $155540b3b8aca771$export$fce59460a1699957 as cookiebot_get_consent, $155540b3b8aca771$export$56c2e8be65fb14ae as cookiebot_wait_for_consent, $155540b3b8aca771$export$8827362e5e938d26 as cookiebot_get_cookie_ipns, $155540b3b8aca771$export$abec7fd9f0b9cc22 as init_cookiebot_tracking};
